/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
import { __decorate, __param, __metadata } from 'tslib';
import { Inject, Optional, Input, ViewChild, ElementRef, Component, Injectable, EventEmitter, isDevMode, Output, HostBinding, ContentChild, ViewContainerRef, forwardRef, ChangeDetectorRef, NgZone, TemplateRef, Host, Directive, NgModule } from '@angular/core';
import { FormControl, Validators, FormGroup, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, BehaviorSubject, zip, fromEvent, merge, interval } from 'rxjs';
import { take, filter, auditTime, map, concatMap, takeUntil } from 'rxjs/operators';
import { ToolBarComponent, ToolBarToolComponent, ToolBarButtonComponent, ToolBarModule } from '@progress/kendo-angular-toolbar';
import { DialogContentBase, DialogRef, DialogService, DialogModule } from '@progress/kendo-angular-dialog';
import { isDocumentAvailable, guid, KendoInput, Keys } from '@progress/kendo-angular-common';
import { nodes, Schema, marks, Selection, SelectionRange, TextSelection, Fragment, Slice, NodeSelection, insertNode, expandToWordWrap, toggleInlineFormat, bold, cleanFormatting, applyLink, applyInlineStyle, insertText, italic, strikethrough, subscript, superscript, underline, removeLink, link, selectAll, isAligned, alignCenterRules, alignBlocks, alignRemoveRules, alignJustifyRules, alignLeftRules, alignRightRules, formatBlockElements, getHtml, indent, insertImage, toggleOrderedList, toggleUnorderedList, outdent, redo, setHtml, undo, hasMark, activeNode, canIndentAsListItem, canBeIndented, indentRules, hasNode, canOutdentAsListItem, outdentRules, getActiveMarks, expandSelection, addColumnBefore, addColumnAfter, addRowBefore, addRowAfter, deleteRow, deleteColumn, mergeCells, splitCell, deleteTable, getNodeFromSelection, getMark, getSelectionText, parseContent, Plugin, PluginKey, history, keymap, buildListKeymap, buildKeymap, baseKeymap, gapCursor, imageResizing, placeholder, EditorState, EditorView, hasSameMarkup, pasteCleanup, removeComments, sanitize, removeAttribute, sanitizeStyleAttr, sanitizeClassAttr } from '@progress/kendo-editor-common';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@progress/kendo-angular-dialog';
import * as ɵngcc2 from '@progress/kendo-angular-buttons';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@progress/kendo-angular-l10n';
import * as ɵngcc6 from '@progress/kendo-angular-toolbar';
import * as ɵngcc7 from '@progress/kendo-angular-dropdowns';
import * as ɵngcc8 from '@progress/kendo-angular-inputs';
import * as ɵngcc9 from '@progress/kendo-angular-popup';

const _c0 = ["textarea"];
const _c1 = ["srcInput"];
const _c2 = ["hrefInput"];
function FileLinkDialogComponent_ng_container_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵelement(3, "input", 17);
    ɵngcc0.ɵɵelementStart(4, "label", 18);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.textForWithPrefix("OpenInNewWindow"));
} }
const _c3 = ["dialogsContainer"];
const _c4 = ["content"];
const _c5 = ["defaultToolbar"];
function EditorComponent_kendo_toolbar_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "kendo-toolbar", 4, 5)(2, "kendo-toolbar-buttongroup");
    ɵngcc0.ɵɵelement(3, "kendo-toolbar-button", 6)(4, "kendo-toolbar-button", 7)(5, "kendo-toolbar-button", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "kendo-toolbar-dropdownlist", 9);
    ɵngcc0.ɵɵelementStart(7, "kendo-toolbar-buttongroup");
    ɵngcc0.ɵɵelement(8, "kendo-toolbar-button", 10)(9, "kendo-toolbar-button", 11)(10, "kendo-toolbar-button", 12)(11, "kendo-toolbar-button", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "kendo-toolbar-buttongroup");
    ɵngcc0.ɵɵelement(13, "kendo-toolbar-button", 14)(14, "kendo-toolbar-button", 15)(15, "kendo-toolbar-button", 16)(16, "kendo-toolbar-button", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "kendo-toolbar-buttongroup");
    ɵngcc0.ɵɵelement(18, "kendo-toolbar-button", 18)(19, "kendo-toolbar-button", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(20, "kendo-toolbar-button", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("overflow", true)("tabindex", ctx_r0.readonly ? -1 : 0);
} }
function EditorComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 21, 22);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("dir", ctx_r1.direction);
} }
function EditorComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21)(1, "iframe", 23, 22);
    ɵngcc0.ɵɵlistener("load", function EditorComponent_div_4_Template_iframe_load_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.iframeOnLoad(); });
    ɵngcc0.ɵɵelementEnd()();
} }
const _c110 = [[["kendo-toolbar"]]];
const _c111 = ["kendo-toolbar"];
const _c112 = ["element"];
function FormatDropDownListComponent_ng_template_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataItem_r2.text, " ");
} }
function FormatDropDownListComponent_ng_template_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataItem_r2.text, " ");
} }
function FormatDropDownListComponent_ng_template_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataItem_r2.text, " ");
} }
function FormatDropDownListComponent_ng_template_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataItem_r2.text, " ");
} }
function FormatDropDownListComponent_ng_template_2_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataItem_r2.text, " ");
} }
function FormatDropDownListComponent_ng_template_2_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataItem_r2.text, " ");
} }
function FormatDropDownListComponent_ng_template_2_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataItem_r2.text, " ");
} }
function FormatDropDownListComponent_ng_template_2_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataItem_r2.text, " ");
} }
function FormatDropDownListComponent_ng_template_2_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(dataItem_r2.text);
} }
function FormatDropDownListComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 3);
    ɵngcc0.ɵɵtemplate(1, FormatDropDownListComponent_ng_template_2_span_1_Template, 2, 1, "span", 4);
    ɵngcc0.ɵɵtemplate(2, FormatDropDownListComponent_ng_template_2_span_2_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵtemplate(3, FormatDropDownListComponent_ng_template_2_span_3_Template, 2, 1, "span", 6);
    ɵngcc0.ɵɵtemplate(4, FormatDropDownListComponent_ng_template_2_span_4_Template, 2, 1, "span", 7);
    ɵngcc0.ɵɵtemplate(5, FormatDropDownListComponent_ng_template_2_span_5_Template, 2, 1, "span", 8);
    ɵngcc0.ɵɵtemplate(6, FormatDropDownListComponent_ng_template_2_span_6_Template, 2, 1, "span", 9);
    ɵngcc0.ɵɵtemplate(7, FormatDropDownListComponent_ng_template_2_span_7_Template, 2, 1, "span", 10);
    ɵngcc0.ɵɵtemplate(8, FormatDropDownListComponent_ng_template_2_span_8_Template, 2, 1, "span", 10);
    ɵngcc0.ɵɵtemplate(9, FormatDropDownListComponent_ng_template_2_span_9_Template, 2, 1, "span", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const dataItem_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngSwitch", dataItem_r2.tag);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "h1");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "h2");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "h3");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "h4");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "h5");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "h6");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "p");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "blockquote");
} }
const _c113 = ["formatDropDownList"];
const _c114 = ["colorpicker"];
const _c115 = function (a0) { return { "font-family": a0 }; };
function FontFamilyDropDownListComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataItem_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(2, _c115, dataItem_r2.fontName));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataItem_r2.text, " ");
} }
const _c116 = ["fontFamilyDropDownList"];
const _c117 = ["toolbarTemplate"];
const _c118 = ["popupTemplate"];
const _c119 = ["formatButton"];
const _c120 = ["kendoEditorFormat", ""];
function EditorFormatComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-editor-format-dropdownlist", 2, 3);
    ɵngcc0.ɵɵlistener("valueChange", function EditorFormatComponent_ng_template_0_Template_kendo_editor_format_dropdownlist_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.value = $event; })("valueChange", function EditorFormatComponent_ng_template_0_Template_kendo_editor_format_dropdownlist_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onValueChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("defaultItem", ctx_r1.defaultItem)("data", ctx_r1.data)("value", ctx_r1.value)("itemDisabled", ctx_r1.itemDisabled)("title", ctx_r1.title)("disabled", ctx_r1.disabled)("tabindex", ctx_r1.tabindex);
} }
function EditorFormatComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4, 5);
    ɵngcc0.ɵɵlistener("click", function EditorFormatComponent_ng_template_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.openDialog(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tabindex", ctx_r3.tabindex)("icon", "apply-format")("disabled", ctx_r3.disabled)("tabindex", ctx_r3.tabindex);
    ɵngcc0.ɵɵattribute("title", ctx_r3.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.title, " ");
} }
const _c121 = ["fontSizeDropDownList"];
const _c122 = ["fontSizeButton"];
const _c123 = ["kendoEditorFontSize", ""];
function EditorFontSizeComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-editor-fontsize-dropdownlist", 2, 3);
    ɵngcc0.ɵɵlistener("valueChange", function EditorFontSizeComponent_ng_template_0_Template_kendo_editor_fontsize_dropdownlist_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.value = $event; })("valueChange", function EditorFontSizeComponent_ng_template_0_Template_kendo_editor_fontsize_dropdownlist_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onValueChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("defaultItem", ctx_r1.defaultItem)("data", ctx_r1.data)("value", ctx_r1.value)("itemDisabled", ctx_r1.itemDisabled)("title", ctx_r1.title)("disabled", ctx_r1.disabled)("tabindex", ctx_r1.tabindex);
} }
function EditorFontSizeComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4, 5);
    ɵngcc0.ɵɵlistener("click", function EditorFontSizeComponent_ng_template_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.openDialog(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", "font-size")("disabled", ctx_r3.disabled)("tabindex", ctx_r3.tabindex);
    ɵngcc0.ɵɵattribute("title", ctx_r3.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.title, " ");
} }
const _c124 = ["fontFamilyButton"];
const _c125 = ["kendoEditorFontFamily", ""];
function EditorFontFamilyComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-editor-fontfamily-dropdownlist", 2, 3);
    ɵngcc0.ɵɵlistener("valueChange", function EditorFontFamilyComponent_ng_template_0_Template_kendo_editor_fontfamily_dropdownlist_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.value = $event; })("valueChange", function EditorFontFamilyComponent_ng_template_0_Template_kendo_editor_fontfamily_dropdownlist_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onValueChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("defaultItem", ctx_r1.defaultItem)("data", ctx_r1.data)("value", ctx_r1.value)("itemDisabled", ctx_r1.itemDisabled)("title", ctx_r1.title)("disabled", ctx_r1.disabled)("tabindex", ctx_r1.tabindex);
} }
function EditorFontFamilyComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4, 5);
    ɵngcc0.ɵɵlistener("click", function EditorFontFamilyComponent_ng_template_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.openDialog(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", "font-family")("disabled", ctx_r3.disabled)("tabindex", ctx_r3.tabindex);
    ɵngcc0.ɵɵattribute("title", ctx_r3.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.title, " ");
} }
const _c126 = ["colorPickerButton"];
function EditorColorPickerComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-colorpicker", 2, 3);
    ɵngcc0.ɵɵlistener("valueChange", function EditorColorPickerComponent_ng_template_0_Template_kendo_colorpicker_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.handleValueChange($event); })("activeColorClick", function EditorColorPickerComponent_ng_template_0_Template_kendo_colorpicker_activeColorClick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.handleActiveColorClick($event); })("open", function EditorColorPickerComponent_ng_template_0_Template_kendo_colorpicker_open_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const _r4 = ɵngcc0.ɵɵreference(1); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onOpen(_r4); })("close", function EditorColorPickerComponent_ng_template_0_Template_kendo_colorpicker_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const _r4 = ɵngcc0.ɵɵreference(1); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onClose(_r4); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("view", ctx_r1.view)("format", "hex")("icon", ctx_r1.icon)("value", ctx_r1.value)("paletteSettings", ctx_r1.paletteSettings)("disabled", ctx_r1.disabled)("tabindex", ctx_r1.tabindex);
    ɵngcc0.ɵɵattribute("title", ctx_r1.title);
} }
function EditorColorPickerComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4, 5);
    ɵngcc0.ɵɵlistener("click", function EditorColorPickerComponent_ng_template_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.openDialog(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", ctx_r3.icon)("disabled", ctx_r3.disabled)("tabindex", ctx_r3.tabindex);
    ɵngcc0.ɵɵattribute("title", ctx_r3.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.title, " ");
} }
const _c127 = ["overflowElement"];
const _c128 = ["popupGridTemplate"];
function EditorInsertTableButtonComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3, 4);
    ɵngcc0.ɵɵlistener("click", function EditorInsertTableButtonComponent_ng_template_0_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.toggle(); })("blur", function EditorInsertTableButtonComponent_ng_template_0_Template_button_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onBlur(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", "table-insert")("disabled", ctx_r1.disabled);
    ɵngcc0.ɵɵattribute("title", ctx_r1.title)("tabindex", ctx_r1.tabIndex);
} }
function EditorInsertTableButtonComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 5, 6);
    ɵngcc0.ɵɵlistener("click", function EditorInsertTableButtonComponent_ng_template_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.openDialog(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", "table-insert")("disabled", ctx_r3.disabled);
    ɵngcc0.ɵɵattribute("title", ctx_r3.title)("tabindex", ctx_r3.tabIndex);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.title, " ");
} }
function EditorInsertTableButtonComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-popup-table-grid", 7);
    ɵngcc0.ɵɵlistener("cellClick", function EditorInsertTableButtonComponent_ng_template_4_Template_kendo_popup_table_grid_cellClick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.onCellClick($event); })("tableWizardClick", function EditorInsertTableButtonComponent_ng_template_4_Template_kendo_popup_table_grid_tableWizardClick_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onTableWizardClick(); });
    ɵngcc0.ɵɵelementEnd();
} }
function PopupTableGridComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵlistener("mouseenter", function PopupTableGridComponent_span_1_Template_span_mouseenter_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const i_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.setState(i_r1); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("k-state-selected", ctx_r0.selected(i_r1))("k-state-disabled", !ctx_r0.selected(i_r1));
} }
export { Schema, EditorState, Plugin, PluginKey, Transaction, EditorView, Decoration, DecorationSet, NodeType, Node, MarkType, Mark, InputRule, inputRules, wrappingInputRule, textblockTypeInputRule, keymap, baseKeymap, history, dropCursor, gapCursor, tableNodes, getSelectionText } from '@progress/kendo-editor-common';
import { validatePackage } from '@progress/kendo-licensing';
import { LocalizationService, L10N_PREFIX, RTL, MessageService, ComponentMessages } from '@progress/kendo-angular-l10n';
import { CommonModule } from '@angular/common';
import { DropDownListComponent, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { ColorPickerComponent, ColorPickerModule, NumericTextBoxModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { PopupService } from '@progress/kendo-angular-popup';

/**
 * @hidden
 */
const packageMetadata = {
    name: '@progress/kendo-angular-editor',
    productName: 'Kendo UI for Angular',
    productCodes: ['KENDOUIANGULAR', 'KENDOUICOMPLETE'],
    publishDate: 1638198421,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-angular-ui/my-license/?utm_medium=product&utm_source=kendoangular&utm_campaign=kendo-ui-angular-purchase-license-keys-warning'
};

/**
 * @hidden
 */
const hasAttrs = (attrs, exclude) => {
    for (let attr in attrs) {
        if (attr && attrs[attr] !== null && attr !== exclude) {
            return true;
        }
    }
    return false;
};
/**
 * @hidden
 */
const getAttrs = (attrs, exclude) => {
    const result = {};
    for (let attr in attrs) {
        if (attr && attrs[attr] !== null && attr !== exclude) {
            result[attr] = attrs[attr];
        }
    }
    return result;
};
/**
 * @hidden
 */
const getAttributes = (dom) => {
    const result = {};
    let attributes = dom.attributes, attr;
    for (let i = 0; i < attributes.length; i++) {
        attr = attributes[i];
        result[attr.name] = attr.value;
    }
    return result;
};
/**
 * @hidden
 */
const serializeDOMAttrs = (el) => Array.from(el.attributes)
    .reduce((acc, curr) => Object.assign({}, acc, { [curr.name]: curr.value }), {});
/**
 * @hidden
 */
const commonAttributes = () => {
    return Object.assign({}, createDefaultAttributes(['class', 'id', 'style']));
};
/**
 * @hidden
 */
const createDefaultAttributes = (attrs = []) => {
    return Object.assign({}, attrs.reduce((acc, curr) => (Object.assign({}, acc, { [curr]: { default: null } })), {}));
};
/**
 * @hidden
 */
const hole = 0;
/**
 * @hidden
 */
const isSchemaNode = (schemaNodeName) => (node) => node.type.name === schemaNodeName;
/**
 * @hidden
 */
const isTable = isSchemaNode('table');
/**
 * @hidden
 */
const isTableBody = isSchemaNode('table_body');
/**
 * @hidden
 */
const isTableHead = isSchemaNode('table_head');
/**
 * @hidden
 */
const isTableFoot = isSchemaNode('table_foot');
/**
 * @hidden
 */
const isTableRow = isSchemaNode('table_row');
/**
 * @hidden
 */
const isTableCell = isSchemaNode('table_cell');
/**
 * @hidden
 */
const isTableHeaderCell = isSchemaNode('table_header');

const createSemanticNode = (tagName) => ({
    // Uncaught SyntaxError: Mixing inline and block content (in content expression '(block | inline)*')
    // content: '(block | inline)*',
    content: 'block*',
    group: 'block',
    attrs: Object.assign({}, commonAttributes()),
    parseDOM: [{
            tag: tagName,
            getAttrs: getAttributes
        }],
    toDOM: node => hasAttrs(node.attrs) ? [tagName, getAttrs(node.attrs), hole] : [tagName, hole]
});
/**
 * @hidden
 */
const semanticTagNames = ['article', 'main', 'nav', 'header', 'footer', 'aside', 'section'];
const ɵ1 = (acc, curr) => Object.assign(acc, { [curr]: createSemanticNode(curr) });
/**
 * @hidden
 */
const semanticNodes = semanticTagNames.reduce(ɵ1, {});

/**
 * @hidden
 */
function outerWidth(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseFloat(style.marginLeft) || 0 + parseFloat(style.marginRight) || 0;
    return width;
}
/**
 * @hidden
 */
const removeEntries = (obj, predicate) => Object.keys(obj)
    .filter(key => predicate(key))
    .reduce((acc, curr) => Object.assign(acc, { [curr]: obj[curr] }), {});
/**
 * @hidden
 */
const removeEmptyEntries = (obj) => {
    const predicate = key => obj[key] !== null && obj[key] !== undefined && obj[key] !== '';
    return removeEntries(obj, predicate);
};
/**
 * @hidden
 */
const isNullOrUndefined = (value) => value === undefined || value === null;
/**
 * @hidden
 */
const isPresent = (value) => !isNullOrUndefined(value);
/**
 * @hidden
 */
const detectIE = () => {
    if (!isDocumentAvailable()) {
        return false;
    }
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');
    return msie > 0 || trident > 0;
};
/**
 * @hidden
 */
const safeString = (value) => (isNullOrUndefined(value) ? '' : value.toString());
/**
 * @hidden
 */
const first = (arr) => arr[0];
/**
 * @hidden
 */
const last = (arr) => arr[arr.length - 1];
/**
 * @hidden
 */
const split = (splitter) => (value) => value.split(splitter);
/**
 * @hidden
 */
const trim = (value) => value.trim();
/**
 * @hidden
 */
const filter$1 = (predicate) => (arr) => arr.filter(predicate);
/**
 * @hidden
 */
const getUniqueStyleValues = (style, cssStyle) => {
    if (style.hasNodesWithoutMarks) {
        return '';
    }
    const uniqueMarkValues = style.marks
        .filter(m => m.type.name === 'style')
        .map(m => m.attrs.style)
        .map(safeString)
        .map(split(';'))
        .map(filter$1((m) => m.includes(cssStyle)))
        // guards against empty array
        .map((cssStyleValues) => (cssStyleValues.length !== 0 ? cssStyleValues : [`${cssStyle}: INVALID`]))
        .map(first)
        .map(split(':'))
        .map(last)
        .map(trim)
        .reduce((acc, curr) => (acc.indexOf(curr) > -1 ? acc : [...acc, curr]), []);
    if (uniqueMarkValues.indexOf('INVALID') > -1 || uniqueMarkValues.length !== 1) {
        return '';
    }
    return uniqueMarkValues[0];
};
/**
 * @hidden
 */
const conditionallyExecute = (fn) => (condition) => (param) => (condition ? fn(param) : param);
/**
 * @hidden
 */
const pipe = (...fns) => x => fns.reduce((y, f) => f(y), x);

const setCellAttrs = nodeAttributes => {
    let attrs = Object.assign({}, nodeAttributes);
    if (nodeAttributes.colspan !== 1) {
        attrs.colspan = nodeAttributes.colspan;
    }
    else {
        attrs.colspan = null;
    }
    if (nodeAttributes.rowspan !== 1) {
        attrs.rowspan = nodeAttributes.rowspan;
    }
    else {
        attrs.rowspan = null;
    }
    return removeEmptyEntries(attrs);
};
const ɵ1$1 = node => ['table', removeEmptyEntries(node.attrs), 0], ɵ2 = node => ['tr', removeEmptyEntries(node.attrs), 0], ɵ3 = node => ['td', setCellAttrs(node.attrs), 0], ɵ4 = node => ['th', setCellAttrs(node.attrs), 0], ɵ5 = node => ['tbody', removeEmptyEntries(node.attrs), 0], ɵ6 = node => ['tfoot', removeEmptyEntries(node.attrs), 0], ɵ7 = node => ['thead', removeEmptyEntries(node.attrs), 0], ɵ8 = node => ['col', removeEmptyEntries(node.attrs)], ɵ9 = node => ['colgroup', removeEmptyEntries(node.attrs), 0];
/**
 * @hidden
 */
const tableNodes = {
    // all table node names must start with table - this is needed for the commands to work properly
    table: {
        attrs: Object.assign({}, commonAttributes(), createDefaultAttributes(['cellspacing', 'cellpadding'])),
        content: '(table_body | table_head | table_foot | table_colgroup)+',
        tableRole: 'table',
        isolating: true,
        group: 'block',
        parseDOM: [
            {
                getAttrs: serializeDOMAttrs,
                tag: 'table'
            }
        ],
        toDOM: ɵ1$1
    },
    table_row: {
        content: '(table_cell | table_header)*',
        attrs: Object.assign({}, commonAttributes()),
        tableRole: 'row',
        parseDOM: [
            {
                getAttrs: serializeDOMAttrs,
                tag: 'tr'
            }
        ],
        toDOM: ɵ2
    },
    table_cell: {
        content: 'block+',
        attrs: Object.assign({}, commonAttributes(), createDefaultAttributes(['headers']), { 
            // this is needed for the commands
            colspan: { default: 1 }, rowspan: { default: 1 } }),
        tableRole: 'cell',
        isolating: true,
        parseDOM: [
            {
                getAttrs: serializeDOMAttrs,
                tag: 'td'
            }
        ],
        toDOM: ɵ3
    },
    table_header: {
        content: 'block+',
        attrs: Object.assign({}, commonAttributes(), createDefaultAttributes(['headers', 'abbr', 'scope']), { colspan: { default: 1 }, rowspan: { default: 1 } }),
        tableRole: 'header_cell',
        isolating: true,
        parseDOM: [
            {
                getAttrs: serializeDOMAttrs,
                tag: 'th'
            }
        ],
        toDOM: ɵ4
    },
    table_body: {
        attrs: Object.assign({}, commonAttributes()),
        content: 'table_row+',
        isolating: true,
        parseDOM: [
            {
                getAttrs: serializeDOMAttrs,
                tag: 'tbody'
            }
        ],
        toDOM: ɵ5
    },
    table_foot: {
        attrs: Object.assign({}, commonAttributes()),
        content: 'table_row+',
        isolating: true,
        parseDOM: [
            {
                getAttrs: serializeDOMAttrs,
                tag: 'tfoot'
            }
        ],
        toDOM: ɵ6
    },
    table_head: {
        attrs: Object.assign({}, commonAttributes()),
        content: 'table_row+',
        isolating: true,
        parseDOM: [
            {
                getAttrs: serializeDOMAttrs,
                tag: 'thead'
            }
        ],
        toDOM: ɵ7
    },
    table_col: {
        attrs: Object.assign({}, commonAttributes(), createDefaultAttributes(['span'])),
        selectable: false,
        atom: true,
        parseDOM: [
            {
                getAttrs: serializeDOMAttrs,
                tag: 'col'
            }
        ],
        toDOM: ɵ8
    },
    table_colgroup: {
        attrs: Object.assign({}, commonAttributes(), createDefaultAttributes(['span'])),
        content: 'table_col*',
        selectable: false,
        parseDOM: [
            {
                getAttrs: serializeDOMAttrs,
                tag: 'colgroup'
            }
        ],
        toDOM: ɵ9
    }
};

/**
 * @hidden
 */
const marks$1 = marks;
const nodes$1 = Object.assign(nodes, tableNodes, semanticNodes);
/**
 * @hidden
 */
const schema = new Schema({
    marks: marks$1,
    nodes: Object.assign({}, nodes$1, { blockquote: Object.assign({}, nodes$1.blockquote, { content: 'inline*' }) })
});

// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let readFromCache;
let addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    let cache = new WeakMap();
    readFromCache = key => cache.get(key);
    addToCache = (key, value) => {
        cache.set(key, value);
        return value;
    };
}
else {
    let cache = [];
    let cacheSize = 10;
    let cachePos = 0;
    readFromCache = key => {
        for (let i = 0; i < cache.length; i += 2) {
            if (cache[i] === key) {
                return cache[i + 1];
            }
        }
    };
    addToCache = (key, value) => {
        if (cachePos === cacheSize) {
            cachePos = 0;
        }
        cache[cachePos++] = key;
        return (cache[cachePos++] = value);
    };
}
const findWidth = (table) => {
    let width = -1;
    let hasRowSpan = false;
    for (let row = 0; row < table.childCount; row++) {
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) {
            for (let j = 0; j < row; j++) {
                const prevRow = table.child(j);
                for (let i = 0; i < prevRow.childCount; i++) {
                    const cell = prevRow.child(i);
                    if (j + cell.attrs.rowspan > row) {
                        rowWidth += cell.attrs.colspan;
                    }
                }
            }
        }
        // check if the cell spans accross multiple columns
        for (let i = 0; i < rowNode.childCount; i++) {
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) {
                hasRowSpan = true;
            }
        }
        if (width === -1) {
            width = rowWidth;
        }
        else if (width !== rowWidth) {
            width = Math.max(width, rowWidth);
        }
    }
    return width;
};
const freshColWidth = attrs => {
    if (attrs.colwidth) {
        return attrs.colwidth.slice();
    }
    const result = [];
    for (let i = 0; i < attrs.colspan; i++) {
        result.push(0);
    }
    return result;
};
const findBadColWidths = (map$$1, colWidths, table) => {
    if (!map$$1.problems) {
        map$$1.problems = [];
    }
    for (let i = 0, seen = {}; i < map$$1.map.length; i++) {
        const pos = map$$1.map[i];
        if (seen[pos]) {
            continue;
        }
        seen[pos] = true;
        let node = table.nodeAt(pos);
        let updated = null;
        for (let j = 0; j < node.attrs.colspan; j++) {
            const col = (i + j) % map$$1.width;
            const colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) {
                (updated || (updated = freshColWidth(node.attrs)))[j] = colWidth;
            }
        }
        if (updated) {
            map$$1.problems.unshift({ type: 'colwidth mismatch', pos, colwidth: updated });
        }
    }
};
// Compute a table map.
const computeMap = tableNode => {
    if (!isTable(tableNode) && !isTableBody(tableNode) && !isTableHead(tableNode) && !isTableFoot(tableNode)) {
        throw new RangeError('Not a table node: ' + tableNode.type.name);
    }
    const width = findWidth(tableNode);
    const height = tableNode.childCount;
    const map$$1 = [];
    let mapPos = 0;
    let problems = null;
    const colWidths = [];
    for (let i = 0, e = width * height; i < e; i++) {
        map$$1[i] = 0;
    }
    for (let row = 0, pos = 0; row < height; row++) {
        const rowNode = tableNode.child(row);
        pos++;
        for (let i = 0;; i++) {
            while (mapPos < map$$1.length && map$$1[mapPos] !== 0) {
                mapPos++;
            }
            if (i === rowNode.childCount) {
                break;
            }
            const cellNode = rowNode.child(i);
            const { colspan, rowspan, colwidth } = cellNode.attrs;
            for (let h = 0; h < rowspan; h++) {
                if (h + row >= height) {
                    (problems || (problems = [])).push({ type: 'overlong_rowspan', pos, n: rowspan - h });
                    break;
                }
                const start = mapPos + h * width;
                for (let w = 0; w < colspan; w++) {
                    if (map$$1[start + w] === 0) {
                        map$$1[start + w] = pos;
                    }
                    else {
                        (problems || (problems = [])).push({ type: 'collision', row, pos, n: colspan - w });
                    }
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = ((start + w) % width) * 2, prev = colWidths[widthIndex];
                        if (prev == null || (prev !== colW && colWidths[widthIndex + 1] === 1)) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        }
                        else if (prev === colW) {
                            colWidths[widthIndex + 1]++;
                        }
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while (mapPos < expectedPos) {
            if (map$$1[mapPos++] === 0) {
                missing++;
            }
        }
        if (missing) {
            (problems || (problems = [])).push({ type: 'missing', row, n: missing });
        }
        pos++;
    }
    const tableMap = new TableMap(width, height, map$$1, problems);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for (let i = 0; !badWidths && i < colWidths.length; i += 2) {
        if (colWidths[i] != null && colWidths[i + 1] < height) {
            badWidths = true;
        }
    }
    if (badWidths) {
        findBadColWidths(tableMap, colWidths, tableNode);
    }
    return tableMap;
};
/**
 * @hidden
 */
class Rect {
    constructor(left, top, right, bottom) {
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
/**
 * @hidden
 */
class TableMap {
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return readFromCache(table) || addToCache(table, computeMap(table));
    }
    constructor(width, height, map$$1, problems) {
        // :: number The width of the table
        this.width = width;
        // :: number The table's height
        this.height = height;
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map$$1;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for (let i = 0; i < this.map.length; i++) {
            const curPos = this.map[i];
            if (curPos !== pos) {
                continue;
            }
            const left = i % this.width;
            const top = Math.floor(i / this.width);
            let right = left + 1;
            let bottom = top + 1;
            for (let j = 1; right < this.width && this.map[i + j] === curPos; j++) {
                right++;
            }
            for (let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++) {
                bottom++;
            }
            return new Rect(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // :: (number) → number
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for (let i = 0; i < this.map.length; i++) {
            if (this.map[i] === pos) {
                return i % this.width;
            }
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left, right, top, bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) {
                return null;
            }
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        }
        else {
            if (dir < 0 ? top === 0 : bottom === this.height) {
                return null;
            }
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new Rect(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for (let row = rect.top; row < rect.bottom; row++) {
            for (let col = rect.left; col < rect.right; col++) {
                const index = row * this.width + col, pos = this.map[index];
                if (seen[pos]) {
                    continue;
                }
                seen[pos] = true;
                if ((col !== rect.left || !col || this.map[index - 1] !== pos) &&
                    (row !== rect.top || !row || this.map[index - this.width] !== pos)) {
                    result.push(pos);
                }
            }
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for (let i = 0, rowStart = 0;; i++) {
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width, rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while (index < rowEndIndex && this.map[index] < rowStart) {
                    index++;
                }
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
}

/**
 * @hidden
 */
// ::- A [`Selection`](http://prosemirror.net/docs/ref/#state.Selection)
// subclass that represents a cell selection spanning part of a table.
// With the plugin enabled, these will be created when the user
// selects across cells, and will be drawn by giving selected cells a
// `selectedCell` CSS class.
class CellSelection extends Selection {
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let map$$1 = TableMap.get($anchorCell.node(-1));
        let start = $anchorCell.start(-1);
        let anchorRect = map$$1.findCell($anchorCell.pos - start);
        let headRect = map$$1.findCell($headCell.pos - start);
        let doc = $anchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) {
                $anchorCell = doc.resolve(start + map$$1.map[anchorRect.left]);
            }
            if (headRect.bottom < map$$1.height) {
                $headCell = doc.resolve(start + map$$1.map[map$$1.width * (map$$1.height - 1) + headRect.right - 1]);
            }
        }
        else {
            if (headRect.top > 0) {
                $headCell = doc.resolve(start + map$$1.map[headRect.left]);
            }
            if (anchorRect.bottom < map$$1.height) {
                $anchorCell = doc.resolve(start + map$$1.map[map$$1.width * (map$$1.height - 1) + anchorRect.right - 1]);
            }
        }
        return new CellSelection($anchorCell, $headCell);
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let map$$1 = TableMap.get($anchorCell.node(-1));
        let start = $anchorCell.start(-1);
        let anchorRect = map$$1.findCell($anchorCell.pos - start);
        let headRect = map$$1.findCell($headCell.pos - start);
        let doc = $anchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) {
                $anchorCell = doc.resolve(start + map$$1.map[anchorRect.top * map$$1.width]);
            }
            if (headRect.right < map$$1.width) {
                $headCell = doc.resolve(start + map$$1.map[map$$1.width * (headRect.top + 1) - 1]);
            }
        }
        else {
            if (headRect.left > 0) {
                $headCell = doc.resolve(start + map$$1.map[headRect.top * map$$1.width]);
            }
            if (anchorRect.right < map$$1.width) {
                $anchorCell = doc.resolve(start + map$$1.map[map$$1.width * (anchorRect.top + 1) - 1]);
            }
        }
        return new CellSelection($anchorCell, $headCell);
    }
    static fromJSON(doc, json) {
        return new CellSelection(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new CellSelection(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    // :: (ResolvedPos, ?ResolvedPos)
    // A table selection is identified by its anchor and head cells. The
    // positions given to this constructor should point _before_ two
    // cells in the same table. They may be the same, to select a single
    // cell.
    constructor($anchorCell, $headCell = $anchorCell) {
        let table = $anchorCell.node(-1), map$$1 = TableMap.get(table), start = $anchorCell.start(-1);
        let rect = map$$1.rectBetween($anchorCell.pos - start, $headCell.pos - start);
        let doc = $anchorCell.node(0);
        let cells = map$$1.cellsInRect(rect).filter(p => p !== $headCell.pos - start);
        // Make the head cell the first range, so that it counts as the
        // primary part of the selection
        cells.unshift($headCell.pos - start);
        let ranges = cells.map(pos => {
            let cell = table.nodeAt(pos), from = pos + start + 1;
            return new SelectionRange(doc.resolve(from), doc.resolve(from + cell.content.size));
        });
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
    }
    map(doc, mapping) {
        let $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        let $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if (pointsAtCell($anchorCell) && pointsAtCell($headCell) && inSameTable($anchorCell, $headCell)) {
            let tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) {
                return CellSelection.rowSelection($anchorCell, $headCell);
            }
            else {
                if (tableChanged && this.isColSelection()) {
                    return CellSelection.colSelection($anchorCell, $headCell);
                }
                else {
                    return new CellSelection($anchorCell, $headCell);
                }
            }
        }
        return TextSelection.between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        let table = this.$anchorCell.node(-1), map$$1 = TableMap.get(table), start = this.$anchorCell.start(-1);
        let rect = map$$1.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        let seen = {}, rows = [];
        for (let row = rect.top; row < rect.bottom; row++) {
            let rowContent = [];
            for (let index = row * map$$1.width + rect.left, col = rect.left; col < rect.right; col++, index++) {
                let pos = map$$1.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    let cellRect = map$$1.findCell(pos), cell = table.nodeAt(pos);
                    let extraLeft = rect.left - cellRect.left, extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let attrs = cell.attrs;
                        if (extraLeft > 0) {
                            attrs = removeColSpan(attrs, 0, extraLeft);
                        }
                        if (extraRight > 0) {
                            attrs = removeColSpan(attrs, attrs.colspan - extraRight, extraRight);
                        }
                        if (cellRect.left < rect.left) {
                            cell = cell.type.createAndFill(attrs);
                        }
                        else {
                            cell = cell.type.create(attrs, cell.content);
                        }
                    }
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        let attrs = setAttr(cell.attrs, 'rowspan', Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top));
                        if (cellRect.top < rect.top) {
                            cell = cell.type.createAndFill(attrs);
                        }
                        else {
                            cell = cell.type.create(attrs, cell.content);
                        }
                    }
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy(Fragment.from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new Slice(Fragment.from(fragment), 1, 1);
    }
    replace(tr, content = Slice.empty) {
        let mapFrom = tr.steps.length;
        let ranges = this.ranges;
        for (let i = 0; i < ranges.length; i++) {
            let { $from, $to } = ranges[i];
            let mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? Slice.empty : content);
        }
        let sel = Selection.findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) {
            tr.setSelection(sel);
        }
    }
    replaceWith(tr, node) {
        this.replace(tr, new Slice(Fragment.from(node), 0, 0));
    }
    forEachCell(f) {
        let table = this.$anchorCell.node(-1);
        let map$$1 = TableMap.get(table);
        let start = this.$anchorCell.start(-1);
        let cells = map$$1.cellsInRect(map$$1.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for (let i = 0; i < cells.length; i++) {
            f(table.nodeAt(cells[i]), start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        let anchorTop = this.$anchorCell.index(-1), headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) {
            return false;
        }
        let anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        let headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        let map$$1 = TableMap.get(this.$anchorCell.node(-1));
        let start = this.$anchorCell.start(-1);
        let anchorLeft = map$$1.colCount(this.$anchorCell.pos - start);
        let headLeft = map$$1.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) {
            return false;
        }
        let anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        let headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map$$1.width;
    }
    eq(other) {
        return (other instanceof CellSelection && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos);
    }
    toJSON() {
        return { type: 'cell', anchor: this.$anchorCell.pos, head: this.$headCell.pos };
    }
    getBookmark() {
        return new CellBookmark(this.$anchorCell.pos, this.$headCell.pos);
    }
}
CellSelection.prototype.visible = false;
Selection.jsonID('table_cell', CellSelection);
class CellBookmark {
    constructor(anchor, head) {
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new CellBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        let $anchorCell = doc.resolve(this.anchor), $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' &&
            $headCell.parent.type.spec.tableRole === 'row' &&
            $anchorCell.index() < $anchorCell.parent.childCount &&
            $headCell.index() < $headCell.parent.childCount &&
            inSameTable($anchorCell, $headCell)) {
            return new CellSelection($anchorCell, $headCell);
        }
        else {
            return Selection.near($headCell, 1);
        }
    }
}

/**
 * @hidden
 */
const findParentNodeClosestToPos = ($pos, predicate) => {
    for (let i = $pos.depth; i > 0; i--) {
        const node = $pos.node(i);
        if (predicate(node)) {
            return {
                start: $pos.start(i),
                pos: i > 0 ? $pos.before(i) : 0,
                depth: i,
                node
            };
        }
    }
};
/**
 * @hidden
 */
const createTable = (nodes$$1, rows, columns) => {
    const { table, table_body, table_row, table_cell } = nodes$$1;
    const tableRows = [];
    let cells;
    for (let r = 0; r < rows + 1; r++) {
        cells = [];
        for (let c = 0; c < columns + 1; c++) {
            cells.push(table_cell.createAndFill());
        }
        tableRows.push(table_row.createAndFill(undefined, cells));
    }
    const body = table_body.createAndFill(undefined, tableRows);
    return table.createAndFill(undefined, body);
};
/**
 * @hidden
 */
const isInTable = (state) => {
    const $head = state.selection.$head;
    for (let d = $head.depth; d > 0; d--) {
        if (isTableRow($head.node(d))) {
            return true;
        }
    }
    return false;
};
/**
 * @hidden
 */
const setAttr = (attrs, name, value) => {
    const result = {};
    // tslint:disable-next-line
    for (const prop in attrs) {
        result[prop] = attrs[prop];
    }
    result[name] = value;
    return result;
};
const cellNear = ($pos) => {
    for (let after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++) {
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') {
            return $pos.doc.resolve(pos);
        }
    }
    for (let before = $pos.nodeBefore, pos = $pos.pos; before; before = before.lastChild, pos--) {
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') {
            return $pos.doc.resolve(pos - before.nodeSize);
        }
    }
};
const cellAround = ($pos) => {
    for (let d = $pos.depth - 1; d > 0; d--) {
        if (isTableRow($pos.node(d))) {
            return $pos.node(0).resolve($pos.before(d + 1));
        }
    }
    return null;
};
const selectionCell = (sel) => {
    if (sel instanceof CellSelection && sel.$anchorCell) {
        return sel.$anchorCell.pos > sel.$headCell.pos ? sel.$anchorCell : sel.$headCell;
    }
    else if (sel instanceof NodeSelection && sel.node && isTableCell(sel.node)) {
        return sel.$anchor;
    }
    return cellAround(sel.$head) || cellNear(sel.$head);
};
/**
 * @hidden
 */
// Helper to get the selected rectangle in a table, if any. Adds table
// map, table node, and table start offset to the object for
// convenience.
const selectedRect = (sel) => {
    // create arr of rect for each table section
    // there has to be a rect for thead, tbody and tfoot(if each exists)
    // and NOT for colgroups
    const $pos = selectionCell(sel);
    const table = $pos.node(-1);
    const tableStart = $pos.start(-1);
    const map$$1 = TableMap.get(table);
    const rect = sel instanceof CellSelection
        ? map$$1.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart)
        : map$$1.findCell($pos.pos - tableStart);
    rect.tableStart = tableStart;
    rect.map = map$$1;
    rect.table = table;
    return rect;
};
/**
 * @hidden
 */
// this has to be removed since the schema should not have roles inside NodeSpec.
const tableNodeTypes = (schema) => {
    let result = schema.cached.tableNodeTypes;
    if (!result) {
        result = schema.cached.tableNodeTypes = {};
        // tslint:disable-next-line
        for (const name in schema.nodes) {
            const type = schema.nodes[name];
            const role = type.spec.tableRole;
            if (role) {
                result[role] = type;
            }
        }
    }
    return result;
};
/**
 * @hidden
 */
const rowIsHeader = (map$$1, table, row) => {
    const headerCell = tableNodeTypes(table.type.schema).header_cell;
    for (let col = 0; col < map$$1.width; col++) {
        if (table.nodeAt(map$$1.map[col + row * map$$1.width]).type !== headerCell) {
            return false;
        }
    }
    return true;
};
/**
 * @hidden
 */
const addColSpan = (attrs, pos, n = 1) => {
    const result = setAttr(attrs, 'colspan', attrs.colspan + n);
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for (let i = 0; i < n; i++) {
            result.colwidth.splice(pos, 0, 0);
        }
    }
    return result;
};
/**
 * @hidden
 */
const removeColSpan = (attrs, pos, n = 1) => {
    const result = setAttr(attrs, 'colspan', attrs.colspan - n);
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some(w => w > 0)) {
            result.colwidth = null;
        }
    }
    return result;
};
/**
 * @hidden
 */
const isCellEmpty = cell => {
    const c = cell.content;
    return c.childCount === 1 && c.firstChild.isTextblock && c.firstChild.childCount === 0;
};
const cellWrapping = ($pos) => {
    for (let d = $pos.depth; d > 0; d--) {
        // Sometimes the cell can be in the same depth.
        const role = $pos.node(d).type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') {
            return $pos.node(d);
        }
    }
    return null;
};
/**
 * @hidden
 */
// Split a selected cell, whose rowpan or colspan is greater than one,
// into smaller cells with the cell type (th, td) returned by getType function.
const splitCellWithType = getCellType => {
    return (state, dispatch) => {
        const sel = state.selection;
        let cellNode;
        let cellPos;
        if (!(sel instanceof CellSelection)) {
            cellNode = cellWrapping(sel.$from);
            if (!cellNode) {
                return false;
            }
            cellPos = cellAround(sel.$from).pos;
        }
        else {
            if (sel.$anchorCell.pos !== sel.$headCell.pos) {
                return false;
            }
            cellNode = sel.$anchorCell.nodeAfter;
            cellPos = sel.$anchorCell.pos;
        }
        if (cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) {
            return false;
        }
        if (dispatch) {
            let baseAttrs = cellNode.attrs;
            const attrs = [];
            const colwidth = baseAttrs.colwidth;
            if (baseAttrs.rowspan > 1) {
                baseAttrs = setAttr(baseAttrs, 'rowspan', 1);
            }
            if (baseAttrs.colspan > 1) {
                baseAttrs = setAttr(baseAttrs, 'colspan', 1);
            }
            const rect = selectedRect(state);
            const tr = state.tr;
            for (let i = 0; i < rect.right - rect.left; i++) {
                attrs.push(colwidth ? setAttr(baseAttrs, 'colwidth', colwidth && colwidth[i] ? [colwidth[i]] : null) : baseAttrs);
            }
            let lastCell;
            for (let row = rect.top; row < rect.bottom; row++) {
                let pos = rect.map.positionAt(row, rect.left, rect.table);
                if (row === rect.top) {
                    pos += cellNode.nodeSize;
                }
                for (let col = rect.left, i = 0; col < rect.right; col++, i++) {
                    if (col === rect.left && row === rect.top) {
                        continue;
                    }
                    tr.insert((lastCell = tr.mapping.map(pos + rect.tableStart, 1)), getCellType({ node: cellNode, row, col }).createAndFill(attrs[i]));
                }
            }
            tr.setNodeMarkup(cellPos, getCellType({ node: cellNode, row: rect.top, col: rect.left }), attrs[0]);
            if (sel instanceof CellSelection) {
                tr.setSelection(new CellSelection(tr.doc.resolve(sel.$anchorCell.pos), lastCell && tr.doc.resolve(lastCell)));
            }
            dispatch(tr);
        }
        return true;
    };
};
/**
 * @hidden
 */
const pointsAtCell = ($pos) => {
    return isTableRow($pos.parent) && $pos.nodeAfter;
};
/**
 * @hidden
 */
const inSameTable = ($a, $b) => {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
};
/**
 * @hidden
 */
const cellsOverlapRectangle = ({ width, height, map: map$$1 }, rect) => {
    let indexTop = rect.top * width + rect.left;
    let indexLeft = indexTop;
    let indexBottom = (rect.bottom - 1) * width + rect.left;
    let indexRight = indexTop + (rect.right - rect.left - 1);
    for (let i = rect.top; i < rect.bottom; i++) {
        if ((rect.left > 0 && map$$1[indexLeft] === map$$1[indexLeft - 1]) || (rect.right < width && map$$1[indexRight] === map$$1[indexRight + 1])) {
            return true;
        }
        indexLeft += width;
        indexRight += width;
    }
    for (let i = rect.left; i < rect.right; i++) {
        if ((rect.top > 0 && map$$1[indexTop] === map$$1[indexTop - width]) ||
            (rect.bottom < height && map$$1[indexBottom] === map$$1[indexBottom + width])) {
            return true;
        }
        indexTop++;
        indexBottom++;
    }
    return false;
};

/**
 * @hidden
 */
const insertTable = (attrs) => (state, dispatch) => {
    const newTable = createTable(state.schema.nodes, attrs.rows, attrs.cols);
    if (newTable) {
        insertNode(newTable, true)(state, dispatch);
    }
};
const addTableGroupColumn = (tr, { left, right }, col, mainTable, requiredGroup, doc) => {
    let refColumn = col > 0 ? -1 : 0;
    // not sure if this should be deleted
    // if (columnIsHeader(map, table, col + refColumn)) {
    //     refColumn = col === 0 || col === map.width ? null : 0;
    // }
    let rect;
    mainTable.node.descendants((tableChildNode, offset) => {
        if (requiredGroup(tableChildNode)) {
            let i = -1;
            tableChildNode.firstChild.descendants((childNode, pos) => {
                if (isTableCell(childNode) || isTableHeaderCell(childNode)) {
                    i = i + 1;
                    if (i === right || i === left) {
                        const selection = new Selection(doc.resolve(pos + offset + mainTable.start), doc.resolve(pos + offset + mainTable.start));
                        rect = selectedRect(selection);
                    }
                }
            });
        }
    });
    // Do nothing if thead, tfoot or tbody is missing
    if (!rect) {
        return tr;
    }
    for (let row = 0; row < rect.map.height; row++) {
        const index = row * rect.map.width + col;
        // If this position falls inside a col-spanning cell
        if (col > 0 && col < rect.map.width && rect.map.map[index - 1] === rect.map.map[index]) {
            const pos = rect.map.map[index];
            const cell = rect.table.nodeAt(pos);
            tr.setNodeMarkup(tr.mapping.map(rect.tableStart + pos), null, addColSpan(cell.attrs, col - rect.map.colCount(pos)));
            // Skip ahead if rowspan > 1
            row += cell.attrs.rowspan - 1;
        }
        else {
            const type = rect.table.nodeAt(rect.map.map[index + refColumn]).type;
            const pos = rect.map.positionAt(row, col, rect.table);
            tr.insert(tr.mapping.map(rect.tableStart + pos), type.createAndFill());
        }
    }
    return tr;
};
const removeTableGroupColumn = (tr, { right, left }, mainTable, requiredGroup, doc) => {
    let rect;
    mainTable.node.descendants((tableChildNode, offset) => {
        if (requiredGroup(tableChildNode)) {
            let i = -1;
            tableChildNode.firstChild.descendants((childNode, pos) => {
                if (isTableCell(childNode) || isTableHeaderCell(childNode)) {
                    i = i + 1;
                    if (i >= left && i < right) {
                        const resolvedPos = doc.resolve(pos + offset + mainTable.start + childNode.nodeSize);
                        const selection = new Selection(resolvedPos, resolvedPos);
                        rect = selectedRect(selection);
                    }
                }
            });
        }
    });
    // Do nothing if thead, tfoot or tbody is missing
    if (!rect) {
        return;
    }
    for (let i = rect.right - 1;; i--) {
        removeColumn(tr, rect, i);
        if (i === rect.left) {
            break;
        }
        rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
        rect.map = TableMap.get(rect.table);
    }
    return;
};
const removeColumn = (tr, { map: map$$1, table, tableStart }, col) => {
    for (let row = 0; row < map$$1.height;) {
        const index = row * map$$1.width + col;
        const pos = map$$1.map[index];
        const cell = table.nodeAt(pos);
        // If this is part of a col-spanning cell
        if ((col > 0 && map$$1.map[index - 1] === pos) || (col < map$$1.width - 1 && map$$1.map[index + 1] === pos)) {
            tr.setNodeMarkup(tr.mapping.map(tableStart + pos), null, removeColSpan(cell.attrs, col - map$$1.colCount(pos)));
        }
        else {
            const start = tr.mapping.map(tableStart + pos);
            tr.delete(start, start + cell.nodeSize);
        }
        row += cell.attrs.rowspan;
    }
};
/**
 * @hidden
 */
// Command to add a column before the column with the selection.
const addColumnBefore$1 = (state, dispatch) => {
    if (!isInTable(state)) {
        return false;
    }
    if (dispatch) {
        const rect = selectedRect(state.selection);
        const mainTable = findParentNodeClosestToPos(state.selection.$anchor, isTable);
        const tHeadTr = addTableGroupColumn(state.tr, rect, rect.left, mainTable, isTableHead, state.doc);
        const tBodyTr = addTableGroupColumn(tHeadTr, rect, rect.left, mainTable, isTableBody, state.doc);
        const tFootTr = addTableGroupColumn(tBodyTr, rect, rect.left, mainTable, isTableFoot, state.doc);
        dispatch(tFootTr);
    }
    return true;
};
/**
 * @hidden
 */
// Command to add a column after the column with the selection.
const addColumnAfter$1 = (state, dispatch) => {
    if (!isInTable(state)) {
        return false;
    }
    if (dispatch) {
        const rect = selectedRect(state.selection);
        const mainTable = findParentNodeClosestToPos(state.selection.$anchor, isTable);
        const theadTr = addTableGroupColumn(state.tr, rect, rect.right, mainTable, isTableHead, state.doc);
        const tBodyTr = addTableGroupColumn(theadTr, rect, rect.right, mainTable, isTableBody, state.doc);
        const tFootTr = addTableGroupColumn(tBodyTr, rect, rect.right, mainTable, isTableFoot, state.doc);
        dispatch(tFootTr);
    }
    return true;
};
const addRow = (tr, { map: map$$1, tableStart, table }, row) => {
    let rowPos = tableStart;
    for (let i = 0; i < row; i++) {
        rowPos += table.child(i).nodeSize;
    }
    const cells = [];
    let refRow = row > 0 ? -1 : 0;
    if (rowIsHeader(map$$1, table, row + refRow)) {
        refRow = row === 0 || row === map$$1.height ? null : 0;
    }
    for (let col = 0, index = map$$1.width * row; col < map$$1.width; col++, index++) {
        // Covered by a rowspan cell
        if (row > 0 && row < map$$1.height && map$$1.map[index] === map$$1.map[index - map$$1.width]) {
            const pos = map$$1.map[index];
            const attrs = table.nodeAt(pos).attrs;
            tr.setNodeMarkup(tableStart + pos, null, setAttr(attrs, 'rowspan', attrs.rowspan + 1));
            col += attrs.colspan - 1;
        }
        else {
            const type = refRow == null ? tableNodeTypes(table.type.schema).cell : table.nodeAt(map$$1.map[index + refRow * map$$1.width]).type;
            cells.push(type.createAndFill());
        }
    }
    tr.insert(rowPos, tableNodeTypes(table.type.schema).row.create(null, cells));
    return tr;
};
/**
 * @hidden
 */
// Add a table row before the selection.
const addRowBefore$1 = (state, dispatch) => {
    if (!isInTable(state)) {
        return false;
    }
    if (dispatch) {
        const rect = selectedRect(state.selection);
        dispatch(addRow(state.tr, rect, rect.top));
    }
    return true;
};
/**
 * @hidden
 */
// Add a table row after the selection.
const addRowAfter$1 = (state, dispatch) => {
    if (!isInTable(state)) {
        return false;
    }
    if (dispatch) {
        const rect = selectedRect(state.selection);
        dispatch(addRow(state.tr, rect, rect.bottom));
    }
    return true;
};
/**
 * @hidden
 */
// Command function that removes the selected columns from a table.
const deleteColumn$1 = (state, dispatch) => {
    if (!isInTable(state)) {
        return false;
    }
    if (dispatch) {
        const rect = selectedRect(state.selection);
        // if only one column left - delete the whole table
        if (rect.left === 0 && rect.right === rect.map.width) {
            return deleteTable$1(state, dispatch);
        }
        const mainTable = findParentNodeClosestToPos(state.selection.$anchor, isTable);
        const tr = state.tr;
        removeTableGroupColumn(tr, rect, mainTable, isTableFoot, tr.doc);
        removeTableGroupColumn(tr, rect, mainTable, isTableBody, tr.doc);
        removeTableGroupColumn(tr, rect, mainTable, isTableHead, tr.doc);
        dispatch(tr);
    }
    return true;
};
const removeRow = (tr, { map: map$$1, table, tableStart }, row) => {
    let rowPos = 0;
    for (let i = 0; i < row; i++) {
        rowPos += table.child(i).nodeSize;
    }
    const nextRow = rowPos + table.child(row).nodeSize;
    const mapFrom = tr.mapping.maps.length;
    tr.delete(rowPos + tableStart, nextRow + tableStart);
    for (let col = 0, index = row * map$$1.width; col < map$$1.width; col++, index++) {
        const pos = map$$1.map[index];
        if (row > 0 && pos === map$$1.map[index - map$$1.width]) {
            // If this cell starts in the row above, simply reduce its rowspan
            const attrs = table.nodeAt(pos).attrs;
            tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + tableStart), null, setAttr(attrs, 'rowspan', attrs.rowspan - 1));
            col += attrs.colspan - 1;
        }
        else if (row < map$$1.width && pos === map$$1.map[index + map$$1.width]) {
            // Else, if it continues in the row below, it has to be moved down
            const cell = table.nodeAt(pos);
            const copy = cell.type.create(setAttr(cell.attrs, 'rowspan', cell.attrs.rowspan - 1), cell.content);
            const newPos = map$$1.positionAt(row + 1, col, table);
            tr.insert(tr.mapping.slice(mapFrom).map(tableStart + newPos), copy);
            col += cell.attrs.colspan - 1;
        }
    }
};
/**
 * @hidden
 */
// Remove the selected rows from a table.
const deleteRow$1 = (state, dispatch) => {
    if (!isInTable(state)) {
        return false;
    }
    if (dispatch) {
        const rect = selectedRect(state.selection);
        const tr = state.tr;
        if (rect.top === 0 && rect.bottom === rect.map.height) {
            const mainTable = findParentNodeClosestToPos(state.selection.$anchor, isTable);
            if (mainTable.node.childCount === 1) {
                deleteTable$1(state, dispatch);
            }
            else {
                deleteTableElement(n => n.type.name === rect.table.type.name)(state, dispatch);
            }
            return true;
        }
        for (let i = rect.bottom - 1;; i--) {
            removeRow(tr, rect, i);
            if (i === rect.top) {
                break;
            }
            rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
            rect.map = TableMap.get(rect.table);
        }
        dispatch(tr);
    }
    return true;
};
/**
 * @hidden
 */
// Merge the selected cells into a single cell. Only available when
// the selected cells' outline forms a rectangle.
const mergeCells$1 = (state, dispatch) => {
    const sel = state.selection;
    if (!(sel instanceof CellSelection) || sel.$anchorCell.pos === sel.$headCell.pos) {
        return false;
    }
    const rect = selectedRect(state.selection);
    const { map: map$$1 } = rect;
    if (cellsOverlapRectangle(map$$1, rect)) {
        return false;
    }
    if (dispatch) {
        const tr = state.tr;
        const seen = {};
        let content = Fragment.empty;
        let mergedPos;
        let mergedCell;
        for (let row = rect.top; row < rect.bottom; row++) {
            for (let col = rect.left; col < rect.right; col++) {
                const cellPos = map$$1.map[row * map$$1.width + col], cell = rect.table.nodeAt(cellPos);
                if (seen[cellPos]) {
                    continue;
                }
                seen[cellPos] = true;
                if (mergedPos === null) {
                    mergedPos = cellPos;
                    mergedCell = cell;
                }
                else {
                    if (!isCellEmpty(cell)) {
                        content = content.append(cell.content);
                    }
                    const mapped = tr.mapping.map(cellPos + rect.tableStart);
                    tr.delete(mapped, mapped + cell.nodeSize);
                }
            }
        }
        tr.setNodeMarkup(mergedPos + rect.tableStart, null, setAttr(addColSpan(mergedCell.attrs, mergedCell.attrs.colspan, rect.right - rect.left - mergedCell.attrs.colspan), 'rowspan', rect.bottom - rect.top));
        if (content.size) {
            const end = mergedPos + 1 + mergedCell.content.size;
            const start = isCellEmpty(mergedCell) ? mergedPos + 1 : end;
            tr.replaceWith(start + rect.tableStart, end + rect.tableStart, content);
        }
        tr.setSelection(new CellSelection(tr.doc.resolve(mergedPos + rect.tableStart)));
        dispatch(tr);
    }
    return true;
};
/**
 * @hidden
 */
// Split a selected cell, whose rowpan or colspan is greater than one,
// into smaller cells. Use the first cell type for the new cells.
const splitCell$1 = (state, dispatch) => {
    const nodeTypes = tableNodeTypes(state.schema);
    return splitCellWithType(({ node }) => {
        return nodeTypes[node.type.spec.tableRole];
    })(state, dispatch);
};
const deleteTableElement = (selector) => (state, dispatch) => {
    const $pos = state.selection.$anchor;
    for (let d = $pos.depth; d > 0; d--) {
        const node = $pos.node(d);
        if (selector(node)) {
            if (dispatch) {
                const tr = state.tr;
                tr.delete($pos.before(d), $pos.after(d)).scrollIntoView();
                dispatch(tr);
            }
            return true;
        }
    }
    return false;
};
/**
 * @hidden
 */
// Deletes the table around the selection, if any.
const deleteTable$1 = deleteTableElement(isTable);

const alignRemove = (state, dispatch) => alignBlocks(alignRemoveRules)(state, dispatch);
const ɵ1$5 = (applyToWord) => expandToWordWrap(toggleInlineFormat, Object.assign({}, bold, { applyToWord })), ɵ2$4 = (options) => cleanFormatting(options), ɵ3$4 = attrs => expandToWordWrap(applyLink, { mark: 'link', attrs: attrs.value, applyToWord: attrs.applyToWord }), ɵ4$2 = attrs => expandToWordWrap(applyInlineStyle, { style: 'font-family', value: attrs.value, applyToWord: attrs.applyToWord }), ɵ5$2 = attrs => expandToWordWrap(applyInlineStyle, { style: 'font-size', value: attrs.value + 'px', applyToWord: attrs.applyToWord }), ɵ6$1 = attrs => expandToWordWrap(applyLink, { mark: 'link', attrs: attrs, applyToWord: attrs.applyToWord }), ɵ7$1 = text => insertText(text), ɵ8$1 = (applyToWord) => expandToWordWrap(toggleInlineFormat, Object.assign({}, italic, { applyToWord })), ɵ9$1 = (applyToWord) => expandToWordWrap(toggleInlineFormat, Object.assign({}, strikethrough, { applyToWord })), ɵ10 = (applyToWord) => expandToWordWrap(toggleInlineFormat, Object.assign({}, subscript, { applyToWord })), ɵ11 = (applyToWord) => expandToWordWrap(toggleInlineFormat, Object.assign({}, superscript, { applyToWord })), ɵ12 = (applyToWord) => expandToWordWrap(toggleInlineFormat, Object.assign({}, underline, { applyToWord })), ɵ13 = () => removeLink(link), ɵ14 = attrs => expandToWordWrap(applyInlineStyle, { style: 'color', value: attrs.value, applyToWord: attrs.applyToWord }), ɵ15 = attrs => expandToWordWrap(applyInlineStyle, { style: 'background-color', value: attrs.value, applyToWord: attrs.applyToWord }), ɵ16 = () => (state, dispatch) => selectAll(state, dispatch);
const inlineCommand = {
    bold: ɵ1$5,
    cleanFormatting: ɵ2$4,
    createLink: ɵ3$4,
    fontFamily: ɵ4$2,
    fontSize: ɵ5$2,
    insertFile: ɵ6$1,
    insertText: ɵ7$1,
    italic: ɵ8$1,
    strikethrough: ɵ9$1,
    subscript: ɵ10,
    superscript: ɵ11,
    underline: ɵ12,
    unlink: ɵ13,
    foreColor: ɵ14,
    backColor: ɵ15,
    selectAll: ɵ16
};
const ɵ17 = () => (state, dispatch) => isAligned(state, alignCenterRules) ? alignRemove(state, dispatch) : alignBlocks(alignCenterRules)(state, dispatch), ɵ18 = () => (state, dispatch) => isAligned(state, alignJustifyRules) ? alignRemove(state, dispatch) : alignBlocks(alignJustifyRules)(state, dispatch), ɵ19 = () => (state, dispatch) => isAligned(state, alignLeftRules) ? alignRemove(state, dispatch) : alignBlocks(alignLeftRules)(state, dispatch), ɵ20 = () => (state, dispatch) => isAligned(state, alignRightRules) ? alignRemove(state, dispatch) : alignBlocks(alignRightRules)(state, dispatch), ɵ21 = formatAttr => formatBlockElements(formatAttr.tag), ɵ22 = () => getHtml, ɵ23 = () => indent, ɵ24 = attrs => insertImage(attrs), ɵ25 = () => toggleOrderedList, ɵ26 = () => toggleUnorderedList, ɵ27 = () => outdent, ɵ28 = () => redo, ɵ29 = ({ content, parseOptions }) => setHtml(content, 'setHTML', parseOptions), ɵ30 = () => undo;
const blockCommand = {
    alignCenter: ɵ17,
    alignJustify: ɵ18,
    alignLeft: ɵ19,
    alignRight: ɵ20,
    format: ɵ21,
    getHTML: ɵ22,
    indent: ɵ23,
    insertImage: ɵ24,
    // think about changing the command name.
    insertOrderedList: ɵ25,
    // think about changing the command name.
    insertUnorderedList: ɵ26,
    outdent: ɵ27,
    redo: ɵ28,
    setHTML: ɵ29,
    undo: ɵ30
};
const ɵ31 = attr => insertTable(attr), ɵ32 = () => addColumnBefore$1, ɵ33 = () => addColumnAfter$1, ɵ34 = () => addRowBefore$1, ɵ35 = () => addRowAfter$1, ɵ36 = () => deleteRow$1, ɵ37 = () => deleteColumn$1, ɵ38 = () => mergeCells$1, ɵ39 = () => splitCell$1, ɵ40 = () => deleteTable$1;
const tableCommand = {
    insertTable: ɵ31,
    addColumnBefore: ɵ32,
    addColumnAfter: ɵ33,
    addRowBefore: ɵ34,
    addRowAfter: ɵ35,
    deleteRow: ɵ36,
    deleteColumn: ɵ37,
    mergeCells: ɵ38,
    splitCell: ɵ39,
    deleteTable: ɵ40
};
/**
 * @hidden
 */
const editorCommands = Object.assign({}, inlineCommand, blockCommand, tableCommand);

/**
 * @hidden
 */
const getToolbarState = (state, options) => ({
    alignCenter: {
        selected: isAligned(state, alignCenterRules),
        disabled: false
    },
    alignJustify: {
        selected: isAligned(state, alignJustifyRules),
        disabled: false
    },
    alignLeft: {
        selected: isAligned(state, alignLeftRules),
        disabled: false
    },
    alignRight: {
        selected: isAligned(state, alignRightRules),
        disabled: false
    },
    bold: {
        selected: hasMark(state, bold),
        disabled: false
    },
    cleanFormatting: {
        selected: false,
        disabled: !cleanFormatting()(state)
    },
    format: {
        selected: activeNode(state),
        disabled: false
    },
    indent: {
        selected: false,
        disabled: !(canIndentAsListItem(state, state.schema.nodes.list_item) || canBeIndented(state, indentRules))
    },
    insertOrderedList: {
        selected: hasNode(state, state.schema.nodes.ordered_list),
        disabled: false
    },
    insertUnorderedList: {
        selected: hasNode(state, state.schema.nodes.bullet_list),
        disabled: false
    },
    italic: {
        selected: hasMark(state, italic),
        disabled: false
    },
    unlink: {
        selected: false,
        disabled: !hasMark(state, link)
    },
    outdent: {
        selected: false,
        disabled: !(canOutdentAsListItem(state, outdentRules) || canBeIndented(state, outdentRules))
    },
    redo: {
        selected: false,
        disabled: !redo(state)
    },
    selectAll: {
        selected: false,
        disabled: false
    },
    strikethrough: {
        selected: hasMark(state, strikethrough),
        disabled: false
    },
    style: {
        selected: getActiveMarks(state, state.schema.marks.style),
        disabled: false
    },
    subscript: {
        selected: hasMark(state, subscript),
        disabled: false
    },
    superscript: {
        selected: hasMark(state, superscript),
        disabled: false
    },
    underline: {
        selected: hasMark(state, underline),
        disabled: false
    },
    undo: {
        selected: false,
        disabled: !undo(state)
    },
    //dialogs
    createLink: {
        selected: false,
        get disabled() {
            const empty = state.selection.empty;
            const applyToWord = options && options.applyToWord;
            if (applyToWord && empty) {
                const extendedState = expandSelection(state, () => { }, options).state;
                return extendedState.selection.empty;
            }
            return empty;
        }
    },
    insertFile: {
        selected: false,
        disabled: state.selection.empty
    },
    insertImage: {
        selected: false,
        disabled: false
    },
    viewSource: {
        selected: false,
        disabled: false
    },
    // print
    print: {
        selected: false,
        disabled: false
    },
    // table
    insertTable: {
        selected: false,
        disabled: false
    },
    addColumnBefore: {
        selected: false,
        disabled: !addColumnBefore(state)
    },
    addColumnAfter: {
        selected: false,
        disabled: !addColumnAfter(state)
    },
    addRowBefore: {
        selected: false,
        disabled: !addRowBefore(state)
    },
    addRowAfter: {
        selected: false,
        disabled: !addRowAfter(state)
    },
    deleteRow: {
        selected: false,
        disabled: !deleteRow(state)
    },
    deleteColumn: {
        selected: false,
        disabled: !deleteColumn(state)
    },
    mergeCells: {
        selected: false,
        disabled: !mergeCells(state)
    },
    splitCell: {
        selected: false,
        disabled: !splitCell(state)
    },
    deleteTable: {
        selected: false,
        disabled: !deleteTable(state)
    }
});
/**
 * @hidden
 */
const initialToolBarState = {
    //alignment
    alignCenter: { selected: false, disabled: false },
    alignJustify: { selected: false, disabled: false },
    alignLeft: { selected: false, disabled: false },
    alignRight: { selected: false, disabled: false },
    //marks
    bold: { selected: false, disabled: false },
    italic: { selected: false, disabled: false },
    underline: { selected: false, disabled: false },
    strikethrough: { selected: false, disabled: false },
    subscript: { selected: false, disabled: false },
    superscript: { selected: false, disabled: false },
    //tools
    format: { selected: { text: 'Format', tag: null }, disabled: false },
    style: { selected: { marks: [], hasNodesWithoutMarks: false }, disabled: false },
    cleanFormatting: { selected: false, disabled: true },
    //indent
    indent: { selected: false, disabled: false },
    outdent: { selected: false, disabled: false },
    //lists
    insertOrderedList: { selected: false, disabled: false },
    insertUnorderedList: { selected: false, disabled: false },
    //links
    unlink: { selected: false, disabled: true },
    //history
    redo: { selected: false, disabled: true },
    undo: { selected: false, disabled: true },
    // print
    print: { selected: false, disabled: false },
    //dialogs
    createLink: { selected: false, disabled: true },
    insertFile: { selected: false, disabled: true },
    insertImage: { selected: false, disabled: false },
    viewSource: { selected: false, disabled: false },
    //table
    insertTable: { selected: false, disabled: false },
    addColumnBefore: { selected: false, disabled: true },
    addColumnAfter: { selected: false, disabled: true },
    addRowBefore: { selected: false, disabled: true },
    addRowAfter: { selected: false, disabled: true },
    deleteRow: { selected: false, disabled: true },
    deleteColumn: { selected: false, disabled: true },
    mergeCells: { selected: false, disabled: true },
    splitCell: { selected: false, disabled: true },
    deleteTable: { selected: false, disabled: true },
    // select all
    selectAll: { selected: false, disabled: false }
};
/**
 * @hidden
 */
const disabledToolBarState = {
    //alignment
    alignCenter: { selected: false, disabled: true },
    alignJustify: { selected: false, disabled: true },
    alignLeft: { selected: false, disabled: true },
    alignRight: { selected: false, disabled: true },
    //marks
    bold: { selected: false, disabled: true },
    italic: { selected: false, disabled: true },
    underline: { selected: false, disabled: true },
    strikethrough: { selected: false, disabled: true },
    subscript: { selected: false, disabled: true },
    superscript: { selected: false, disabled: true },
    //tools
    format: { selected: { text: 'Format', tag: null }, disabled: true },
    style: { selected: { marks: [], hasNodesWithoutMarks: false }, disabled: true },
    cleanFormatting: { selected: false, disabled: true },
    //indent
    indent: { selected: false, disabled: true },
    outdent: { selected: false, disabled: true },
    //lists
    insertOrderedList: { selected: false, disabled: true },
    insertUnorderedList: { selected: false, disabled: true },
    //links
    unlink: { selected: false, disabled: true },
    //history
    redo: { selected: false, disabled: true },
    undo: { selected: false, disabled: true },
    // print
    print: { selected: false, disabled: true },
    //dialogs
    createLink: { selected: false, disabled: true },
    insertFile: { selected: false, disabled: true },
    insertImage: { selected: false, disabled: true },
    viewSource: { selected: false, disabled: true },
    //table
    insertTable: { selected: false, disabled: true },
    addColumnBefore: { selected: false, disabled: true },
    addColumnAfter: { selected: false, disabled: true },
    addRowBefore: { selected: false, disabled: true },
    addRowAfter: { selected: false, disabled: true },
    deleteRow: { selected: false, disabled: true },
    deleteColumn: { selected: false, disabled: true },
    mergeCells: { selected: false, disabled: true },
    splitCell: { selected: false, disabled: true },
    deleteTable: { selected: false, disabled: true },
    // select all
    selectAll: { selected: false, disabled: true }
};

/**
 * @hidden
 */
let EditorLocalizationService = class EditorLocalizationService extends LocalizationService {
    constructor(prefix, messageService, _rtl) {
        super(prefix, messageService, _rtl);
    }
};
EditorLocalizationService.ɵfac = function EditorLocalizationService_Factory(t) { return new (t || EditorLocalizationService)(ɵngcc0.ɵɵinject(L10N_PREFIX), ɵngcc0.ɵɵinject(ɵngcc5.MessageService, 8), ɵngcc0.ɵɵinject(RTL, 8)); };
EditorLocalizationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: EditorLocalizationService, factory: function (t) { return EditorLocalizationService.ɵfac(t); } });
EditorLocalizationService = __decorate([
    __param(0, Inject(L10N_PREFIX)),
    __param(1, Optional()),
    __param(2, Optional()), __param(2, Inject(RTL)),
    __metadata("design:paramtypes", [String, MessageService, Boolean])
], EditorLocalizationService);

/**
 * @hidden
 */
let SourceDialogComponent = class SourceDialogComponent extends DialogContentBase {
    constructor(dialog, localization) {
        super(dialog);
        this.dialog = dialog;
        this.localization = localization;
        this.data = '';
    }
    ngAfterViewInit() {
        Promise.resolve(null).then(() => {
            this.textarea.nativeElement.focus();
        });
    }
    onCancelAction() {
        this.dialog.close();
    }
    onConfirmAction() {
        this.editor.exec('setHTML', this.getData());
        this.dialog.close();
        this.editor.view.focus();
    }
    getData() {
        return this.textarea.nativeElement.value;
    }
    setData() {
        this.data = this.indent(this.editor.getSource());
    }
    textFor(key) {
        return this.localization.get(key);
    }
    indent(content) {
        return content
            .replace(/<\/(p|li|ul|ol|h[1-6]|table|tr|td|th)>/gi, '</$1>\n')
            .replace(/<(ul|ol)([^>]*)><li/gi, '<$1$2>\n<li')
            .replace(/<br \/>/gi, '<br />\n')
            .replace(/\n$/, '');
    }
};
SourceDialogComponent.ɵfac = function SourceDialogComponent_Factory(t) { return new (t || SourceDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogRef), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService)); };
SourceDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SourceDialogComponent, selectors: [["ng-component"]], viewQuery: function SourceDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.textarea = _t.first);
    } }, inputs: { editor: "editor" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 5, consts: [[3, "close"], [1, "k-textarea", "k-editor-textarea", 3, "value"], ["textarea", ""], ["kendoButton", "", 3, "click"], ["kendoButton", "", 3, "primary", "click"]], template: function SourceDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dialog-titlebar", 0);
        ɵngcc0.ɵɵlistener("close", function SourceDialogComponent_Template_kendo_dialog_titlebar_close_0_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(2, "textarea", 1, 2);
        ɵngcc0.ɵɵelementStart(4, "kendo-dialog-actions")(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function SourceDialogComponent_Template_button_click_5_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 4);
        ɵngcc0.ɵɵlistener("click", function SourceDialogComponent_Template_button_click_7_listener() { return ctx.onConfirmAction(); });
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor("viewSource"), " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("value", ctx.data);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogCancel"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("primary", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogUpdate"));
    } }, directives: [ɵngcc1.DialogTitleBarComponent, ɵngcc1.DialogActionsComponent, ɵngcc2.ButtonDirective], styles: [".k-editor-textarea {\n                height: 100%;\n            }"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], SourceDialogComponent.prototype, "editor", void 0);
__decorate([
    ViewChild('textarea', { static: true }),
    __metadata("design:type", ElementRef)
], SourceDialogComponent.prototype, "textarea", void 0);
SourceDialogComponent = __decorate([ __metadata("design:paramtypes", [DialogRef,
        EditorLocalizationService])
], SourceDialogComponent);

/**
 * @hidden
 */
let ImageDialogComponent = class ImageDialogComponent extends DialogContentBase {
    constructor(dialog, localization) {
        super(dialog);
        this.dialog = dialog;
        this.localization = localization;
        this.src = new FormControl('', Validators.required);
        this.alt = new FormControl('');
        this.width = new FormControl('', Validators.min(1));
        this.height = new FormControl('', Validators.min(1));
        this.data = {
            alt: '',
            height: '',
            src: '',
            width: ''
        };
        this.imageData = new FormGroup({
            alt: this.alt,
            height: this.height,
            src: this.src,
            width: this.width
        });
    }
    ngOnInit() {
        this.srcInputId = `k-${guid()}`;
        this.altTextInputId = `k-${guid()}`;
        this.widthInputId = `k-${guid()}`;
        this.heightInputId = `k-${guid()}`;
    }
    ngAfterViewInit() {
        Promise.resolve(null).then(() => {
            this.srcInput.nativeElement.focus();
        });
    }
    onCancelAction() {
        this.dialog.close();
    }
    onConfirmAction() {
        if (this.src.value) {
            this.editor.exec('insertImage', this.getData());
            this.dialog.close();
            this.editor.view.focus();
        }
    }
    setData(state) {
        const node = getNodeFromSelection(state);
        if (node) {
            this.src.patchValue(node.attrs.src);
            this.alt.patchValue(node.attrs.alt);
            this.width.patchValue(node.attrs.width);
            this.height.patchValue(node.attrs.height);
        }
    }
    textFor(key) {
        return this.localization.get(key);
    }
    getData() {
        return {
            alt: this.alt.value,
            height: this.normalizeDimension(this.height.value),
            src: this.src.value,
            width: this.normalizeDimension(this.width.value)
        };
    }
    normalizeDimension(value) {
        return Number.isNaN(parseInt(value, 10)) || parseInt(value, 10) <= 0 ? '' : safeString(parseInt(value, 10));
    }
};
ImageDialogComponent.ɵfac = function ImageDialogComponent_Factory(t) { return new (t || ImageDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogRef), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService)); };
ImageDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ImageDialogComponent, selectors: [["ng-component"]], viewQuery: function ImageDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.srcInput = _t.first);
    } }, inputs: { editor: "editor" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 31, vars: 21, consts: [[3, "close"], [1, "k-editor-dialog"], [1, "k-editor-dialog", "k-popup-edit-form", "k-window-content", "k-content"], [1, "k-edit-form-container", "k-window-content"], [1, "k-edit-label"], [3, "for"], [1, "k-edit-field"], ["type", "text", 1, "k-textbox", 3, "id", "formControl"], ["srcInput", ""], ["kendoButton", "", 3, "click"], ["kendoButton", "", 3, "disabled", "primary", "click"]], template: function ImageDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dialog-titlebar", 0);
        ɵngcc0.ɵɵlistener("close", function ImageDialogComponent_Template_kendo_dialog_titlebar_close_0_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "div", 3)(5, "div", 4)(6, "label", 5);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelement(9, "input", 7, 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 4)(12, "label", 5);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(14, "div", 6);
        ɵngcc0.ɵɵelement(15, "input", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 4)(17, "label", 5);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(19, "div", 6);
        ɵngcc0.ɵɵelement(20, "input", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 4)(22, "label", 5);
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(24, "div", 6);
        ɵngcc0.ɵɵelement(25, "input", 7);
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(26, "kendo-dialog-actions")(27, "button", 9);
        ɵngcc0.ɵɵlistener("click", function ImageDialogComponent_Template_button_click_27_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(28);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "button", 10);
        ɵngcc0.ɵɵlistener("click", function ImageDialogComponent_Template_button_click_29_listener() { return ctx.onConfirmAction(); });
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor("insertImage"), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("for", ctx.srcInputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("imageWebAddress"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("id", ctx.srcInputId)("formControl", ctx.src);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("for", ctx.altTextInputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("imageAltText"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("id", ctx.altTextInputId)("formControl", ctx.alt);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("for", ctx.widthInputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("imageWidth"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("id", ctx.widthInputId)("formControl", ctx.width);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("for", ctx.heightInputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("imageHeight"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("id", ctx.heightInputId)("formControl", ctx.height);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogCancel"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.imageData.invalid)("primary", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogInsert"));
    } }, directives: [ɵngcc1.DialogTitleBarComponent, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlDirective, ɵngcc1.DialogActionsComponent, ɵngcc2.ButtonDirective], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], ImageDialogComponent.prototype, "editor", void 0);
__decorate([
    ViewChild('srcInput', { read: ElementRef, static: true }),
    __metadata("design:type", ElementRef)
], ImageDialogComponent.prototype, "srcInput", void 0);
ImageDialogComponent = __decorate([ __metadata("design:paramtypes", [DialogRef,
        EditorLocalizationService])
], ImageDialogComponent);

/**
 * @hidden
 */
let FileLinkDialogComponent = class FileLinkDialogComponent extends DialogContentBase {
    constructor(dialog, localization) {
        super(dialog);
        this.dialog = dialog;
        this.localization = localization;
        this.linkForm = new FormGroup({
            'href': new FormControl('', Validators.required),
            'text': new FormControl({ value: '', disabled: true }, Validators.required),
            'title': new FormControl('')
        });
    }
    ngAfterViewInit() {
        Promise.resolve(null).then(() => {
            this.hrefInput.nativeElement.focus();
        });
    }
    onCancelAction() {
        this.dialog.close();
    }
    onConfirmAction() {
        const linkData = this.getData();
        this.editor.exec(this.command, linkData);
        this.dialog.close();
        this.editor.view.focus();
    }
    get titleText() {
        return this.localization.get(this.command);
    }
    setData(state, options) {
        if (this.command === 'createLink') {
            this.linkForm.addControl('target', new FormControl());
        }
        const linkMark = getMark(state, state.schema.marks.link);
        if (linkMark) {
            // const linkMarkRange = getMarkRange(state.selection.$cursor, schema.marks.link);
            // const mark = parentNode.child(cursorNodeIndex).marks.find(m => m.type === markType);
            this.linkForm.reset({
                href: linkMark.attrs.href,
                title: linkMark.attrs.title,
                target: isPresent(linkMark.attrs.target),
                text: this.setLinkText(state)
            });
            return;
        }
        if (state.selection.empty) {
            const currentState = options.applyToWord ? expandSelection(state, () => { }, options).state : state;
            if (!currentState.selection.empty) {
                this.linkForm.patchValue({
                    'text': getSelectionText(currentState)
                });
            }
        }
        else {
            this.linkForm.patchValue({
                'text': getSelectionText(state)
            });
        }
    }
    textForWithPrefix(key) {
        const prefix = this.command === 'createLink' ? 'link' : 'file';
        return this.textFor(prefix + key);
    }
    textFor(key) {
        return this.localization.get(key);
    }
    setLinkText(state) {
        const selection = state.selection;
        if (selection.empty && selection.$cursor) {
            const cursor = selection.$cursor;
            const cursorNodeIndex = cursor.index();
            const parentNode = cursor.parent;
            return parentNode.child(cursorNodeIndex).text;
        }
        else {
            return getSelectionText(state);
        }
    }
    getData() {
        let linkData = this.linkForm.value;
        if (isPresent(this.linkForm.controls.target)) {
            linkData.target = linkData.target ? '_blank' : null;
        }
        return linkData;
    }
};
FileLinkDialogComponent.ɵfac = function FileLinkDialogComponent_Factory(t) { return new (t || FileLinkDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogRef), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService)); };
FileLinkDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FileLinkDialogComponent, selectors: [["ng-component"]], viewQuery: function FileLinkDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.hrefInput = _t.first);
    } }, inputs: { editor: "editor", command: "command" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 30, vars: 10, consts: [[3, "close"], [1, "k-editor-dialog"], [1, "k-editor-dialog", "k-popup-edit-form", "k-window-content", "k-content"], [1, "k-edit-form-container", "k-window-content"], ["novalidate", "", 3, "formGroup"], [1, "k-edit-label"], [3, "click"], [1, "k-edit-field"], ["formControlName", "href", "type", "text", 1, "k-textbox"], ["hrefInput", ""], ["formControlName", "text", "type", "text", 1, "k-textbox"], ["textInput", ""], ["formControlName", "title", "type", "text", 1, "k-textbox"], ["titleInput", ""], [4, "ngIf"], ["kendoButton", "", 3, "click"], ["kendoButton", "", 3, "disabled", "primary", "click"], ["type", "checkbox", "id", "k-target-blank", "formControlName", "target", 1, "k-checkbox"], ["for", "k-target-blank", 1, "k-checkbox-label"]], template: function FileLinkDialogComponent_Template(rf, ctx) { if (rf & 1) {
        const _r4 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "kendo-dialog-titlebar", 0);
        ɵngcc0.ɵɵlistener("close", function FileLinkDialogComponent_Template_kendo_dialog_titlebar_close_0_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "div", 3)(5, "form", 4)(6, "div", 5)(7, "label", 6);
        ɵngcc0.ɵɵlistener("click", function FileLinkDialogComponent_Template_label_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r4); const _r0 = ɵngcc0.ɵɵreference(11); return _r0.focus(); });
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelement(10, "input", 8, 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 5)(13, "label", 6);
        ɵngcc0.ɵɵlistener("click", function FileLinkDialogComponent_Template_label_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r4); const _r1 = ɵngcc0.ɵɵreference(17); return _r1.focus(); });
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(15, "div", 7);
        ɵngcc0.ɵɵelement(16, "input", 10, 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 5)(19, "label", 6);
        ɵngcc0.ɵɵlistener("click", function FileLinkDialogComponent_Template_label_click_19_listener() { ɵngcc0.ɵɵrestoreView(_r4); const _r2 = ɵngcc0.ɵɵreference(23); return _r2.focus(); });
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(21, "div", 7);
        ɵngcc0.ɵɵelement(22, "input", 12, 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(24, FileLinkDialogComponent_ng_container_24_Template, 6, 1, "ng-container", 14);
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(25, "kendo-dialog-actions")(26, "button", 15);
        ɵngcc0.ɵɵlistener("click", function FileLinkDialogComponent_Template_button_click_26_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(27);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "button", 16);
        ɵngcc0.ɵɵlistener("click", function FileLinkDialogComponent_Template_button_click_28_listener() { return ctx.onConfirmAction(); });
        ɵngcc0.ɵɵtext(29);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.titleText, " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("formGroup", ctx.linkForm);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.textForWithPrefix("WebAddress"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.textForWithPrefix("Text"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.textForWithPrefix("Title"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.command === "createLink");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogCancel"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.linkForm.invalid)("primary", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor("dialogInsert"), " ");
    } }, directives: [ɵngcc1.DialogTitleBarComponent, ɵngcc3.ɵNgNoValidate, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc4.NgIf, ɵngcc3.CheckboxControlValueAccessor, ɵngcc1.DialogActionsComponent, ɵngcc2.ButtonDirective], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], FileLinkDialogComponent.prototype, "editor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FileLinkDialogComponent.prototype, "command", void 0);
__decorate([
    ViewChild('hrefInput', { read: ElementRef, static: true }),
    __metadata("design:type", ElementRef)
], FileLinkDialogComponent.prototype, "hrefInput", void 0);
FileLinkDialogComponent = __decorate([ __metadata("design:paramtypes", [DialogRef, EditorLocalizationService])
], FileLinkDialogComponent);

/**
 * @hidden
 */
const defaultStyle = `
html, body {
    margin: 0;
    height: 100%;
    padding: 0;
}

html {
  min-height: 100%;
}

body {
  box-sizing: border-box;
  position: relative;
  padding: 8px;
}

.ProseMirror-selectednode {
  outline: 2px solid #8cf;
}

div.ProseMirror {
  position: relative;
  min-height: 100%;
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

div.ProseMirror:focus {
  outline: none;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

.ProseMirror-hideselection *::selection { background: transparent; }
.ProseMirror-hideselection *::-moz-selection { background: transparent; }
.ProseMirror-hideselection { caret-color: transparent; }

.ProseMirror li {
  position: relative;
}

li.ProseMirror-selectednode {
  outline: none;
}

li.ProseMirror-selectednode:after {
  content: "";
  position: absolute;
  left: -32px;
  right: -2px;
  top: -2px;
  bottom: -2px;
  border: 2px solid #8cf;
  pointer-events: none;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.ProseMirror .k-placeholder::before {
    content: attr(data-placeholder);
    height: 0;
    color: #8a8a8a;
    float: left;
    opacity: 1;
    cursor: text;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* image resizing */
.k-editor-resize-handles-wrapper {
    position: absolute;
    visibility: hidden;
}

.k-editor-resize-handle {
    position: absolute;
    visibility: visible;
    background-color: #fff;
    border: 1px solid #000;
    z-index: 100;
    width: 5px;
    height: 5px;
}

.k-editor-resize-handle.northwest {
    top: 0;
    left: 0;
    transform: translate(-50%, -50%);
    cursor: nw-resize;
}

.k-editor-resize-handle.north {
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: n-resize;
}

.k-editor-resize-handle.northeast {
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    cursor: ne-resize;
}

.k-editor-resize-handle.southwest {
    left: 0;
    bottom: 0;
    transform: translate(-50%, 50%);
    cursor: sw-resize;
}

.k-editor-resize-handle.south {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    cursor: s-resize;
}

.k-editor-resize-handle.southeast {
    right: 0;
    bottom: 0;
    transform: translate(50%, 50%);
    cursor: se-resize;
}

.k-editor-resize-handle.west {
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    cursor: w-resize;
}

.k-editor-resize-handle.east {
    top: 50%;
    right: 0;
    transform: translate(50%, -50%);
    cursor: e-resize;
}
`;
/**
 * @hidden
 */
const tablesStyles = `
  .ProseMirror .tableWrapper {
    overflow-x: auto;
    margin: 1em 0;
  }

  .ProseMirror table {
    margin: 0;
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    overflow: hidden;
  }

  .ProseMirror td, .ProseMirror th {
    min-width: 1em;
    border: 1px solid #ddd;
    padding: 3px 5px;
    vertical-align: top;
    box-sizing: border-box;
    position: relative;
  }

  .ProseMirror th {
    font-weight: bold;
    text-align: left;
  }

  .ProseMirror .column-resize-handle {
    position: absolute;
    right: -2px;
    top: 0;
    bottom: 0;
    width: 4px;
    z-index: 20;
    background-color: #adf;
    pointer-events: none;
  }

  .ProseMirror.resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }

  /* Give selected cells a blue overlay */
  .ProseMirror .selectedCell:after {
    z-index: 2;
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(200, 200, 255, 0.4);
    pointer-events: none;
  }
`;
/**
 * @hidden
 */
const rtlStyles = 'body { direction: rtl }';

const ɵ0$6 = (arg) => `plugins must be a function, but received ${JSON.stringify(arg)}.`;
/* tslint:disable:variable-name */
/**
 * @hidden
 */
const EditorErrorMessages = {
    schemaType: 'Expected value of type Schema. See http://www.telerik.com/kendo-angular-ui/components/editor/schema/',
    setSchemaOnce: 'The Schema cannot be changed dynamically. See http://www.telerik.com/kendo-angular-ui/components/editor/schema/',
    pluginsCallbackType: ɵ0$6,
    setPluginsOnce: 'The plugins cannot be changed dynamically. See http://www.telerik.com/kendo-angular-ui/components/editor/plugins/',
    setPlaceHolderOnce: 'The placeholder cannot be changed dynamically. See http://www.telerik.com/kendo-angular-ui/components/editor/placeholder/',
    printTool: 'The Print tool and functionality are supported only in iframe mode. See https://www.telerik.com/kendo-angular-ui-develop/components/editor/api/EditorPrintButtonDirective/'
};

/**
 * @hidden
 */
let EditorToolsService = class EditorToolsService {
    /**
     * @hidden
     */
    constructor() {
        this.needsCheck = new Subject();
    }
};
EditorToolsService.ɵfac = function EditorToolsService_Factory(t) { return new (t || EditorToolsService)(); };
EditorToolsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: EditorToolsService, factory: function (t) { return EditorToolsService.ɵfac(t); } });

var EditorComponent_1;
const EMPTY_PARAGRAPH = '<p></p>';
const defaultPasteCleanupSettings = {
    convertMsLists: false,
    removeAttributes: [],
    removeHtmlComments: false,
    removeInvalidHTML: false,
    removeMsClasses: false,
    removeMsStyles: false,
    stripTags: ['']
};
const removeCommentsIf = conditionallyExecute(removeComments);
const removeInvalidHTMLIf = conditionallyExecute(sanitize);
const getPasteCleanupAttributes = (config) => {
    if (config.removeAttributes === 'all') {
        return { '*': removeAttribute };
    }
    const initial = removeEmptyEntries({
        style: config.removeMsStyles ? sanitizeStyleAttr : undefined,
        class: config.removeMsClasses ? sanitizeClassAttr : undefined
    });
    return config.removeAttributes.reduce((acc, curr) => (Object.assign({}, acc, { [curr]: removeAttribute })), initial);
};
/**
 * Represents the [Kendo UI Editor component for Angular]({% slug overview_editor %}).
 */
let EditorComponent = EditorComponent_1 = class EditorComponent {
    constructor(dialogService, localization, cdr, ngZone, element, toolsService) {
        this.dialogService = dialogService;
        this.localization = localization;
        this.cdr = cdr;
        this.ngZone = ngZone;
        this.element = element;
        this.toolsService = toolsService;
        /**
         * If set to `false`, the Editor will run in style non-encapsulated mode. This means
         * that the styles of the page will be persisted in the Editor and its content will be affected by them.
         * @default true
         */
        this.iframe = true;
        /**
         * If set to `true` or `ApplyToWordOptions` object, commands that apply emphasis or inline styles will be applied to the whole word the cursor is in.
         * @default false
         */
        this.applyToWord = false;
        /**
         * By design, the Editor emits `valueChange`, updates the model and the ToolBar state on each keystroke.
         * When you are interested in ignoring the new values for a given amout of time and take only the most recent one, you can use the `updateInterval` property.
         * A possible use case is to get the new values and to update the ToolBar state at a maximum rate per second in order to speed up your application.
         * The specified interval (in milliseconds) should be a positive number.
         * By default the `updateInterval` is set to 100 miliseconds. If set to zero the delay will be disabled entirely.
         */
        this.updateInterval = 100;
        /**
         * By default, whitespace is collapsed as per HTML's rules.
         * Set to `true` to preserve whitespace, but normalize newlines to spaces.
         * Set to `'full'` to preserve whitespace entirely. In this case the default ProseMirror behavior is to parse white space into nodes.
         *
         * @default false
         */
        this.preserveWhitespace = false;
        /**
         * Determines whether the Editor can be resized ([see example]({% slug styling_editor %}#toc-resizable-editor)).
         * @default false
         */
        this.resizable = false;
        /**
         * Fires each time the value of the Editor is changed upon user interaction&mdash;
         * for example, when the value is updated through typing in the content area or using some of the Editor tools ([see example]({% slug overview_editor %}#toc-events)).
         * When the value of the Editor is programmatically changed through its API (`ngModel`) or form binding (`formControl`),
         * the `valueChange` event is not triggered because it might cause a mix-up with the
         * built-in `valueChange` mechanisms of the `ngModel` or `formControl` bindings.
         */
        this.valueChange = new EventEmitter();
        /**
         * Fires when the content area of the Editor is focused ([see example]({% slug overview_editor %}#toc-events)).
         */
        this.onFocus = new EventEmitter();
        /**
         * Fires when the content area of the Editor is blurred ([see example]({% slug overview_editor %}#toc-events)).
         */
        this.onBlur = new EventEmitter();
        this.hostClass = true;
        /**
         * @hidden
         */
        this.stateChange = new BehaviorSubject(initialToolBarState);
        /**
         * @hidden
         */
        this.valueModified = new Subject();
        this._readonly = false;
        this._placeholder = '';
        this.afterViewInit = new Subject();
        this.contentAreaLoaded = new Subject();
        this.onChangeCallback = (_) => { }; // tslint:disable-line:no-empty
        this.onTouchedCallback = (_) => { }; // tslint:disable-line:no-empty
        validatePackage(packageMetadata);
        this.direction = localization.rtl ? 'rtl' : 'ltr';
        // https://stackoverflow.com/questions/56572483/chrome-is-synchronously-handling-iframe-loading-whereas-firefox-handles-it-asyn
        this.subs = zip(this.afterViewInit.asObservable(), this.contentAreaLoaded.asObservable()).subscribe(() => this.initialize());
    }
    /**
     * Sets the value of the Editor ([see example]({% slug overview_editor %}#toc-basic-usage)).
     */
    set value(value) {
        if (this._previousValue === value) {
            return;
        }
        this._value = value;
        this._previousValue = value;
        if (this._view) {
            const iframeContentWindowNotPresent = this.iframe && !this.container.element.nativeElement.contentWindow;
            if (iframeContentWindowNotPresent) {
                return;
            }
            this.exec('setHTML', {
                content: this._value || '',
                parseOptions: {
                    preserveWhitespace: this.preserveWhitespace
                }
            });
        }
    }
    get value() {
        let value = this._view ? this.getSource() : this._value;
        if (value === EMPTY_PARAGRAPH) {
            return this._value ? '' : this._value;
        }
        else {
            return value;
        }
    }
    /**
     * Sets the disabled state of the component.
     */
    set disabled(value) {
        this._disabled = value || false;
        if (this._view) {
            this._view.updateState(this._view.state);
        }
        if (this._disabled) {
            this.readonly = false;
        }
        if (this._disabled || this._readonly) {
            this.stateChange.next(disabledToolBarState);
        }
        else {
            this.stateChange.next(initialToolBarState);
        }
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * Sets the read-only state of the component.
     */
    set readonly(value) {
        this._readonly = value || false;
        if (this._view) {
            // remove DOM selection
            let win;
            if (this.iframe) {
                win = this.container.element.nativeElement.contentWindow;
            }
            else {
                win = window;
            }
            const focusedNode = win.getSelection().focusNode;
            if (this._view.dom.contains(focusedNode)) {
                win.getSelection().removeAllRanges();
            }
            // remove ProseMirror selection
            const doc = this._view.state.doc;
            const tr = this._view.state.tr.setSelection(TextSelection.create(doc, 1));
            this._view.dispatch(tr);
        }
        if (this._readonly) {
            if (this.toolbar) {
                this.toolbar.tabindex = -1;
            }
            this.stateChange.next(disabledToolBarState);
        }
        else {
            if (this.toolbar) {
                this.toolbar.tabindex = 0;
            }
            this.stateChange.next(initialToolBarState);
        }
    }
    get readonly() {
        return this._readonly;
    }
    /**
     * Allows providing a custom schema. ([see example]({% slug schema_editor %}))
     */
    set schema(value) {
        if (isDevMode) {
            if (!(value instanceof Schema)) {
                throw new Error(EditorErrorMessages.schemaType);
            }
            if (this._view) {
                throw new Error(EditorErrorMessages.setSchemaOnce);
            }
        }
        this._schema = value;
    }
    get schema() {
        return this._schema;
    }
    /**
     * Defines a function which determines the plugins that will be used when initializing the Editor.
     * It exposes the default plugins collection as an argument, and returns
     * the plugins collection that will be used when creating the Editor component. ([see example]({% slug plugins_editor %}))
     *
     * ```ts-no-run
     *  pluginsCallback(defaultPlugins: Plugin[]): Plugin[] {
     *    const myPlugin = new Plugin({/custom plugin code/});
     *    return [...defaultPlugins, myPlugin];
     *  }
     * ```
     */
    set plugins(fn) {
        if (isDevMode) {
            if (typeof fn !== 'function') {
                throw new Error(EditorErrorMessages.pluginsCallbackType(fn));
            }
            if (this._view) {
                throw new Error(EditorErrorMessages.setPluginsOnce);
            }
        }
        this._plugins = fn;
    }
    get plugins() {
        return this._plugins;
    }
    /**
     * The hint, which is displayed when the component is empty.
     */
    set placeholder(value) {
        if (isDevMode && this._view) {
            throw new Error(EditorErrorMessages.setPlaceHolderOnce);
        }
        this._placeholder = value;
    }
    get placeholder() {
        return this._placeholder;
    }
    get resizableClass() {
        return !!this.resizable;
    }
    get isDisabled() {
        return this.disabled;
    }
    get isReadonly() {
        return this.readonly;
    }
    get isIE() {
        return this.iframe && detectIE();
    }
    get dir() {
        return this.direction;
    }
    get ariaDisabled() {
        return this.disabled;
    }
    get minWidth() {
        const resizableOptions = this.resizable;
        return resizableOptions.minWidth ? resizableOptions.minWidth + 'px' : undefined;
    }
    get maxWidth() {
        const resizableOptions = this.resizable;
        return resizableOptions.maxWidth ? resizableOptions.maxWidth + 'px' : undefined;
    }
    get minHeight() {
        const resizableOptions = this.resizable;
        return resizableOptions.minHeight ? resizableOptions.minHeight + 'px' : undefined;
    }
    get maxHeight() {
        const resizableOptions = this.resizable;
        return resizableOptions.maxHeight ? resizableOptions.maxHeight + 'px' : undefined;
    }
    get toolbar() {
        return this.defaultToolbarComponent || this.userToolBarComponent;
    }
    /**
     * Returns the ProseMirror [EditorView](https://prosemirror.net/docs/ref/#view.EditorView) object
     * that manages the DOM structure that represents an editable document.
     */
    get view() {
        return this._view;
    }
    /**
     * Returns the text which the current Editor selection contains ([see example]({% slug selection_editor %}#toc-retrieve-the-selected-text)).
     */
    get selectionText() {
        return this._view && this._view.state ? getSelectionText(this._view.state) : '';
    }
    ngOnInit() {
        this.subs.add(this.localization.changes.subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
        }));
        this.subs.add(this.toolsService.needsCheck.subscribe(() => this.cdr.markForCheck()));
    }
    ngAfterViewInit() {
        this.afterViewInit.next();
        if (!this.iframe) {
            this.contentAreaLoaded.next();
        }
        if (this.resizable) {
            this.normalizeSize();
        }
    }
    ngOnChanges(changes) {
        if (changes.iframe && !changes.iframe.isFirstChange()) {
            this.ngZone.onStable.pipe(take(1)).subscribe(() => this.initialize());
        }
        if (changes.resizable && !changes.resizable.isFirstChange()) {
            this.normalizeSize();
        }
    }
    /**
     * @hidden
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @hidden
     */
    iframeOnLoad() {
        this.contentAreaLoaded.next();
    }
    /**
     * Executes a command on the currently selected text
     * ([more information and example]({% slug toolbartools_editor %}#toc-custom-tools)).
     *
     * @param {EditorCommand} commandName - The command that will be executed.
     * @param {any} attr - Optional parameters for the command. Apart from the following list,
     * the parameters do not expect specific attributes when you call them:
     * - `format` - Accepts an object with the `tag` property.
     * The supported tags are `p`, `blockquote`, and any of the `h1` to `h6` heading tags.
     * - `createLink` - Accepts an object with the `href`, `title`, and `target` properties. The `href` property is mandatory.
     * - `setHTML` - Accepts a `string` parameter.
     * - `insertTable` - Accepts an object with the `rows` and `cols` properties. The number values are zero based.
     *
     * @example
     * ```ts-no-run
     * // Toggles the bold styling.
     * editor.exec('bold');
     *
     * // Creates a bullet list.
     * editor.exec('insertUnorderedList');
     *
     * // Creates a link.
     * editor.exec('createLink', { href: 'www.progress.com', title: 'Progress', target: 'window' });
     *
     * // Inserts a file.
     * editor.exec('insertFile', { href: 'www.progress.com/resources/myfile.doc', title: 'My file', target: 'window' });
     *
     * // Inserts a image.
     * editor.exec('insertImage', { src: 'www.progress.com/resources/logo.jpg', title: 'Progress', target: 'window' });
     *
     * // Inserts a text at a given position. If no position is specified, the text will be inserted after the cursor.
     * editor.exec('insertText', { text: 'Hello World!', from: 0, to: 0 });
     *
     * // Changes the format of a text block.
     * editor.exec('format', { tag: 'h2' });
     *
     * // Changes the font size of the selected text.
     * editor.exec('fontSize', 24);
     *
     * // Changes the content of the Editor.
     * editor.exec('setHTML', '<p>HTML content</p>');
     *
     * // Creates and inserts a table with the specified number of rows and columns. Numbers are zero based.
     * this.editor.exec("insertTable", { rows: 3, cols: 5 });
     * ```
     */
    exec(commandName, attr) {
        // normalizes setHTML attributes
        if (commandName === 'setHTML' && typeof attr === 'string') {
            attr = {
                content: attr,
                parseOptions: {
                    preserveWhitespace: this.preserveWhitespace
                }
            };
        }
        else if (['fontFamily', 'fontSize', 'foreColor', 'backColor', 'createLink'].some(name => name === commandName)) {
            attr = {
                value: attr,
                applyToWord: this.applyToWord
            };
        }
        // Finds a command and applies the attributes.
        const command = editorCommands[commandName](attr);
        // Executes a ProseMirror command.
        command(this._view.state, this._view.dispatch, this._view);
        // See the `dispatchTransaction` comments.
        // this.stateChange.emit(updateToolBar(this.view));
    }
    /**
     * Opens a dialog.
     * @param {DialogCommand} dialogName - The name of the dialog that will open.
     *
     * The supported values are:
     * * `createLink`
     * * `viewSource`
     * * `insertFile`
     * * `insertImage`
     * * `tableWizard`
     *
     * @example
     * ```ts-no-run
     * // Opens a `createLink` dialog.
     * editor.openDialog('createLink');
     *
     * // Opens a `viewSource` dialog.
     * editor.openDialog('viewSource');
     * ```
     */
    openDialog(dialogName) {
        const editorDialogs = {
            createLink: {
                content: FileLinkDialogComponent
            },
            insertFile: {
                content: FileLinkDialogComponent
            },
            insertImage: {
                content: ImageDialogComponent
            },
            viewSource: {
                content: SourceDialogComponent,
                height: 400,
                width: 500
            }
            // tableWizard: {
            //     content: TableWizardDialogComponent
            // }
        };
        const dialog = Object.assign({ appendTo: this.dialogContainer }, editorDialogs[dialogName]);
        this.toolbar.toggle(false);
        const dialogContent = this.dialogService.open(dialog).content.instance;
        if (dialogName === 'createLink' || dialogName === 'insertFile') {
            dialogContent.command = dialogName;
        }
        dialogContent.editor = this;
        dialogContent.setData(this._view.state, { applyToWord: this.applyToWord });
    }
    /**
     * Manually focus the Editor.
     */
    focus() {
        this.focusChangedProgrammatically = true;
        this._view.focus();
        this.focusChangedProgrammatically = false;
    }
    /**
     * Manually blur the Editor.
     */
    blur() {
        this.focusChangedProgrammatically = true;
        this._view.dom.blur();
        this.focusChangedProgrammatically = false;
    }
    /**
     * @hidden
     */
    getSource() {
        return getHtml(this._view.state);
    }
    ngOnDestroy() {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (this._styleObserver) {
            this._styleObserver.disconnect();
        }
    }
    /**
     * @hidden
     */
    writeValue(value) {
        // To avoid confusion, non-existent values are always undefined.
        this.value = value === null ? undefined : value;
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    /**
     * @hidden
     * Used by the TextBoxContainer to determine if the component is empty.
     */
    isEmpty() {
        return false;
    }
    initialize() {
        if (!isDocumentAvailable()) {
            return;
        }
        const currentSchema = this.schema || schema;
        const that = this;
        const containerNativeElement = this.container.element.nativeElement;
        const contentNode = parseContent((this.value || '').trim(), currentSchema, { preserveWhitespace: this.preserveWhitespace });
        if (this.iframe) {
            const iframeDoc = containerNativeElement.contentDocument;
            const meta = iframeDoc.createElement('meta');
            meta.setAttribute('charset', 'utf-8');
            iframeDoc.head.appendChild(meta);
            [defaultStyle, tablesStyles, this.dir === 'rtl' ? rtlStyles : undefined].forEach(styles => {
                if (styles) {
                    const style = iframeDoc.createElement('style');
                    style.appendChild(iframeDoc.createTextNode(styles));
                    iframeDoc.head.appendChild(style);
                }
            });
            const element = iframeDoc.createElement('div');
            iframeDoc.body.appendChild(element);
        }
        else {
            const element = document.createElement('div');
            containerNativeElement.appendChild(element);
        }
        const defaultPlugins = [
            new Plugin({
                key: new PluginKey('editor-tabindex'),
                props: {
                    attributes: () => ({
                        // set tabindex when contenteditable is false, so that the content area can be selected
                        tabIndex: this.readonly ? '0' : ''
                    })
                }
            }),
            new Plugin({
                key: new PluginKey('toolbar-tools-update'),
                view: () => ({
                    update: editorView => {
                        if (!this.disabled) {
                            this.stateChange.next(this.readonly ? disabledToolBarState : getToolbarState(editorView.state, { applyToWord: this.applyToWord }));
                        }
                    }
                })
            }),
            new Plugin({
                key: new PluginKey('editor-filter-disabled-state'),
                filterTransaction: () => !this.disabled
            }),
            history(),
            keymap(buildListKeymap(currentSchema)),
            keymap(buildKeymap(currentSchema, { applyToWord: this.applyToWord })),
            keymap(baseKeymap),
            gapCursor(),
            imageResizing()
        ];
        if (this.placeholder) {
            defaultPlugins.push(placeholder(this.placeholder));
        }
        const state = EditorState.create({
            schema: currentSchema,
            doc: contentNode,
            plugins: isPresent(this.plugins) ? this.plugins(defaultPlugins) : defaultPlugins
        });
        if (this.iframe) {
            this.viewMountElement = containerNativeElement.contentDocument.querySelector('div');
        }
        else {
            this.viewMountElement = containerNativeElement.querySelector('div');
        }
        this.ngZone.runOutsideAngular(() => {
            this._view = new EditorView({ mount: this.viewMountElement }, {
                state,
                editable: () => !this.readonly,
                dispatchTransaction: function (tr) {
                    // `this` is bound to the view instance.
                    this.updateState(this.state.apply(tr));
                    // that.cdr.detectChanges();
                    // When the user utilizes keyboard shortcuts&mdash;for example, `Ctrl`+`b`&mdash;
                    // `tr.docChanged` is `true` and the toolbar is not updated.
                    // A possible future solution is to move the keymaps to the service.
                    // if (!tr.docChanged) {
                    //     that.stateChange.emit(updateToolBar(that.view));
                    // }
                    const value = that.value;
                    if (!hasSameMarkup(value, that._previousValue, this.state.schema)) {
                        that._previousValue = value;
                        that.ngZone.run(() => that.valueModified.next(value));
                    }
                },
                transformPastedHTML: (html) => {
                    const pasteCleanupSettings = Object.assign({}, defaultPasteCleanupSettings, this.pasteCleanupSettings);
                    const clean = pipe(removeCommentsIf(pasteCleanupSettings.removeHtmlComments), removeInvalidHTMLIf(pasteCleanupSettings.removeInvalidHTML))(html);
                    const attributes = getPasteCleanupAttributes(pasteCleanupSettings);
                    return pasteCleanup(clean, {
                        convertMsLists: pasteCleanupSettings.convertMsLists,
                        stripTags: pasteCleanupSettings.stripTags.join('|'),
                        attributes
                    });
                }
            });
        });
        if (this._view) {
            let containerElement;
            const contentAreaClasslist = this.element.nativeElement.querySelector('.k-editor-content').classList;
            if (this.iframe) {
                containerElement = this.container.element.nativeElement.contentDocument;
            }
            else {
                containerElement = this.container.element.nativeElement;
            }
            this.subs.add(fromEvent(containerElement, 'focusin')
                .subscribe(() => {
                if (this.readonly) {
                    contentAreaClasslist.add('k-state-focused');
                }
                if (!this.focusChangedProgrammatically || this.shouldEmitFocus) {
                    this.ngZone.run(() => this.onFocus.emit());
                    this.shouldEmitFocus = false;
                }
            }));
            this.subs.add(fromEvent(containerElement, 'focusout')
                .subscribe(() => {
                if (this.readonly) {
                    contentAreaClasslist.remove('k-state-focused');
                }
                if (!this.focusChangedProgrammatically) {
                    this.ngZone.run(() => this.onBlur.emit());
                }
            }));
        }
        this.subs.add(this.stateChange.subscribe(() => {
            if (this.userToolBarComponent) {
                this.userToolBarComponent.cdr.detectChanges();
            }
            else {
                this.cdr.detectChanges();
            }
        }));
        this.subs.add(merge(this.valueModified.pipe(filter(() => this.updateInterval > 0), auditTime(this.updateInterval)), this.valueModified.pipe(filter(() => this.updateInterval === 0))).subscribe((value) => {
            this.onChangeCallback(value);
            this.valueChange.emit(value);
            this.cdr.markForCheck();
        }));
        this.subs.add(fromEvent(this.viewMountElement, 'keyup')
            .pipe(map((e) => e.keyCode), filter((code) => code === 121), // F10
        map(() => this.userToolBarElement || this.defaultToolbar))
            .subscribe((toolbar) => toolbar.nativeElement.focus()));
        this.subs.add(fromEvent(this.viewMountElement, 'blur')
            .pipe(filter((event) => !this.viewMountElement.contains(event.relatedTarget)))
            .subscribe(() => this.onTouchedCallback()));
    }
    normalizeSize() {
        if (typeof this.resizable === 'object' && !this._styleObserver) {
            const element = this.element.nativeElement;
            this._styleObserver = new MutationObserver(() => {
                this.ngZone.runOutsideAngular(() => this.normalizeProperties(element));
            });
            this._styleObserver.observe(element, { attributeFilter: ['style'] });
        }
    }
    normalizeProperties(element) {
        const props = Object.keys(this.resizable);
        const pixelWidth = parseInt(element.style.width, 10);
        const pixelHeight = parseInt(element.style.height, 10);
        const resizable = this.resizable;
        props.forEach(prop => {
            const isMinProp = prop.startsWith('min');
            const isMaxProp = !isMinProp;
            const isWidthProp = prop.endsWith('Width');
            const isHeightProp = !isWidthProp;
            if (isMinProp && isWidthProp) {
                if (pixelWidth < resizable.minWidth) {
                    element.style.width = resizable.minWidth + 'px';
                }
            }
            else if (isMinProp && isHeightProp) {
                if (pixelHeight < resizable.minHeight) {
                    element.style.height = resizable.minHeight + 'px';
                }
            }
            else if (isMaxProp && isWidthProp) {
                if (pixelWidth > resizable.maxWidth) {
                    element.style.width = resizable.maxWidth + 'px';
                }
            }
            else {
                if (pixelHeight > resizable.maxHeight) {
                    element.style.height = resizable.maxHeight + 'px';
                }
            }
        });
    }
};
EditorComponent.ɵfac = function EditorComponent_Factory(t) { return new (t || EditorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditorComponent, selectors: [["kendo-editor"]], contentQueries: function EditorComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ToolBarComponent, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, ToolBarComponent, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.userToolBarComponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.userToolBarElement = _t.first);
    } }, viewQuery: function EditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 7, ViewContainerRef);
        ɵngcc0.ɵɵviewQuery(_c4, 5, ViewContainerRef);
        ɵngcc0.ɵɵviewQuery(_c5, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c5, 5, ToolBarComponent);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dialogContainer = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.defaultToolbar = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.defaultToolbarComponent = _t.first);
    } }, hostVars: 20, hostBindings: function EditorComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.dir)("ariaDisabled", ctx.ariaDisabled);
        ɵngcc0.ɵɵstyleProp("min-width", ctx.minWidth)("max-width", ctx.maxWidth)("min-height", ctx.minHeight)("max-height", ctx.maxHeight);
        ɵngcc0.ɵɵclassProp("k-editor", ctx.hostClass)("k-editor-resizable", ctx.resizableClass)("k-state-disabled", ctx.isDisabled)("k-readonly", ctx.isReadonly)("k-ie", ctx.isIE);
    } }, inputs: { iframe: "iframe", applyToWord: "applyToWord", updateInterval: "updateInterval", preserveWhitespace: "preserveWhitespace", resizable: "resizable", value: "value", disabled: "disabled", readonly: "readonly", schema: "schema", plugins: "plugins", placeholder: "placeholder", pasteCleanupSettings: "pasteCleanupSettings" }, outputs: { valueChange: "valueChange", onFocus: "focus", onBlur: "blur" }, features: [ɵngcc0.ɵɵProvidersFeature([
            EditorLocalizationService,
            EditorToolsService,
            {
                provide: LocalizationService,
                useExisting: EditorLocalizationService
            },
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.editor'
            },
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => EditorComponent_1),
                multi: true
            },
            {
                provide: KendoInput,
                useExisting: forwardRef(() => EditorComponent_1)
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c111, decls: 7, vars: 3, consts: function () { let i18n_6; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that aligns text in the center.
         * @meaning kendo.editor.alignCenter
         */
        const MSG_EXTERNAL_4529292660735098393$$DIST_FESM2015_INDEX_JS_7 = goog.getMsg("Center text");
        i18n_6 = MSG_EXTERNAL_4529292660735098393$$DIST_FESM2015_INDEX_JS_7;
    }
    else {
        i18n_6 = $localize `:kendo.editor.alignCenter|The title of the tool that aligns text in the center.␟c19b9de1395639d8d6906083e06a682537d548b8␟4529292660735098393:Center text`;
    } let i18n_8; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that justifies text both left and right.
         * @meaning kendo.editor.alignJustify
         */
        const MSG_EXTERNAL_4684700365643535728$$DIST_FESM2015_INDEX_JS_9 = goog.getMsg("Justify");
        i18n_8 = MSG_EXTERNAL_4684700365643535728$$DIST_FESM2015_INDEX_JS_9;
    }
    else {
        i18n_8 = $localize `:kendo.editor.alignJustify|The title of the tool that justifies text both left and right.␟6fd8af3052680f0e8af558f02aafbdae846763ad␟4684700365643535728:Justify`;
    } let i18n_10; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that aligns text on the left.
         * @meaning kendo.editor.alignLeft
         */
        const MSG_EXTERNAL_154382826604788564$$DIST_FESM2015_INDEX_JS_11 = goog.getMsg("Align text left");
        i18n_10 = MSG_EXTERNAL_154382826604788564$$DIST_FESM2015_INDEX_JS_11;
    }
    else {
        i18n_10 = $localize `:kendo.editor.alignLeft|The title of the tool that aligns text on the left.␟0e6294e25d0445bf78814703fc3db0f9275cdfaf␟154382826604788564:Align text left`;
    } let i18n_12; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that aligns text on the right.
         * @meaning kendo.editor.alignRight
         */
        const MSG_EXTERNAL_947503876024297122$$DIST_FESM2015_INDEX_JS_13 = goog.getMsg("Align text right");
        i18n_12 = MSG_EXTERNAL_947503876024297122$$DIST_FESM2015_INDEX_JS_13;
    }
    else {
        i18n_12 = $localize `:kendo.editor.alignRight|The title of the tool that aligns text on the right.␟e42635af2f5e2255fe4e5e4259139bed6771d5b0␟947503876024297122:Align text right`;
    } let i18n_14; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that changes the text background color.
         * @meaning kendo.editor.backColor
         */
        const MSG_EXTERNAL_6855434377775366481$$DIST_FESM2015_INDEX_JS_15 = goog.getMsg("Background color");
        i18n_14 = MSG_EXTERNAL_6855434377775366481$$DIST_FESM2015_INDEX_JS_15;
    }
    else {
        i18n_14 = $localize `:kendo.editor.backColor|The title of the tool that changes the text background color.␟94feffd30b062ee0ef8aac49af5faebc986b79ee␟6855434377775366481:Background color`;
    } let i18n_16; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that makes text bold.
         * @meaning kendo.editor.bold
         */
        const MSG_EXTERNAL_2189266817166266173$$DIST_FESM2015_INDEX_JS_17 = goog.getMsg("Bold");
        i18n_16 = MSG_EXTERNAL_2189266817166266173$$DIST_FESM2015_INDEX_JS_17;
    }
    else {
        i18n_16 = $localize `:kendo.editor.bold|The title of the tool that makes text bold.␟e1a1b567ad44320e7949153f90b735a000e0dd54␟2189266817166266173:Bold`;
    } let i18n_18; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the Clean Formatting tool.
         * @meaning kendo.editor.cleanFormatting
         */
        const MSG_EXTERNAL_6409775087646476318$$DIST_FESM2015_INDEX_JS_19 = goog.getMsg("Clean formatting");
        i18n_18 = MSG_EXTERNAL_6409775087646476318$$DIST_FESM2015_INDEX_JS_19;
    }
    else {
        i18n_18 = $localize `:kendo.editor.cleanFormatting|The title of the Clean Formatting tool.␟6ee3ea0c48aeb94e9ed4b728391edc424c5b2b90␟6409775087646476318:Clean formatting`;
    } let i18n_20; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that creates hyperlinks.
         * @meaning kendo.editor.createLink
         */
        const MSG_EXTERNAL_2895696791468415067$$DIST_FESM2015_INDEX_JS_21 = goog.getMsg("Insert link");
        i18n_20 = MSG_EXTERNAL_2895696791468415067$$DIST_FESM2015_INDEX_JS_21;
    }
    else {
        i18n_20 = $localize `:kendo.editor.createLink|The title of the tool that creates hyperlinks.␟a0857ff55fd21727d74e873d164f6785c4a1d2a4␟2895696791468415067:Insert link`;
    } let i18n_22; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The label of the **Apply** button in all editor dialogs.
         * @meaning kendo.editor.dialogApply
         */
        const MSG_EXTERNAL_3478270206890847719$$DIST_FESM2015_INDEX_JS_23 = goog.getMsg("Apply");
        i18n_22 = MSG_EXTERNAL_3478270206890847719$$DIST_FESM2015_INDEX_JS_23;
    }
    else {
        i18n_22 = $localize `:kendo.editor.dialogApply|The label of the **Apply** button in all editor dialogs.␟0205d0783c43657539254c5d8cd37d4a88911f1d␟3478270206890847719:Apply`;
    } let i18n_24; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The label of the **Cancel** button in all editor dialogs.
         * @meaning kendo.editor.dialogCancel
         */
        const MSG_EXTERNAL_1436637880389464255$$DIST_FESM2015_INDEX_JS_25 = goog.getMsg("Cancel");
        i18n_24 = MSG_EXTERNAL_1436637880389464255$$DIST_FESM2015_INDEX_JS_25;
    }
    else {
        i18n_24 = $localize `:kendo.editor.dialogCancel|The label of the **Cancel** button in all editor dialogs.␟62c847eb7dfe44fa70224659b77a69e04ad24e98␟1436637880389464255:Cancel`;
    } let i18n_26; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The label of the **Insert** button in all editor dialogs.
         * @meaning kendo.editor.dialogInsert
         */
        const MSG_EXTERNAL_1902538342017591848$$DIST_FESM2015_INDEX_JS_27 = goog.getMsg("Insert");
        i18n_26 = MSG_EXTERNAL_1902538342017591848$$DIST_FESM2015_INDEX_JS_27;
    }
    else {
        i18n_26 = $localize `:kendo.editor.dialogInsert|The label of the **Insert** button in all editor dialogs.␟e2897c2d92e5b0f60dbc34568ea63ee29aac72b1␟1902538342017591848:Insert`;
    } let i18n_28; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The label of the **Update** button in all editor dialogs.
         * @meaning kendo.editor.dialogUpdate
         */
        const MSG_EXTERNAL_3131813297607973618$$DIST_FESM2015_INDEX_JS_29 = goog.getMsg("Update");
        i18n_28 = MSG_EXTERNAL_3131813297607973618$$DIST_FESM2015_INDEX_JS_29;
    }
    else {
        i18n_28 = $localize `:kendo.editor.dialogUpdate|The label of the **Update** button in all editor dialogs.␟da599b240288c66d5682ecf53647fae17b1f255d␟3131813297607973618:Update`;
    } let i18n_30; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The caption for the file text in the insertFile dialog.
         * @meaning kendo.editor.fileText
         */
        const MSG_EXTERNAL_2994440335095238335$$DIST_FESM2015_INDEX_JS_31 = goog.getMsg("Text");
        i18n_30 = MSG_EXTERNAL_2994440335095238335$$DIST_FESM2015_INDEX_JS_31;
    }
    else {
        i18n_30 = $localize `:kendo.editor.fileText|The caption for the file text in the insertFile dialog.␟b9e9c0726907339811d576fbecf9ee7ef25228dd␟2994440335095238335:Text`;
    } let i18n_32; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The caption for the file Title in the insertFile dialog.
         * @meaning kendo.editor.fileTitle
         */
        const MSG_EXTERNAL_2270852727137392864$$DIST_FESM2015_INDEX_JS_33 = goog.getMsg("Title");
        i18n_32 = MSG_EXTERNAL_2270852727137392864$$DIST_FESM2015_INDEX_JS_33;
    }
    else {
        i18n_32 = $localize `:kendo.editor.fileTitle|The caption for the file Title in the insertFile dialog.␟773650e91245315dd99ba76678b651035d896449␟2270852727137392864:Title`;
    } let i18n_34; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The caption for the file URL in the insertFile dialog.
         * @meaning kendo.editor.fileWebAddress
         */
        const MSG_EXTERNAL_272090133902355251$$DIST_FESM2015_INDEX_JS_35 = goog.getMsg("Web address");
        i18n_34 = MSG_EXTERNAL_272090133902355251$$DIST_FESM2015_INDEX_JS_35;
    }
    else {
        i18n_34 = $localize `:kendo.editor.fileWebAddress|The caption for the file URL in the insertFile dialog.␟920e262f27d93e37174869fe53fbda129edd6220␟272090133902355251:Web address`;
    } let i18n_36; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that changes the text font.
         * @meaning kendo.editor.fontFamily
         */
        const MSG_EXTERNAL_2242101754750506857$$DIST_FESM2015_INDEX_JS_37 = goog.getMsg("Select font family");
        i18n_36 = MSG_EXTERNAL_2242101754750506857$$DIST_FESM2015_INDEX_JS_37;
    }
    else {
        i18n_36 = $localize `:kendo.editor.fontFamily|The title of the tool that changes the text font.␟b3c7dd6b566ab94cbad12176f608f617394069a5␟2242101754750506857:Select font family`;
    } let i18n_38; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that changes the text size.
         * @meaning kendo.editor.fontSize
         */
        const MSG_EXTERNAL_3134383620280891369$$DIST_FESM2015_INDEX_JS_39 = goog.getMsg("Select font size");
        i18n_38 = MSG_EXTERNAL_3134383620280891369$$DIST_FESM2015_INDEX_JS_39;
    }
    else {
        i18n_38 = $localize `:kendo.editor.fontSize|The title of the tool that changes the text size.␟1e36b676782998a979c662191a815b60e212b1e4␟3134383620280891369:Select font size`;
    } let i18n_40; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that changes the text color.
         * @meaning kendo.editor.foreColor
         */
        const MSG_EXTERNAL_5478978124365341523$$DIST_FESM2015_INDEX_JS_41 = goog.getMsg("Color");
        i18n_40 = MSG_EXTERNAL_5478978124365341523$$DIST_FESM2015_INDEX_JS_41;
    }
    else {
        i18n_40 = $localize `:kendo.editor.foreColor|The title of the tool that changes the text color.␟6b7246584279a0e44d9bd9cb953a0c701696d059␟5478978124365341523:Color`;
    } let i18n_42; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that lets users choose block formats.
         * @meaning kendo.editor.format
         */
        const MSG_EXTERNAL_7573626268088286043$$DIST_FESM2015_INDEX_JS_43 = goog.getMsg("Format");
        i18n_42 = MSG_EXTERNAL_7573626268088286043$$DIST_FESM2015_INDEX_JS_43;
    }
    else {
        i18n_42 = $localize `:kendo.editor.format|The title of the tool that lets users choose block formats.␟27423769f36c1e1662739fe78b0a29f8449ca2ed␟7573626268088286043:Format`;
    } let i18n_44; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The caption for the image alternate text in the insertImage dialog.
         * @meaning kendo.editor.imageAltText
         */
        const MSG_EXTERNAL_2605419586703055723$$DIST_FESM2015_INDEX_JS_45 = goog.getMsg("Alternate text");
        i18n_44 = MSG_EXTERNAL_2605419586703055723$$DIST_FESM2015_INDEX_JS_45;
    }
    else {
        i18n_44 = $localize `:kendo.editor.imageAltText|The caption for the image alternate text in the insertImage dialog.␟588c2538a305890410558065bbb376099873f059␟2605419586703055723:Alternate text`;
    } let i18n_46; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The caption for the image height in the insertImage dialog.
         * @meaning kendo.editor.imageHeight
         */
        const MSG_EXTERNAL_7389256657313538937$$DIST_FESM2015_INDEX_JS_47 = goog.getMsg("Height (px)");
        i18n_46 = MSG_EXTERNAL_7389256657313538937$$DIST_FESM2015_INDEX_JS_47;
    }
    else {
        i18n_46 = $localize `:kendo.editor.imageHeight|The caption for the image height in the insertImage dialog.␟1f22b7da203eebe3e1efd22cc86aa9b990b0c16f␟7389256657313538937:Height (px)`;
    } let i18n_48; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The caption for the image URL in the insertImage dialog.
         * @meaning kendo.editor.imageWebAddress
         */
        const MSG_EXTERNAL_6975958345731927150$$DIST_FESM2015_INDEX_JS_49 = goog.getMsg("Web address");
        i18n_48 = MSG_EXTERNAL_6975958345731927150$$DIST_FESM2015_INDEX_JS_49;
    }
    else {
        i18n_48 = $localize `:kendo.editor.imageWebAddress|The caption for the image URL in the insertImage dialog.␟31537a903057886e7fb1a79cd5cde73a649a8ed6␟6975958345731927150:Web address`;
    } let i18n_50; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The caption for the image width in the insertImage dialog.
         * @meaning kendo.editor.imageWidth
         */
        const MSG_EXTERNAL_8309100232203036921$$DIST_FESM2015_INDEX_JS_51 = goog.getMsg("Width (px)");
        i18n_50 = MSG_EXTERNAL_8309100232203036921$$DIST_FESM2015_INDEX_JS_51;
    }
    else {
        i18n_50 = $localize `:kendo.editor.imageWidth|The caption for the image width in the insertImage dialog.␟4f26f47317f5b69c192fbc9cafecb432e8fa8ee5␟8309100232203036921:Width (px)`;
    } let i18n_52; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that indents the content.
         * @meaning kendo.editor.indent
         */
        const MSG_EXTERNAL_5647108364628468094$$DIST_FESM2015_INDEX_JS_53 = goog.getMsg("Indent");
        i18n_52 = MSG_EXTERNAL_5647108364628468094$$DIST_FESM2015_INDEX_JS_53;
    }
    else {
        i18n_52 = $localize `:kendo.editor.indent|The title of the tool that indents the content.␟332319db3aabf32cd56e64e1569276c5f878fd5d␟5647108364628468094:Indent`;
    } let i18n_54; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that inserts links to files.
         * @meaning kendo.editor.insertFile
         */
        const MSG_EXTERNAL_539957110154874519$$DIST_FESM2015_INDEX_JS_55 = goog.getMsg("Insert file");
        i18n_54 = MSG_EXTERNAL_539957110154874519$$DIST_FESM2015_INDEX_JS_55;
    }
    else {
        i18n_54 = $localize `:kendo.editor.insertFile|The title of the tool that inserts links to files.␟f57591626833e959e88b177754c2e996119a3c1a␟539957110154874519:Insert file`;
    } let i18n_56; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that inserts images.
         * @meaning kendo.editor.insertImage
         */
        const MSG_EXTERNAL_3091202802113261385$$DIST_FESM2015_INDEX_JS_57 = goog.getMsg("Insert image");
        i18n_56 = MSG_EXTERNAL_3091202802113261385$$DIST_FESM2015_INDEX_JS_57;
    }
    else {
        i18n_56 = $localize `:kendo.editor.insertImage|The title of the tool that inserts images.␟759c8463401821450bfa80fd9106314adab25ca3␟3091202802113261385:Insert image`;
    } let i18n_58; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that inserts an ordered list.
         * @meaning kendo.editor.insertOrderedList
         */
        const MSG_EXTERNAL_4334727692818265844$$DIST_FESM2015_INDEX_JS_59 = goog.getMsg("Insert ordered list");
        i18n_58 = MSG_EXTERNAL_4334727692818265844$$DIST_FESM2015_INDEX_JS_59;
    }
    else {
        i18n_58 = $localize `:kendo.editor.insertOrderedList|The title of the tool that inserts an ordered list.␟9de4d5df2c52ec20dda585ddf9046b64042a63dc␟4334727692818265844:Insert ordered list`;
    } let i18n_60; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that inserts an unordered list.
         * @meaning kendo.editor.insertUnorderedList
         */
        const MSG_EXTERNAL_6391583758449842507$$DIST_FESM2015_INDEX_JS_61 = goog.getMsg("Insert unordered list");
        i18n_60 = MSG_EXTERNAL_6391583758449842507$$DIST_FESM2015_INDEX_JS_61;
    }
    else {
        i18n_60 = $localize `:kendo.editor.insertUnorderedList|The title of the tool that inserts an unordered list.␟2c56625f542e63a0fcb2cdfff32ac7958a773131␟6391583758449842507:Insert unordered list`;
    } let i18n_62; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that makes text italicized.
         * @meaning kendo.editor.italic
         */
        const MSG_EXTERNAL_7054357458452689543$$DIST_FESM2015_INDEX_JS_63 = goog.getMsg("Italic");
        i18n_62 = MSG_EXTERNAL_7054357458452689543$$DIST_FESM2015_INDEX_JS_63;
    }
    else {
        i18n_62 = $localize `:kendo.editor.italic|The title of the tool that makes text italicized.␟0c2f657b2d63906813f0d999c34639d6703d29fe␟7054357458452689543:Italic`;
    } let i18n_64; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The caption for the checkbox for opening the link in a new window in the createLink dialog.
         * @meaning kendo.editor.linkOpenInNewWindow
         */
        const MSG_EXTERNAL_6304412528521452300$$DIST_FESM2015_INDEX_JS_65 = goog.getMsg("Open link in new window");
        i18n_64 = MSG_EXTERNAL_6304412528521452300$$DIST_FESM2015_INDEX_JS_65;
    }
    else {
        i18n_64 = $localize `:kendo.editor.linkOpenInNewWindow|The caption for the checkbox for opening the link in a new window in the createLink dialog.␟7ddbe5ff681ec56e0a1d47f55baf03aae43143f0␟6304412528521452300:Open link in new window`;
    } let i18n_66; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The caption for the link text in the createLink dialog.
         * @meaning kendo.editor.linkText
         */
        const MSG_EXTERNAL_8060045722754477150$$DIST_FESM2015_INDEX_JS_67 = goog.getMsg("Text");
        i18n_66 = MSG_EXTERNAL_8060045722754477150$$DIST_FESM2015_INDEX_JS_67;
    }
    else {
        i18n_66 = $localize `:kendo.editor.linkText|The caption for the link text in the createLink dialog.␟bc5096e9fa3fd49769d041a4734d5d5d8e6fd0e9␟8060045722754477150:Text`;
    } let i18n_68; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The caption for the link title in the createLink dialog.
         * @meaning kendo.editor.linkTitle
         */
        const MSG_EXTERNAL_330780229810449102$$DIST_FESM2015_INDEX_JS_69 = goog.getMsg("Title");
        i18n_68 = MSG_EXTERNAL_330780229810449102$$DIST_FESM2015_INDEX_JS_69;
    }
    else {
        i18n_68 = $localize `:kendo.editor.linkTitle|The caption for the link title in the createLink dialog.␟e5c8208c08928222b713afcf80de78633236349d␟330780229810449102:Title`;
    } let i18n_70; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The caption for the URL in the createLink dialog.
         * @meaning kendo.editor.linkWebAddress
         */
        const MSG_EXTERNAL_6362180643798508446$$DIST_FESM2015_INDEX_JS_71 = goog.getMsg("Web address");
        i18n_70 = MSG_EXTERNAL_6362180643798508446$$DIST_FESM2015_INDEX_JS_71;
    }
    else {
        i18n_70 = $localize `:kendo.editor.linkWebAddress|The caption for the URL in the createLink dialog.␟19f853c2933a9a1b71d96accf814e4f9e9e6e8dd␟6362180643798508446:Web address`;
    } let i18n_72; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that outdents the content.
         * @meaning kendo.editor.outdent
         */
        const MSG_EXTERNAL_8474960686200350213$$DIST_FESM2015_INDEX_JS_73 = goog.getMsg("Outdent");
        i18n_72 = MSG_EXTERNAL_8474960686200350213$$DIST_FESM2015_INDEX_JS_73;
    }
    else {
        i18n_72 = $localize `:kendo.editor.outdent|The title of the tool that outdents the content.␟33a49dc9bce8c37c9c957a6cdb7fcd0b82b8bf58␟8474960686200350213:Outdent`;
    } let i18n_74; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the print tool.
         * @meaning kendo.editor.print
         */
        const MSG_EXTERNAL_80847516738809405$$DIST_FESM2015_INDEX_JS_75 = goog.getMsg("Print");
        i18n_74 = MSG_EXTERNAL_80847516738809405$$DIST_FESM2015_INDEX_JS_75;
    }
    else {
        i18n_74 = $localize `:kendo.editor.print|The title of the print tool.␟9d52f416bc1f1a35c55906e927a19befea8a2b84␟80847516738809405:Print`;
    } let i18n_76; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that undos the last action.
         * @meaning kendo.editor.redo
         */
        const MSG_EXTERNAL_6526989398460728046$$DIST_FESM2015_INDEX_JS_77 = goog.getMsg("Redo");
        i18n_76 = MSG_EXTERNAL_6526989398460728046$$DIST_FESM2015_INDEX_JS_77;
    }
    else {
        i18n_76 = $localize `:kendo.editor.redo|The title of the tool that undos the last action.␟117c237ef9fa6ff04fb4447fc233fe846ed366c1␟6526989398460728046:Redo`;
    } let i18n_78; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that selects all content.
         * @meaning kendo.editor.selectAll
         */
        const MSG_EXTERNAL_7460989834038782177$$DIST_FESM2015_INDEX_JS_79 = goog.getMsg("Select All");
        i18n_78 = MSG_EXTERNAL_7460989834038782177$$DIST_FESM2015_INDEX_JS_79;
    }
    else {
        i18n_78 = $localize `:kendo.editor.selectAll|The title of the tool that selects all content.␟f2421e26609d5f0e84c4db8da0d8990a764eb604␟7460989834038782177:Select All`;
    } let i18n_80; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that strikes through text.
         * @meaning kendo.editor.strikethrough
         */
        const MSG_EXTERNAL_2488604920377820272$$DIST_FESM2015_INDEX_JS_81 = goog.getMsg("Strikethrough");
        i18n_80 = MSG_EXTERNAL_2488604920377820272$$DIST_FESM2015_INDEX_JS_81;
    }
    else {
        i18n_80 = $localize `:kendo.editor.strikethrough|The title of the tool that strikes through text.␟6e38a1450b5d50601f44a665fbb329feca31e97b␟2488604920377820272:Strikethrough`;
    } let i18n_82; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that makes text subscript.
         * @meaning kendo.editor.subscript
         */
        const MSG_EXTERNAL_7270994954007735302$$DIST_FESM2015_INDEX_JS_83 = goog.getMsg("Subscript");
        i18n_82 = MSG_EXTERNAL_7270994954007735302$$DIST_FESM2015_INDEX_JS_83;
    }
    else {
        i18n_82 = $localize `:kendo.editor.subscript|The title of the tool that makes text subscript.␟2bd31b9317a43ee8fb808b0c254b1bb200f908fa␟7270994954007735302:Subscript`;
    } let i18n_84; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that makes text superscript.
         * @meaning kendo.editor.superscript
         */
        const MSG_EXTERNAL_7596297815131300603$$DIST_FESM2015_INDEX_JS_85 = goog.getMsg("Superscript");
        i18n_84 = MSG_EXTERNAL_7596297815131300603$$DIST_FESM2015_INDEX_JS_85;
    }
    else {
        i18n_84 = $localize `:kendo.editor.superscript|The title of the tool that makes text superscript.␟825050144d6680f962bf7ec296c42e08e6ac09d9␟7596297815131300603:Superscript`;
    } let i18n_86; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that underlines text.
         * @meaning kendo.editor.underline
         */
        const MSG_EXTERNAL_8473045911658532041$$DIST_FESM2015_INDEX_JS_87 = goog.getMsg("Underline");
        i18n_86 = MSG_EXTERNAL_8473045911658532041$$DIST_FESM2015_INDEX_JS_87;
    }
    else {
        i18n_86 = $localize `:kendo.editor.underline|The title of the tool that underlines text.␟67eb1cff18f5e9a2e7d47aae052c666583bab261␟8473045911658532041:Underline`;
    } let i18n_88; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that removes hyperlinks.
         * @meaning kendo.editor.unlink
         */
        const MSG_EXTERNAL_1024469129593792947$$DIST_FESM2015_INDEX_JS_89 = goog.getMsg("Remove Link");
        i18n_88 = MSG_EXTERNAL_1024469129593792947$$DIST_FESM2015_INDEX_JS_89;
    }
    else {
        i18n_88 = $localize `:kendo.editor.unlink|The title of the tool that removes hyperlinks.␟ad3a3c5c713542df87373b77cae8a124edb29c22␟1024469129593792947:Remove Link`;
    } let i18n_90; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that undos the last action.
         * @meaning kendo.editor.undo
         */
        const MSG_EXTERNAL_3987002812814489417$$DIST_FESM2015_INDEX_JS_91 = goog.getMsg("Undo");
        i18n_90 = MSG_EXTERNAL_3987002812814489417$$DIST_FESM2015_INDEX_JS_91;
    }
    else {
        i18n_90 = $localize `:kendo.editor.undo|The title of the tool that undos the last action.␟18b488b145eeea939eecd65716bc3578939dcc0f␟3987002812814489417:Undo`;
    } let i18n_92; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that shows the editor value as HTML.
         * @meaning kendo.editor.viewSource
         */
        const MSG_EXTERNAL_3825180996241734650$$DIST_FESM2015_INDEX_JS_93 = goog.getMsg("View source");
        i18n_92 = MSG_EXTERNAL_3825180996241734650$$DIST_FESM2015_INDEX_JS_93;
    }
    else {
        i18n_92 = $localize `:kendo.editor.viewSource|The title of the tool that shows the editor value as HTML.␟3caea7fc81a53a3e225561af33a56902f642ac26␟3825180996241734650:View source`;
    } let i18n_94; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that inserts table.
         * @meaning kendo.editor.insertTable
         */
        const MSG_EXTERNAL_5261534950694067764$$DIST_FESM2015_INDEX_JS_95 = goog.getMsg("Insert Table");
        i18n_94 = MSG_EXTERNAL_5261534950694067764$$DIST_FESM2015_INDEX_JS_95;
    }
    else {
        i18n_94 = $localize `:kendo.editor.insertTable|The title of the tool that inserts table.␟32de5e66d4b2073bded7114d8a1ea1411cd7ceec␟5261534950694067764:Insert Table`;
    } let i18n_96; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that adds new column before currently selected column.
         * @meaning kendo.editor.addColumnBefore
         */
        const MSG_EXTERNAL_2967496815045471366$$DIST_FESM2015_INDEX_JS_97 = goog.getMsg("Add column before");
        i18n_96 = MSG_EXTERNAL_2967496815045471366$$DIST_FESM2015_INDEX_JS_97;
    }
    else {
        i18n_96 = $localize `:kendo.editor.addColumnBefore|The title of the tool that adds new column before currently selected column.␟66c68280830690c0ebd374fd34dead01df2e7057␟2967496815045471366:Add column before`;
    } let i18n_98; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that adds new column after currently selected column.
         * @meaning kendo.editor.addColumnAfter
         */
        const MSG_EXTERNAL_1046762424668985150$$DIST_FESM2015_INDEX_JS_99 = goog.getMsg("Add column after");
        i18n_98 = MSG_EXTERNAL_1046762424668985150$$DIST_FESM2015_INDEX_JS_99;
    }
    else {
        i18n_98 = $localize `:kendo.editor.addColumnAfter|The title of the tool that adds new column after currently selected column.␟24d531a9e3507a6ad02bff394c5030a25a731d66␟1046762424668985150:Add column after`;
    } let i18n_100; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that adds new row before currently selected row.
         * @meaning kendo.editor.addRowBefore
         */
        const MSG_EXTERNAL_5531388093960518917$$DIST_FESM2015_INDEX_JS_101 = goog.getMsg("Add row before");
        i18n_100 = MSG_EXTERNAL_5531388093960518917$$DIST_FESM2015_INDEX_JS_101;
    }
    else {
        i18n_100 = $localize `:kendo.editor.addRowBefore|The title of the tool that adds new row before currently selected row.␟c42641b164ae5711cb01b88bcde664031cc230bf␟5531388093960518917:Add row before`;
    } let i18n_102; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that adds new row after currently selected row.
         * @meaning kendo.editor.addRowAfter
         */
        const MSG_EXTERNAL_6647582145372406524$$DIST_FESM2015_INDEX_JS_103 = goog.getMsg("Add row after");
        i18n_102 = MSG_EXTERNAL_6647582145372406524$$DIST_FESM2015_INDEX_JS_103;
    }
    else {
        i18n_102 = $localize `:kendo.editor.addRowAfter|The title of the tool that adds new row after currently selected row.␟c852853beee80e68e673421fd4bc57fa49d417d9␟6647582145372406524:Add row after`;
    } let i18n_104; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that deletes a table column.
         * @meaning kendo.editor.deleteColumn
         */
        const MSG_EXTERNAL_7009319757848972360$$DIST_FESM2015_INDEX_JS_105 = goog.getMsg("Delete column");
        i18n_104 = MSG_EXTERNAL_7009319757848972360$$DIST_FESM2015_INDEX_JS_105;
    }
    else {
        i18n_104 = $localize `:kendo.editor.deleteColumn|The title of the tool that deletes a table column.␟233fbf121ca8b9ea127211a83ab72f0daf01593a␟7009319757848972360:Delete column`;
    } let i18n_106; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that deletes a table row.
         * @meaning kendo.editor.deleteRow
         */
        const MSG_EXTERNAL_8410650025259601548$$DIST_FESM2015_INDEX_JS_107 = goog.getMsg("Delete row");
        i18n_106 = MSG_EXTERNAL_8410650025259601548$$DIST_FESM2015_INDEX_JS_107;
    }
    else {
        i18n_106 = $localize `:kendo.editor.deleteRow|The title of the tool that deletes a table row.␟a7bf50c04d3769d4bde61bab60e6aaa0e982a488␟8410650025259601548:Delete row`;
    } let i18n_108; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the tool that deletes a table.
         * @meaning kendo.editor.deleteTable
         */
        const MSG_EXTERNAL_3609415533235721295$$DIST_FESM2015_INDEX_JS_109 = goog.getMsg("Delete table");
        i18n_108 = MSG_EXTERNAL_3609415533235721295$$DIST_FESM2015_INDEX_JS_109;
    }
    else {
        i18n_108 = $localize `:kendo.editor.deleteTable|The title of the tool that deletes a table.␟2694410604d01084a49e5225a60fbe3eda3af5cc␟3609415533235721295:Delete table`;
    } return [["kendoEditorLocalizedMessages", "", "alignCenter", i18n_6, "alignJustify", i18n_8, "alignLeft", i18n_10, "alignRight", i18n_12, "backColor", i18n_14, "bold", i18n_16, "cleanFormatting", i18n_18, "createLink", i18n_20, "dialogApply", i18n_22, "dialogCancel", i18n_24, "dialogInsert", i18n_26, "dialogUpdate", i18n_28, "fileText", i18n_30, "fileTitle", i18n_32, "fileWebAddress", i18n_34, "fontFamily", i18n_36, "fontSize", i18n_38, "foreColor", i18n_40, "format", i18n_42, "imageAltText", i18n_44, "imageHeight", i18n_46, "imageWebAddress", i18n_48, "imageWidth", i18n_50, "indent", i18n_52, "insertFile", i18n_54, "insertImage", i18n_56, "insertOrderedList", i18n_58, "insertUnorderedList", i18n_60, "italic", i18n_62, "linkOpenInNewWindow", i18n_64, "linkText", i18n_66, "linkTitle", i18n_68, "linkWebAddress", i18n_70, "outdent", i18n_72, "print", i18n_74, "redo", i18n_76, "selectAll", i18n_78, "strikethrough", i18n_80, "subscript", i18n_82, "superscript", i18n_84, "underline", i18n_86, "unlink", i18n_88, "undo", i18n_90, "viewSource", i18n_92, "insertTable", i18n_94, "addColumnBefore", i18n_96, "addColumnAfter", i18n_98, "addRowBefore", i18n_100, "addRowAfter", i18n_102, "deleteColumn", i18n_104, "deleteRow", i18n_106, "deleteTable", i18n_108], [3, "overflow", "tabindex", 4, "ngIf"], ["class", "k-editor-content", 4, "ngIf"], ["dialogsContainer", ""], [3, "overflow", "tabindex"], ["defaultToolbar", ""], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorFormat", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertImageButton", ""], [1, "k-editor-content"], ["content", ""], ["frameborder", "0", 1, "k-iframe", 3, "load"]]; }, template: function EditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c110);
        ɵngcc0.ɵɵelementContainer(0, 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, EditorComponent_kendo_toolbar_2_Template, 21, 2, "kendo-toolbar", 1);
        ɵngcc0.ɵɵtemplate(3, EditorComponent_div_3_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(4, EditorComponent_div_4_Template, 3, 0, "div", 2);
        ɵngcc0.ɵɵelementContainer(5, null, 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.userToolBarElement);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.iframe);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iframe);
    } }, directives: function () { return [LocalizedMessagesDirective, ɵngcc4.NgIf, ɵngcc6.ToolBarComponent, ɵngcc6.ToolBarButtonGroupComponent, ɵngcc6.ToolBarButtonComponent, EditorBoldButtonDirective, EditorItalicButtonDirective, EditorUnderlineButtonDirective, EditorFormatComponent, EditorAlignLeftButtonDirective, EditorAlignCenterButtonDirective, EditorAlignRightButtonDirective, EditorAlignJustifyButtonDirective, EditorInsertUnorderedListButtonDirective, EditorInsertOrderedListButtonDirective, EditorIndentButtonDirective, EditorOutdentButtonDirective, EditorCreateLinkButtonDirective, EditorUnlinkButtonDirective, EditorInsertImageButtonDirective]; }, styles: [".k-editor-content > .ProseMirror {\n                height: 100%;\n                width: 100%;\n                box-sizing: border-box;\n                outline: none;\n                overflow: auto;\n            }\n\n            .k-iframe[_ngcontent-%COMP%] {\n                width: 100%;\n                height: 100%;\n                display: block;\n            }"] });
__decorate([
    Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], EditorComponent.prototype, "value", null);
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], EditorComponent.prototype, "disabled", null);
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], EditorComponent.prototype, "readonly", null);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], EditorComponent.prototype, "iframe", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EditorComponent.prototype, "applyToWord", void 0);
__decorate([
    Input(),
    __metadata("design:type", Schema),
    __metadata("design:paramtypes", [Schema])
], EditorComponent.prototype, "schema", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], EditorComponent.prototype, "plugins", null);
__decorate([
    Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], EditorComponent.prototype, "placeholder", null);
__decorate([
    Input(),
    __metadata("design:type", Number)
], EditorComponent.prototype, "updateInterval", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EditorComponent.prototype, "preserveWhitespace", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EditorComponent.prototype, "pasteCleanupSettings", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EditorComponent.prototype, "resizable", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], EditorComponent.prototype, "valueChange", void 0);
__decorate([
    Output('focus'),
    __metadata("design:type", EventEmitter)
], EditorComponent.prototype, "onFocus", void 0);
__decorate([
    Output('blur'),
    __metadata("design:type", EventEmitter)
], EditorComponent.prototype, "onBlur", void 0);
__decorate([
    HostBinding('class.k-editor'),
    __metadata("design:type", Boolean)
], EditorComponent.prototype, "hostClass", void 0);
__decorate([
    HostBinding('class.k-editor-resizable'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], EditorComponent.prototype, "resizableClass", null);
__decorate([
    HostBinding('class.k-state-disabled'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], EditorComponent.prototype, "isDisabled", null);
__decorate([
    HostBinding('class.k-readonly'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], EditorComponent.prototype, "isReadonly", null);
__decorate([
    HostBinding('class.k-ie'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], EditorComponent.prototype, "isIE", null);
__decorate([
    HostBinding('attr.dir'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], EditorComponent.prototype, "dir", null);
__decorate([
    HostBinding('attr.ariaDisabled'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], EditorComponent.prototype, "ariaDisabled", null);
__decorate([
    HostBinding('style.minWidth'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], EditorComponent.prototype, "minWidth", null);
__decorate([
    HostBinding('style.maxWidth'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], EditorComponent.prototype, "maxWidth", null);
__decorate([
    HostBinding('style.minHeight'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], EditorComponent.prototype, "minHeight", null);
__decorate([
    HostBinding('style.maxHeight'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], EditorComponent.prototype, "maxHeight", null);
__decorate([
    ContentChild(ToolBarComponent, { static: false }),
    __metadata("design:type", ToolBarComponent)
], EditorComponent.prototype, "userToolBarComponent", void 0);
__decorate([
    ContentChild(ToolBarComponent, { read: ElementRef, static: false }),
    __metadata("design:type", ElementRef)
], EditorComponent.prototype, "userToolBarElement", void 0);
__decorate([
    ViewChild('dialogsContainer', { read: ViewContainerRef, static: true }),
    __metadata("design:type", ViewContainerRef)
], EditorComponent.prototype, "dialogContainer", void 0);
__decorate([
    ViewChild('content', { read: ViewContainerRef, static: false }),
    __metadata("design:type", ViewContainerRef)
], EditorComponent.prototype, "container", void 0);
__decorate([
    ViewChild('defaultToolbar', { read: ElementRef, static: false }),
    __metadata("design:type", ElementRef)
], EditorComponent.prototype, "defaultToolbar", void 0);
__decorate([
    ViewChild('defaultToolbar', { read: ToolBarComponent, static: false }),
    __metadata("design:type", ToolBarComponent)
], EditorComponent.prototype, "defaultToolbarComponent", void 0);
EditorComponent = EditorComponent_1 = __decorate([ __metadata("design:paramtypes", [DialogService,
        LocalizationService,
        ChangeDetectorRef,
        NgZone,
        ElementRef,
        EditorToolsService])
], EditorComponent);

/**
 * @hidden
 */
let FormatDropDownListComponent = class FormatDropDownListComponent {
    /**
     * @hidden
     */
    constructor() {
        this.valueChange = new EventEmitter();
    }
    onValueChange(tag) {
        this.valueChange.emit(tag);
    }
    focus() {
        this.dropDownList.focus();
    }
};
FormatDropDownListComponent.ɵfac = function FormatDropDownListComponent_Factory(t) { return new (t || FormatDropDownListComponent)(); };
FormatDropDownListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormatDropDownListComponent, selectors: [["kendo-editor-format-dropdownlist"]], viewQuery: function FormatDropDownListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c112, 7);
        ɵngcc0.ɵɵviewQuery(_c112, 7, DropDownListComponent);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.element = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropDownList = _t.first);
    } }, inputs: { data: "data", value: "value", defaultItem: "defaultItem", itemDisabled: "itemDisabled", title: "title", disabled: "disabled", tabindex: "tabindex" }, outputs: { valueChange: "valueChange" }, decls: 3, vars: 10, consts: [["kendoEditorDropDownTool", "", 3, "defaultItem", "textField", "valueField", "data", "value", "valuePrimitive", "itemDisabled", "disabled", "tabindex", "valueChange"], ["element", ""], ["kendoDropDownListItemTemplate", ""], [3, "ngSwitch"], ["style", "display: block; font-size: 2em; margin-left: 0; font-weight: bold;", 4, "ngSwitchCase"], ["style", "display: block; font-size: 1.5em; margin-left: 0; font-weight: bold;", 4, "ngSwitchCase"], ["style", "display: block; font-size: 1.17em; margin-left: 0; font-weight: bold;", 4, "ngSwitchCase"], ["style", "display: block; font-size: 1em; margin-left: 0; font-weight: bold;", 4, "ngSwitchCase"], ["style", "display: block; font-size: .83em; margin-left: 0; font-weight: bold;", 4, "ngSwitchCase"], ["style", "display: block; font-size: .67em; margin-left: 0; font-weight: bold;", 4, "ngSwitchCase"], ["style", "display: block; margin-left: 0;", 4, "ngSwitchCase"], [4, "ngSwitchDefault"], [2, "display", "block", "font-size", "2em", "margin-left", "0", "font-weight", "bold"], [2, "display", "block", "font-size", "1.5em", "margin-left", "0", "font-weight", "bold"], [2, "display", "block", "font-size", "1.17em", "margin-left", "0", "font-weight", "bold"], [2, "display", "block", "font-size", "1em", "margin-left", "0", "font-weight", "bold"], [2, "display", "block", "font-size", ".83em", "margin-left", "0", "font-weight", "bold"], [2, "display", "block", "font-size", ".67em", "margin-left", "0", "font-weight", "bold"], [2, "display", "block", "margin-left", "0"]], template: function FormatDropDownListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dropdownlist", 0, 1);
        ɵngcc0.ɵɵlistener("valueChange", function FormatDropDownListComponent_Template_kendo_dropdownlist_valueChange_0_listener($event) { return ctx.value = $event; })("valueChange", function FormatDropDownListComponent_Template_kendo_dropdownlist_valueChange_0_listener($event) { return ctx.onValueChange($event); });
        ɵngcc0.ɵɵtemplate(2, FormatDropDownListComponent_ng_template_2_Template, 10, 9, "ng-template", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("defaultItem", ctx.defaultItem)("textField", "text")("valueField", "tag")("data", ctx.data)("value", ctx.value)("valuePrimitive", true)("itemDisabled", ctx.itemDisabled)("disabled", ctx.disabled)("tabindex", ctx.tabindex);
        ɵngcc0.ɵɵattribute("title", ctx.title);
    } }, directives: function () { return [ɵngcc7.DropDownListComponent, DropDownToolDirective, ɵngcc7.ItemTemplateDirective, ɵngcc4.NgSwitch, ɵngcc4.NgSwitchCase, ɵngcc4.NgSwitchDefault]; }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array)
], FormatDropDownListComponent.prototype, "data", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FormatDropDownListComponent.prototype, "value", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], FormatDropDownListComponent.prototype, "defaultItem", void 0);
__decorate([
    Input(),
    __metadata("design:type", Function)
], FormatDropDownListComponent.prototype, "itemDisabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FormatDropDownListComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], FormatDropDownListComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], FormatDropDownListComponent.prototype, "tabindex", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], FormatDropDownListComponent.prototype, "valueChange", void 0);
__decorate([
    ViewChild('element', { static: true }),
    __metadata("design:type", ElementRef)
], FormatDropDownListComponent.prototype, "element", void 0);
__decorate([
    ViewChild('element', { read: DropDownListComponent, static: true }),
    __metadata("design:type", DropDownListComponent)
], FormatDropDownListComponent.prototype, "dropDownList", void 0);

/**
 * @hidden
 */
let FormatDialogComponent = class FormatDialogComponent extends DialogContentBase {
    constructor(dialog, localization) {
        super(dialog);
        this.dialog = dialog;
        this.localization = localization;
        this.data = [];
    }
    ngAfterViewInit() {
        Promise.resolve(null).then(() => {
            this.formatDropDownList.dropDownList.focus();
        });
    }
    onCancelAction() {
        this.dialog.close();
    }
    onConfirmAction() {
        if (this.value) {
            this.editor.exec('format', { tag: this.value });
        }
        this.dialog.close();
    }
    setData(args) {
        this.editor = args.editor;
        this.data = args.data;
        this.defaultItem = args.defaultItem;
        this.value = args.value;
        this.itemDisabled = args.itemDisabled;
    }
    textFor(key) {
        return this.localization.get(key);
    }
};
FormatDialogComponent.ɵfac = function FormatDialogComponent_Factory(t) { return new (t || FormatDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogRef), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService)); };
FormatDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormatDialogComponent, selectors: [["ng-component"]], viewQuery: function FormatDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c113, 7, FormatDropDownListComponent);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formatDropDownList = _t.first);
    } }, inputs: { editor: "editor" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 8, consts: [[3, "close"], [1, "k-editor-dialog"], [1, "k-editor-dialog", "k-popup-edit-form", "k-window-content", "k-content"], [1, "k-edit-form-container", "k-window-content", 2, "text-align", "center"], [3, "defaultItem", "data", "value", "itemDisabled", "valueChange"], ["formatDropDownList", ""], ["kendoButton", "", 3, "click"], ["kendoButton", "", 3, "primary", "click"]], template: function FormatDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dialog-titlebar", 0);
        ɵngcc0.ɵɵlistener("close", function FormatDialogComponent_Template_kendo_dialog_titlebar_close_0_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "div", 3)(5, "kendo-editor-format-dropdownlist", 4, 5);
        ɵngcc0.ɵɵlistener("valueChange", function FormatDialogComponent_Template_kendo_editor_format_dropdownlist_valueChange_5_listener($event) { return ctx.value = $event; });
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(7, "kendo-dialog-actions")(8, "button", 6);
        ɵngcc0.ɵɵlistener("click", function FormatDialogComponent_Template_button_click_8_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 7);
        ɵngcc0.ɵɵlistener("click", function FormatDialogComponent_Template_button_click_10_listener() { return ctx.onConfirmAction(); });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor("format"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("defaultItem", ctx.defaultItem)("data", ctx.data)("value", ctx.value)("itemDisabled", ctx.itemDisabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogCancel"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("primary", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogApply"));
    } }, directives: [ɵngcc1.DialogTitleBarComponent, FormatDropDownListComponent, ɵngcc1.DialogActionsComponent, ɵngcc2.ButtonDirective], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", EditorComponent)
], FormatDialogComponent.prototype, "editor", void 0);
__decorate([
    ViewChild('formatDropDownList', { read: FormatDropDownListComponent, static: true }),
    __metadata("design:type", FormatDropDownListComponent)
], FormatDialogComponent.prototype, "formatDropDownList", void 0);
FormatDialogComponent = __decorate([ __metadata("design:paramtypes", [DialogRef,
        EditorLocalizationService])
], FormatDialogComponent);

/**
 * @hidden
 */
let ColorPickerDialogComponent = class ColorPickerDialogComponent extends DialogContentBase {
    constructor(dialog, localization) {
        super(dialog);
        this.dialog = dialog;
        this.localization = localization;
    }
    ngAfterViewInit() {
        Promise.resolve(null).then(() => {
            this.colorPicker.focus();
        });
    }
    handleActiveColorClick(event) {
        event.preventOpen();
        this.value = event.color;
    }
    onCancelAction() {
        this.dialog.close();
    }
    onConfirmAction() {
        if (this.value) {
            this.editor.exec(this.editorCommand, this.value);
        }
        this.dialog.close();
    }
    setData(args) {
        this.editor = args.editor;
        this.value = args.value;
        this.editorCommand = args.editorCommand;
        this.paletteSettings = args.paletteSettings;
        this.icon = args.icon;
        this.view = args.view;
    }
    textFor(key) {
        return this.localization.get(key);
    }
};
ColorPickerDialogComponent.ɵfac = function ColorPickerDialogComponent_Factory(t) { return new (t || ColorPickerDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogRef), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService)); };
ColorPickerDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ColorPickerDialogComponent, selectors: [["ng-component"]], viewQuery: function ColorPickerDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c114, 7, ColorPickerComponent);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.colorPicker = _t.first);
    } }, inputs: { editor: "editor" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 10, consts: [[3, "close"], [1, "k-editor-dialog"], [1, "k-editor-dialog", "k-popup-edit-form", "k-window-content", "k-content"], [1, "k-edit-form-container", "k-window-content", 2, "text-align", "center"], [3, "view", "format", "icon", "value", "paletteSettings", "valueChange", "activeColorClick"], ["colorpicker", ""], ["kendoButton", "", 3, "click"], ["kendoButton", "", 3, "primary", "click"]], template: function ColorPickerDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dialog-titlebar", 0);
        ɵngcc0.ɵɵlistener("close", function ColorPickerDialogComponent_Template_kendo_dialog_titlebar_close_0_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "div", 3)(5, "kendo-colorpicker", 4, 5);
        ɵngcc0.ɵɵlistener("valueChange", function ColorPickerDialogComponent_Template_kendo_colorpicker_valueChange_5_listener($event) { return ctx.value = $event; })("activeColorClick", function ColorPickerDialogComponent_Template_kendo_colorpicker_activeColorClick_5_listener($event) { return ctx.handleActiveColorClick($event); });
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(7, "kendo-dialog-actions")(8, "button", 6);
        ɵngcc0.ɵɵlistener("click", function ColorPickerDialogComponent_Template_button_click_8_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 7);
        ɵngcc0.ɵɵlistener("click", function ColorPickerDialogComponent_Template_button_click_10_listener() { return ctx.onConfirmAction(); });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor(ctx.editorCommand), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("view", ctx.view)("format", "hex")("icon", ctx.icon)("value", ctx.value)("paletteSettings", ctx.paletteSettings);
        ɵngcc0.ɵɵattribute("title", ctx.title);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogCancel"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("primary", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogApply"));
    } }, directives: [ɵngcc1.DialogTitleBarComponent, ɵngcc8.ColorPickerComponent, ɵngcc1.DialogActionsComponent, ɵngcc2.ButtonDirective], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", EditorComponent)
], ColorPickerDialogComponent.prototype, "editor", void 0);
__decorate([
    ViewChild('colorpicker', { read: ColorPickerComponent, static: true }),
    __metadata("design:type", ColorPickerComponent)
], ColorPickerDialogComponent.prototype, "colorPicker", void 0);
ColorPickerDialogComponent = __decorate([ __metadata("design:paramtypes", [DialogRef,
        EditorLocalizationService])
], ColorPickerDialogComponent);

/**
 * @hidden
 */
let FontFamilyDropDownListComponent = class FontFamilyDropDownListComponent {
    /**
     * @hidden
     */
    constructor() {
        this.valueChange = new EventEmitter();
    }
    onValueChange(tag) {
        this.valueChange.emit(tag);
    }
    focus() {
        this.dropDownList.focus();
    }
};
FontFamilyDropDownListComponent.ɵfac = function FontFamilyDropDownListComponent_Factory(t) { return new (t || FontFamilyDropDownListComponent)(); };
FontFamilyDropDownListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FontFamilyDropDownListComponent, selectors: [["kendo-editor-fontfamily-dropdownlist"]], viewQuery: function FontFamilyDropDownListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c112, 7);
        ɵngcc0.ɵɵviewQuery(_c112, 7, DropDownListComponent);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.element = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropDownList = _t.first);
    } }, inputs: { data: "data", value: "value", defaultItem: "defaultItem", itemDisabled: "itemDisabled", title: "title", disabled: "disabled", tabindex: "tabindex" }, outputs: { valueChange: "valueChange" }, decls: 3, vars: 10, consts: [["kendoEditorDropDownTool", "", 3, "defaultItem", "textField", "valueField", "data", "value", "valuePrimitive", "itemDisabled", "disabled", "tabindex", "valueChange"], ["element", ""], ["kendoDropDownListItemTemplate", ""], [3, "ngStyle"]], template: function FontFamilyDropDownListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dropdownlist", 0, 1);
        ɵngcc0.ɵɵlistener("valueChange", function FontFamilyDropDownListComponent_Template_kendo_dropdownlist_valueChange_0_listener($event) { return ctx.value = $event; })("valueChange", function FontFamilyDropDownListComponent_Template_kendo_dropdownlist_valueChange_0_listener($event) { return ctx.onValueChange($event); });
        ɵngcc0.ɵɵtemplate(2, FontFamilyDropDownListComponent_ng_template_2_Template, 2, 4, "ng-template", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("defaultItem", ctx.defaultItem)("textField", "text")("valueField", "fontName")("data", ctx.data)("value", ctx.value)("valuePrimitive", true)("itemDisabled", ctx.itemDisabled)("disabled", ctx.disabled)("tabindex", ctx.tabindex);
        ɵngcc0.ɵɵattribute("title", ctx.title);
    } }, directives: function () { return [ɵngcc7.DropDownListComponent, DropDownToolDirective, ɵngcc7.ItemTemplateDirective, ɵngcc4.NgStyle]; }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array)
], FontFamilyDropDownListComponent.prototype, "data", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FontFamilyDropDownListComponent.prototype, "value", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], FontFamilyDropDownListComponent.prototype, "defaultItem", void 0);
__decorate([
    Input(),
    __metadata("design:type", Function)
], FontFamilyDropDownListComponent.prototype, "itemDisabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FontFamilyDropDownListComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], FontFamilyDropDownListComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], FontFamilyDropDownListComponent.prototype, "tabindex", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], FontFamilyDropDownListComponent.prototype, "valueChange", void 0);
__decorate([
    ViewChild('element', { static: true }),
    __metadata("design:type", ElementRef)
], FontFamilyDropDownListComponent.prototype, "element", void 0);
__decorate([
    ViewChild('element', { read: DropDownListComponent, static: true }),
    __metadata("design:type", DropDownListComponent)
], FontFamilyDropDownListComponent.prototype, "dropDownList", void 0);

/**
 * @hidden
 */
let FontFamilyDialogComponent = class FontFamilyDialogComponent extends DialogContentBase {
    constructor(dialog, localization) {
        super(dialog);
        this.dialog = dialog;
        this.localization = localization;
        this.data = [];
    }
    ngAfterViewInit() {
        Promise.resolve(null).then(() => {
            this.fontFamilyDropDownList.dropDownList.focus();
        });
    }
    onCancelAction() {
        this.dialog.close();
    }
    onConfirmAction() {
        if (this.value) {
            this.editor.exec('fontFamily', this.value);
        }
        this.dialog.close();
    }
    setData(args) {
        this.editor = args.editor;
        this.data = args.data;
        this.defaultItem = args.defaultItem;
        this.value = args.value;
        this.itemDisabled = args.itemDisabled;
    }
    textFor(key) {
        return this.localization.get(key);
    }
};
FontFamilyDialogComponent.ɵfac = function FontFamilyDialogComponent_Factory(t) { return new (t || FontFamilyDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogRef), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService)); };
FontFamilyDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FontFamilyDialogComponent, selectors: [["ng-component"]], viewQuery: function FontFamilyDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c116, 7, FontFamilyDropDownListComponent);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fontFamilyDropDownList = _t.first);
    } }, inputs: { editor: "editor" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 8, consts: [[3, "close"], [1, "k-editor-dialog"], [1, "k-editor-dialog", "k-popup-edit-form", "k-window-content", "k-content"], [1, "k-edit-form-container", "k-window-content", 2, "text-align", "center"], [3, "defaultItem", "data", "value", "itemDisabled", "valueChange"], ["fontFamilyDropDownList", ""], ["kendoButton", "", 3, "click"], ["kendoButton", "", 3, "primary", "click"]], template: function FontFamilyDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dialog-titlebar", 0);
        ɵngcc0.ɵɵlistener("close", function FontFamilyDialogComponent_Template_kendo_dialog_titlebar_close_0_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "div", 3)(5, "kendo-editor-fontfamily-dropdownlist", 4, 5);
        ɵngcc0.ɵɵlistener("valueChange", function FontFamilyDialogComponent_Template_kendo_editor_fontfamily_dropdownlist_valueChange_5_listener($event) { return ctx.value = $event; });
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(7, "kendo-dialog-actions")(8, "button", 6);
        ɵngcc0.ɵɵlistener("click", function FontFamilyDialogComponent_Template_button_click_8_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 7);
        ɵngcc0.ɵɵlistener("click", function FontFamilyDialogComponent_Template_button_click_10_listener() { return ctx.onConfirmAction(); });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor("fontFamily"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("defaultItem", ctx.defaultItem)("data", ctx.data)("value", ctx.value)("itemDisabled", ctx.itemDisabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogCancel"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("primary", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogApply"));
    } }, directives: [ɵngcc1.DialogTitleBarComponent, FontFamilyDropDownListComponent, ɵngcc1.DialogActionsComponent, ɵngcc2.ButtonDirective], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", EditorComponent)
], FontFamilyDialogComponent.prototype, "editor", void 0);
__decorate([
    ViewChild('fontFamilyDropDownList', { read: FontFamilyDropDownListComponent, static: true }),
    __metadata("design:type", FontFamilyDropDownListComponent)
], FontFamilyDialogComponent.prototype, "fontFamilyDropDownList", void 0);
FontFamilyDialogComponent = __decorate([ __metadata("design:paramtypes", [DialogRef,
        EditorLocalizationService])
], FontFamilyDialogComponent);

/**
 * @hidden
 */
let InsertTableDialogComponent = class InsertTableDialogComponent extends DialogContentBase {
    constructor(dialog, localization) {
        super(dialog);
        this.dialog = dialog;
        this.localization = localization;
    }
    onCancelAction() {
        this.dialog.close();
        this.editor.view.focus();
    }
    onCellClick(args) {
        this.dialog.close();
        this.editor.exec("insertTable", args);
        this.editor.view.focus();
    }
    setData(args) {
        this.editor = args.editor;
    }
    textFor(key) {
        return this.localization.get(key);
    }
};
InsertTableDialogComponent.ɵfac = function InsertTableDialogComponent_Factory(t) { return new (t || InsertTableDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogRef), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService)); };
InsertTableDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InsertTableDialogComponent, selectors: [["ng-component"]], inputs: { editor: "editor" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 2, consts: [[3, "close"], [1, "k-editor-dialog"], [1, "k-editor-dialog", "k-popup-edit-form", "k-window-content", "k-content"], [1, "k-ct-popup", "k-window-content", 2, "text-align", "center"], [3, "cellClick"], ["kendoButton", "", 3, "click"]], template: function InsertTableDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dialog-titlebar", 0);
        ɵngcc0.ɵɵlistener("close", function InsertTableDialogComponent_Template_kendo_dialog_titlebar_close_0_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "div", 3)(5, "kendo-popup-table-grid", 4);
        ɵngcc0.ɵɵlistener("cellClick", function InsertTableDialogComponent_Template_kendo_popup_table_grid_cellClick_5_listener($event) { return ctx.onCellClick($event); });
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(6, "kendo-dialog-actions")(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function InsertTableDialogComponent_Template_button_click_7_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor("insertTable"), " ");
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogCancel"));
    } }, directives: function () { return [ɵngcc1.DialogTitleBarComponent, PopupTableGridComponent, ɵngcc1.DialogActionsComponent, ɵngcc2.ButtonDirective]; }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", EditorComponent)
], InsertTableDialogComponent.prototype, "editor", void 0);
InsertTableDialogComponent = __decorate([ __metadata("design:paramtypes", [DialogRef,
        EditorLocalizationService])
], InsertTableDialogComponent);

var EditorFormatComponent_1;
/**
 * A component which configures an existing `DropDownListComponent` as an Editor tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The component associates a `kendo-dropdownlist` with an Editor command that changes the format of a content block and
 * automatically defines the options of the drop-down list and sets its values.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
 * ```
 */
let EditorFormatComponent = EditorFormatComponent_1 = class EditorFormatComponent extends ToolBarToolComponent {
    constructor(editor, dialogService, localization, toolsService) {
        super();
        this.editor = editor;
        this.dialogService = dialogService;
        this.localization = localization;
        this.toolsService = toolsService;
        this.disabled = false;
        this.tabindex = -1;
        /**
         * Fires when the user updates the value of the drop-down list.
         */
        this.valueChange = new EventEmitter();
        this._data = [
            { text: 'Paragraph', tag: 'p' },
            { text: 'Quotation', tag: 'blockquote' },
            { text: 'Heading 1', tag: 'h1' },
            { text: 'Heading 2', tag: 'h2' },
            { text: 'Heading 3', tag: 'h3' },
            { text: 'Heading 4', tag: 'h4' },
            { text: 'Heading 5', tag: 'h5' },
            { text: 'Heading 6', tag: 'h6' }
        ];
    }
    /**
     * Overrides the default format items list.
     */
    set data(formatItems) {
        this._data = formatItems || this._data;
    }
    get data() {
        return this._data;
    }
    ngOnInit() {
        this.itemDisabled = (itemArgs) => {
            if (!this.overflows && this.formatDropDownList && !this.formatDropDownList.dropDownList.isOpen) {
                return true; //disable all items in order to prevent navigation when DDL is closed
            }
            else {
                return itemArgs.dataItem.tag === null;
            }
        };
        setTimeout(() => {
            this.defaultItem = { text: this.title, tag: null };
            this.toolsService.needsCheck.next();
        });
        this.subs = this.editor.stateChange.subscribe(({ format }) => {
            const index = this.data.findIndex(item => item.tag === format.selected.tag);
            this.value = index !== -1 ? format.selected.tag : null;
            this.disabled = format.disabled;
        });
    }
    /**
     * @hidden
     */
    onValueChange(ev) {
        if (isPresent(ev)) {
            this.editor.exec('format', { tag: ev });
            this.editor.view.focus();
            this.valueChange.emit(this.data.find(d => d.tag === ev));
        }
    }
    ngOnDestroy() {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
    get outerWidth() {
        const element = this.formatDropDownList.element;
        if (element) {
            return outerWidth(element.nativeElement);
        }
    }
    get title() {
        return this.localization.get('format');
    }
    /**
     * @hidden
     */
    openDialog() {
        const dialogSettings = {
            appendTo: this.editor.dialogContainer,
            content: FormatDialogComponent
        };
        this.editor.toolbar.toggle(false);
        const dialogContent = this.dialogService.open(dialogSettings).content.instance;
        dialogContent.setData({
            editor: this.editor,
            data: this.data,
            defaultItem: this.defaultItem,
            value: this.value,
            itemDisabled: this.itemDisabled
        });
    }
    /**
     * @hidden
     */
    canFocus() {
        return !this.disabled;
    }
    /**
     * @hidden
     */
    focus() {
        this.tabindex = 0;
        if (this.overflows) {
            this.formatButton.nativeElement.focus();
        }
        else {
            this.formatDropDownList.focus();
        }
    }
    /**
     * @hidden
     */
    handleKey() {
        this.tabindex = -1;
        return false;
    }
};
EditorFormatComponent.ɵfac = function EditorFormatComponent_Factory(t) { return new (t || EditorFormatComponent)(ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogService), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorFormatComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditorFormatComponent, selectors: [["kendo-toolbar-dropdownlist", "kendoEditorFormat", ""]], viewQuery: function EditorFormatComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c117, 7);
        ɵngcc0.ɵɵviewQuery(_c118, 7);
        ɵngcc0.ɵɵviewQuery(_c113, 5);
        ɵngcc0.ɵɵviewQuery(_c119, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toolbarTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formatDropDownList = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formatButton = _t.first);
    } }, inputs: { data: "data" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: ToolBarToolComponent, useExisting: forwardRef(() => EditorFormatComponent_1) }]), ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c120, decls: 4, vars: 0, consts: [["toolbarTemplate", ""], ["popupTemplate", ""], [3, "defaultItem", "data", "value", "itemDisabled", "title", "disabled", "tabindex", "valueChange"], ["formatDropDownList", ""], ["type", "button", "kendoButton", "", 1, "k-overflow-button", 3, "tabindex", "icon", "disabled", "click"], ["formatButton", ""]], template: function EditorFormatComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EditorFormatComponent_ng_template_0_Template, 2, 7, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, EditorFormatComponent_ng_template_2_Template, 3, 6, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, directives: [FormatDropDownListComponent, ɵngcc2.ButtonDirective], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], EditorFormatComponent.prototype, "data", null);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], EditorFormatComponent.prototype, "valueChange", void 0);
__decorate([
    ViewChild('toolbarTemplate', { static: true }),
    __metadata("design:type", TemplateRef)
], EditorFormatComponent.prototype, "toolbarTemplate", void 0);
__decorate([
    ViewChild('popupTemplate', { static: true }),
    __metadata("design:type", TemplateRef)
], EditorFormatComponent.prototype, "popupTemplate", void 0);
__decorate([
    ViewChild('formatDropDownList', { static: false }),
    __metadata("design:type", FormatDropDownListComponent)
], EditorFormatComponent.prototype, "formatDropDownList", void 0);
__decorate([
    ViewChild('formatButton', { static: false }),
    __metadata("design:type", ElementRef)
], EditorFormatComponent.prototype, "formatButton", void 0);
EditorFormatComponent = EditorFormatComponent_1 = __decorate([ __param(0, Host()),
    __metadata("design:paramtypes", [EditorComponent,
        DialogService,
        EditorLocalizationService,
        EditorToolsService])
], EditorFormatComponent);

/**
 * @hidden
 */
let FontSizeDropDownListComponent = class FontSizeDropDownListComponent {
    /**
     * @hidden
     */
    constructor() {
        this.valueChange = new EventEmitter();
    }
    onValueChange(size) {
        this.valueChange.emit(size);
    }
    focus() {
        this.dropDownList.focus();
    }
};
FontSizeDropDownListComponent.ɵfac = function FontSizeDropDownListComponent_Factory(t) { return new (t || FontSizeDropDownListComponent)(); };
FontSizeDropDownListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FontSizeDropDownListComponent, selectors: [["kendo-editor-fontsize-dropdownlist"]], viewQuery: function FontSizeDropDownListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c112, 7);
        ɵngcc0.ɵɵviewQuery(_c112, 7, DropDownListComponent);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.element = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropDownList = _t.first);
    } }, inputs: { data: "data", value: "value", defaultItem: "defaultItem", itemDisabled: "itemDisabled", title: "title", disabled: "disabled", tabindex: "tabindex" }, outputs: { valueChange: "valueChange" }, decls: 2, vars: 10, consts: [["kendoEditorDropDownTool", "", 3, "defaultItem", "textField", "valueField", "data", "value", "valuePrimitive", "itemDisabled", "disabled", "tabindex", "valueChange"], ["element", ""]], template: function FontSizeDropDownListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dropdownlist", 0, 1);
        ɵngcc0.ɵɵlistener("valueChange", function FontSizeDropDownListComponent_Template_kendo_dropdownlist_valueChange_0_listener($event) { return ctx.value = $event; })("valueChange", function FontSizeDropDownListComponent_Template_kendo_dropdownlist_valueChange_0_listener($event) { return ctx.onValueChange($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("defaultItem", ctx.defaultItem)("textField", "text")("valueField", "size")("data", ctx.data)("value", ctx.value)("valuePrimitive", true)("itemDisabled", ctx.itemDisabled)("disabled", ctx.disabled)("tabindex", ctx.tabindex);
        ɵngcc0.ɵɵattribute("title", ctx.title);
    } }, directives: function () { return [ɵngcc7.DropDownListComponent, DropDownToolDirective]; }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array)
], FontSizeDropDownListComponent.prototype, "data", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FontSizeDropDownListComponent.prototype, "value", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], FontSizeDropDownListComponent.prototype, "defaultItem", void 0);
__decorate([
    Input(),
    __metadata("design:type", Function)
], FontSizeDropDownListComponent.prototype, "itemDisabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FontSizeDropDownListComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], FontSizeDropDownListComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], FontSizeDropDownListComponent.prototype, "tabindex", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], FontSizeDropDownListComponent.prototype, "valueChange", void 0);
__decorate([
    ViewChild('element', { static: true }),
    __metadata("design:type", ElementRef)
], FontSizeDropDownListComponent.prototype, "element", void 0);
__decorate([
    ViewChild('element', { read: DropDownListComponent, static: true }),
    __metadata("design:type", DropDownListComponent)
], FontSizeDropDownListComponent.prototype, "dropDownList", void 0);

/**
 * @hidden
 */
let FontSizeDialogComponent = class FontSizeDialogComponent extends DialogContentBase {
    constructor(dialog, localization) {
        super(dialog);
        this.dialog = dialog;
        this.localization = localization;
        this.data = [];
    }
    ngAfterViewInit() {
        Promise.resolve(null).then(() => {
            this.fontSizeDropDownList.dropDownList.focus();
        });
    }
    onCancelAction() {
        this.dialog.close();
    }
    onConfirmAction() {
        if (this.value) {
            this.editor.exec('fontSize', this.value);
        }
        this.dialog.close();
    }
    setData(args) {
        this.editor = args.editor;
        this.data = args.data;
        this.defaultItem = args.defaultItem;
        this.value = args.value;
        this.itemDisabled = args.itemDisabled;
    }
    textFor(key) {
        return this.localization.get(key);
    }
};
FontSizeDialogComponent.ɵfac = function FontSizeDialogComponent_Factory(t) { return new (t || FontSizeDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogRef), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService)); };
FontSizeDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FontSizeDialogComponent, selectors: [["ng-component"]], viewQuery: function FontSizeDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c121, 7, FontSizeDropDownListComponent);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fontSizeDropDownList = _t.first);
    } }, inputs: { editor: "editor" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 8, consts: [[3, "close"], [1, "k-editor-dialog"], [1, "k-editor-dialog", "k-popup-edit-form", "k-window-content", "k-content"], [1, "k-edit-form-container", "k-window-content", 2, "text-align", "center"], [3, "defaultItem", "data", "value", "itemDisabled", "valueChange"], ["fontSizeDropDownList", ""], ["kendoButton", "", 3, "click"], ["kendoButton", "", 3, "primary", "click"]], template: function FontSizeDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-dialog-titlebar", 0);
        ɵngcc0.ɵɵlistener("close", function FontSizeDialogComponent_Template_kendo_dialog_titlebar_close_0_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "div", 3)(5, "kendo-editor-fontsize-dropdownlist", 4, 5);
        ɵngcc0.ɵɵlistener("valueChange", function FontSizeDialogComponent_Template_kendo_editor_fontsize_dropdownlist_valueChange_5_listener($event) { return ctx.value = $event; });
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(7, "kendo-dialog-actions")(8, "button", 6);
        ɵngcc0.ɵɵlistener("click", function FontSizeDialogComponent_Template_button_click_8_listener() { return ctx.onCancelAction(); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 7);
        ɵngcc0.ɵɵlistener("click", function FontSizeDialogComponent_Template_button_click_10_listener() { return ctx.onConfirmAction(); });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor("fontSize"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("defaultItem", ctx.defaultItem)("data", ctx.data)("value", ctx.value)("itemDisabled", ctx.itemDisabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogCancel"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("primary", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dialogApply"));
    } }, directives: [ɵngcc1.DialogTitleBarComponent, FontSizeDropDownListComponent, ɵngcc1.DialogActionsComponent, ɵngcc2.ButtonDirective], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", EditorComponent)
], FontSizeDialogComponent.prototype, "editor", void 0);
__decorate([
    ViewChild('fontSizeDropDownList', { read: FontSizeDropDownListComponent, static: true }),
    __metadata("design:type", FontSizeDropDownListComponent)
], FontSizeDialogComponent.prototype, "fontSizeDropDownList", void 0);
FontSizeDialogComponent = __decorate([ __metadata("design:paramtypes", [DialogRef,
        EditorLocalizationService])
], FontSizeDialogComponent);

var EditorFontSizeComponent_1;
/**
 * A component which configures an existing `DropDownListComponent` as an Editor tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The component associates a `kendo-dropdownlist` with an Editor command that changes the font size of a content block and
 * automatically defines the options of the drop-down list and sets its values.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
 * ```
 */
let EditorFontSizeComponent = EditorFontSizeComponent_1 = class EditorFontSizeComponent extends ToolBarToolComponent {
    constructor(editor, dialogService, localization, toolsService) {
        super();
        this.editor = editor;
        this.dialogService = dialogService;
        this.localization = localization;
        this.toolsService = toolsService;
        this.disabled = false;
        this.tabindex = -1;
        /**
         * Fires when the user updates the value of the drop-down list.
         */
        this.valueChange = new EventEmitter();
        this._data = [
            { text: '8px', size: 8 },
            { text: '10px', size: 10 },
            { text: '12px', size: 12 },
            { text: '14px', size: 14 },
            { text: '18px', size: 18 },
            { text: '24px', size: 24 },
            { text: '36px', size: 36 }
        ];
    }
    /**
     * Overrides the default font size list.
     */
    set data(sizes) {
        this._data = sizes || this._data;
    }
    get data() {
        return this._data;
    }
    ngOnInit() {
        this.itemDisabled = itemArgs => {
            if (!this.overflows && this.fontSizeDropDownList && !this.fontSizeDropDownList.dropDownList.isOpen) {
                return true; //disable all items in order to prevent navigation when DDL is closed
            }
            else {
                return itemArgs.dataItem.size === null;
            }
        };
        setTimeout(() => {
            this.defaultItem = { text: this.title, size: null };
            this.toolsService.needsCheck.next();
        });
        this.subs = this.editor.stateChange.subscribe(({ style }) => {
            // remove units(px, em, rem...)
            // string#match returns array
            this.value = (getUniqueStyleValues(style.selected, 'font-size').match(/\d+/g) || [null])[0];
            this.disabled = style.disabled;
        });
    }
    /**
     * @hidden
     */
    onValueChange(ev) {
        if (isPresent(ev)) {
            this.editor.exec('fontSize', ev);
            this.editor.view.focus();
            this.valueChange.emit(this.data.find(d => d.size === parseInt(ev, 10)));
        }
    }
    ngOnDestroy() {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
    get outerWidth() {
        if (this.element) {
            return outerWidth(this.element.nativeElement);
        }
    }
    get title() {
        return this.localization.get('fontSize');
    }
    /**
     * @hidden
     */
    openDialog() {
        const dialogSettings = {
            appendTo: this.editor.dialogContainer,
            content: FontSizeDialogComponent
        };
        this.editor.toolbar.toggle(false);
        const dialogContent = this.dialogService.open(dialogSettings).content.instance;
        dialogContent.setData({
            editor: this.editor,
            data: this.data,
            defaultItem: this.defaultItem,
            value: this.value,
            itemDisabled: this.itemDisabled
        });
    }
    /**
     * @hidden
     */
    canFocus() {
        return !this.disabled;
    }
    /**
     * @hidden
     */
    focus() {
        this.tabindex = 0;
        if (this.overflows) {
            this.fontSizeButton.nativeElement.focus();
        }
        else {
            this.fontSizeDropDownList.focus();
        }
    }
    /**
     * @hidden
     */
    handleKey() {
        this.tabindex = -1;
        return false;
    }
};
EditorFontSizeComponent.ɵfac = function EditorFontSizeComponent_Factory(t) { return new (t || EditorFontSizeComponent)(ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogService), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorFontSizeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditorFontSizeComponent, selectors: [["kendo-toolbar-dropdownlist", "kendoEditorFontSize", ""]], viewQuery: function EditorFontSizeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c117, 7);
        ɵngcc0.ɵɵviewQuery(_c118, 7);
        ɵngcc0.ɵɵviewQuery(_c112, 5);
        ɵngcc0.ɵɵviewQuery(_c112, 5, FontSizeDropDownListComponent);
        ɵngcc0.ɵɵviewQuery(_c122, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toolbarTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.element = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fontSizeDropDownList = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fontSizeButton = _t.first);
    } }, inputs: { data: "data" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: ToolBarToolComponent, useExisting: forwardRef(() => EditorFontSizeComponent_1) }]), ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c123, decls: 4, vars: 0, consts: [["toolbarTemplate", ""], ["popupTemplate", ""], [3, "defaultItem", "data", "value", "itemDisabled", "title", "disabled", "tabindex", "valueChange"], ["element", ""], ["tabindex", "-1", "type", "button", "kendoButton", "", 1, "k-overflow-button", 3, "icon", "disabled", "tabindex", "click"], ["fontSizeButton", ""]], template: function EditorFontSizeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EditorFontSizeComponent_ng_template_0_Template, 2, 7, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, EditorFontSizeComponent_ng_template_2_Template, 3, 5, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, directives: [FontSizeDropDownListComponent, ɵngcc2.ButtonDirective], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], EditorFontSizeComponent.prototype, "data", null);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], EditorFontSizeComponent.prototype, "valueChange", void 0);
__decorate([
    ViewChild('toolbarTemplate', { static: true }),
    __metadata("design:type", TemplateRef)
], EditorFontSizeComponent.prototype, "toolbarTemplate", void 0);
__decorate([
    ViewChild('popupTemplate', { static: true }),
    __metadata("design:type", TemplateRef)
], EditorFontSizeComponent.prototype, "popupTemplate", void 0);
__decorate([
    ViewChild('element', { static: false }),
    __metadata("design:type", ElementRef)
], EditorFontSizeComponent.prototype, "element", void 0);
__decorate([
    ViewChild('element', { read: FontSizeDropDownListComponent, static: false }),
    __metadata("design:type", FontSizeDropDownListComponent)
], EditorFontSizeComponent.prototype, "fontSizeDropDownList", void 0);
__decorate([
    ViewChild('fontSizeButton', { static: false }),
    __metadata("design:type", ElementRef)
], EditorFontSizeComponent.prototype, "fontSizeButton", void 0);
EditorFontSizeComponent = EditorFontSizeComponent_1 = __decorate([ __param(0, Host()),
    __metadata("design:paramtypes", [EditorComponent,
        DialogService,
        EditorLocalizationService,
        EditorToolsService])
], EditorFontSizeComponent);

var EditorFontFamilyComponent_1;
/**
 * A component which configures an existing `DropDownListComponent` as an Editor tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The component associates a `kendo-toolbar-dropdownlist` with an Editor command that changes the font family of a content block and
 * automatically defines the options of the drop-down list and sets its values.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
 * ```
 */
let EditorFontFamilyComponent = EditorFontFamilyComponent_1 = class EditorFontFamilyComponent extends ToolBarToolComponent {
    constructor(editor, dialogService, localization, toolsService) {
        super();
        this.editor = editor;
        this.dialogService = dialogService;
        this.localization = localization;
        this.toolsService = toolsService;
        this.disabled = false;
        this.tabindex = -1;
        /**
         * Fires when the user updates the value of the drop-down list.
         */
        this.valueChange = new EventEmitter();
        this._data = [
            { text: 'Arial', fontName: 'Arial,"Helvetica Neue",Helvetica,sans-serif' },
            { text: 'Courier New', fontName: '"Courier New",Courier,"Lucida Sans Typewriter","Lucida Typewriter",monospace' },
            { text: 'Georgia', fontName: 'Georgia,Times,"Times New Roman",serif' },
            {
                fontName: 
                // tslint:disable-next-line:max-line-length
                'Impact,Haettenschweiler,"Franklin Gothic Bold",Charcoal,"Helvetica Inserat","Bitstream Vera Sans Bold","Arial Black","sans serif"',
                text: 'Impact'
            },
            { text: 'Lucida Console', fontName: '"Lucida Console","Lucida Sans Typewriter",monaco,"Bitstream Vera Sans Mono",monospace' },
            { text: 'Tahoma', fontName: 'Tahoma,Verdana,Segoe,sans-serif' },
            { text: 'Times New Roman', fontName: 'TimesNewRoman,"Times New Roman",Times,Baskerville,Georgia,serif' },
            { text: 'Trebuchet MS', fontName: '"Trebuchet MS","Lucida Grande","Lucida Sans Unicode","Lucida Sans",Tahoma,sans-serif' },
            { text: 'Verdana', fontName: 'Verdana,Geneva,sans-serif' }
        ];
    }
    /**
     * Overrides the default font list.
     */
    set data(fonts) {
        this._data = fonts || this._data;
    }
    get data() {
        return this._data;
    }
    ngOnInit() {
        this.itemDisabled = (itemArgs) => {
            if (!this.overflows && this.fontFamilyDropDownList && !this.fontFamilyDropDownList.dropDownList.isOpen) {
                return true; //disable all items in order to prevent navigation when DDL is closed
            }
            else {
                return itemArgs.dataItem.fontName === null;
            }
        };
        setTimeout(() => {
            this.defaultItem = { text: this.title, fontName: null };
            this.toolsService.needsCheck.next();
        });
        this.subs = this.editor.stateChange.subscribe(({ style }) => {
            this.value = getUniqueStyleValues(style.selected, 'font-family') || null;
            this.disabled = style.disabled;
        });
    }
    /**
     * @hidden
     */
    onValueChange(ev) {
        if (isPresent(ev)) {
            this.editor.exec('fontFamily', ev);
            this.editor.view.focus();
            this.valueChange.emit(this.data.find(f => f.fontName === ev));
        }
    }
    ngOnDestroy() {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
    get outerWidth() {
        if (this.element) {
            return outerWidth(this.element.nativeElement);
        }
    }
    get title() {
        return this.localization.get('fontFamily');
    }
    /**
     * @hidden
     */
    openDialog() {
        const dialogSettings = {
            appendTo: this.editor.dialogContainer,
            content: FontFamilyDialogComponent
        };
        this.editor.toolbar.toggle(false);
        const dialogContent = this.dialogService.open(dialogSettings).content.instance;
        dialogContent.setData({
            editor: this.editor,
            data: this.data,
            defaultItem: this.defaultItem,
            value: this.value,
            itemDisabled: this.itemDisabled
        });
    }
    /**
     * @hidden
     */
    canFocus() {
        return !this.disabled;
    }
    /**
     * @hidden
     */
    focus() {
        this.tabindex = 0;
        if (this.overflows) {
            this.fontFamilyButton.nativeElement.focus();
        }
        else {
            this.fontFamilyDropDownList.focus();
        }
    }
    /**
     * @hidden
     */
    handleKey() {
        this.tabindex = -1;
        return false;
    }
};
EditorFontFamilyComponent.ɵfac = function EditorFontFamilyComponent_Factory(t) { return new (t || EditorFontFamilyComponent)(ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogService), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorFontFamilyComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditorFontFamilyComponent, selectors: [["kendo-toolbar-dropdownlist", "kendoEditorFontFamily", ""]], viewQuery: function EditorFontFamilyComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c117, 7);
        ɵngcc0.ɵɵviewQuery(_c118, 7);
        ɵngcc0.ɵɵviewQuery(_c112, 5);
        ɵngcc0.ɵɵviewQuery(_c112, 5, FontFamilyDropDownListComponent);
        ɵngcc0.ɵɵviewQuery(_c124, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toolbarTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.element = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fontFamilyDropDownList = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fontFamilyButton = _t.first);
    } }, inputs: { data: "data" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: ToolBarToolComponent, useExisting: forwardRef(() => EditorFontFamilyComponent_1) }]), ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c125, decls: 4, vars: 0, consts: [["toolbarTemplate", ""], ["popupTemplate", ""], [3, "defaultItem", "data", "value", "itemDisabled", "title", "disabled", "tabindex", "valueChange"], ["element", ""], ["tabindex", "-1", "type", "button", "kendoButton", "", 1, "k-overflow-button", 3, "icon", "disabled", "tabindex", "click"], ["fontFamilyButton", ""]], template: function EditorFontFamilyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EditorFontFamilyComponent_ng_template_0_Template, 2, 7, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, EditorFontFamilyComponent_ng_template_2_Template, 3, 5, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, directives: [FontFamilyDropDownListComponent, ɵngcc2.ButtonDirective], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], EditorFontFamilyComponent.prototype, "data", null);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], EditorFontFamilyComponent.prototype, "valueChange", void 0);
__decorate([
    ViewChild('toolbarTemplate', { static: true }),
    __metadata("design:type", TemplateRef)
], EditorFontFamilyComponent.prototype, "toolbarTemplate", void 0);
__decorate([
    ViewChild('popupTemplate', { static: true }),
    __metadata("design:type", TemplateRef)
], EditorFontFamilyComponent.prototype, "popupTemplate", void 0);
__decorate([
    ViewChild('element', { static: false }),
    __metadata("design:type", ElementRef)
], EditorFontFamilyComponent.prototype, "element", void 0);
__decorate([
    ViewChild('element', { read: FontFamilyDropDownListComponent, static: false }),
    __metadata("design:type", FontFamilyDropDownListComponent)
], EditorFontFamilyComponent.prototype, "fontFamilyDropDownList", void 0);
__decorate([
    ViewChild('fontFamilyButton', { static: false }),
    __metadata("design:type", ElementRef)
], EditorFontFamilyComponent.prototype, "fontFamilyButton", void 0);
EditorFontFamilyComponent = EditorFontFamilyComponent_1 = __decorate([ __param(0, Host()),
    __metadata("design:paramtypes", [EditorComponent,
        DialogService,
        EditorLocalizationService,
        EditorToolsService])
], EditorFontFamilyComponent);

// tslint:disable:no-forward-ref
var EditorColorPickerComponent_1;
/**
 * A component which configures an existing ColorPickerComponent as a ToolBar tool.
 * To associate a `kendo-toolbar-colorpicker` with an Editor command that changes the
 * foreground or the background color of the text, use the `kendoEditorForeColor` or `kendoEditorBackColor` directive.
 */
let EditorColorPickerComponent = EditorColorPickerComponent_1 = class EditorColorPickerComponent extends ToolBarToolComponent {
    constructor(editor, localization, dialogService, ngZone) {
        super();
        this.editor = editor;
        this.localization = localization;
        this.dialogService = dialogService;
        this.ngZone = ngZone;
        this.tabindex = -1;
        /**
         * Specifies if the component should be disabled.
         */
        this.disabled = false;
        /**
         * Specifies whether the ColorPicker will render a gradient, palette or combo view.
         *
         * @default 'palette'
         */
        this.view = 'palette';
    }
    /**
     * @hidden
     */
    get title() {
        return this.localization.get(this.editorCommand);
    }
    ngOnInit() {
        this.subs = this.editor.stateChange.subscribe(({ style }) => {
            this.disabled = style.disabled;
        });
    }
    ngOnDestroy() {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
    /**
     * @hidden
     */
    handleValueChange(color) {
        this.editor.exec(this.editorCommand, color);
    }
    /**
     * @hidden
     */
    handleActiveColorClick(event) {
        event.preventOpen();
        this.handleValueChange(event.color);
    }
    /**
     * @hidden
     */
    onOpen(picker) {
        this.valueCache = picker.value;
        picker.reset();
    }
    /**
     * @hidden
     */
    onClose(picker) {
        if (!picker.value) {
            picker.value = this.valueCache;
        }
        this.ngZone.onStable.pipe(take(1)).subscribe(() => this.editor.view.focus());
    }
    /**
     * @hidden
     */
    get outerWidth() {
        if (this.element) {
            return outerWidth(this.element.nativeElement);
        }
    }
    /**
     * @hidden
     */
    openDialog() {
        const dialogSettings = {
            appendTo: this.editor.dialogContainer,
            content: ColorPickerDialogComponent
        };
        this.editor.toolbar.toggle(false);
        const dialogContent = this.dialogService.open(dialogSettings).content.instance;
        dialogContent.setData({
            editor: this.editor,
            value: this.value,
            title: this.title,
            editorCommand: this.editorCommand,
            paletteSettings: this.paletteSettings,
            icon: this.icon,
            view: this.view
        });
    }
    /**
     * @hidden
     */
    canFocus() {
        return !this.disabled;
    }
    /**
     * @hidden
     */
    focus() {
        this.tabindex = 0;
        if (this.overflows) {
            this.colorPickerButton.nativeElement.focus();
        }
        else {
            this.colorPicker.focus();
        }
    }
    /**
     * @hidden
     */
    handleKey() {
        this.tabindex = -1;
        return false;
    }
};
EditorColorPickerComponent.ɵfac = function EditorColorPickerComponent_Factory(t) { return new (t || EditorColorPickerComponent)(ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
EditorColorPickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditorColorPickerComponent, selectors: [["kendo-toolbar-colorpicker"]], viewQuery: function EditorColorPickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c117, 7);
        ɵngcc0.ɵɵviewQuery(_c118, 7);
        ɵngcc0.ɵɵviewQuery(_c114, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c114, 5, ColorPickerComponent);
        ɵngcc0.ɵɵviewQuery(_c126, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toolbarTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.element = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.colorPicker = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.colorPickerButton = _t.first);
    } }, inputs: { disabled: "disabled", view: "view", value: "value", icon: "icon", paletteSettings: "paletteSettings", editorCommand: "editorCommand" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: ToolBarToolComponent, useExisting: forwardRef(() => EditorColorPickerComponent_1) }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 0, consts: [["toolbarTemplate", ""], ["popupTemplate", ""], [3, "view", "format", "icon", "value", "paletteSettings", "disabled", "tabindex", "valueChange", "activeColorClick", "open", "close"], ["colorpicker", ""], ["tabindex", "-1", "type", "button", "kendoButton", "", 1, "k-overflow-button", 3, "icon", "disabled", "tabindex", "click"], ["colorPickerButton", ""]], template: function EditorColorPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EditorColorPickerComponent_ng_template_0_Template, 2, 8, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, EditorColorPickerComponent_ng_template_2_Template, 3, 5, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, directives: [ɵngcc8.ColorPickerComponent, ɵngcc2.ButtonDirective], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", String)
], EditorColorPickerComponent.prototype, "value", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], EditorColorPickerComponent.prototype, "icon", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EditorColorPickerComponent.prototype, "paletteSettings", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], EditorColorPickerComponent.prototype, "editorCommand", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], EditorColorPickerComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], EditorColorPickerComponent.prototype, "view", void 0);
__decorate([
    ViewChild('toolbarTemplate', { static: true }),
    __metadata("design:type", TemplateRef)
], EditorColorPickerComponent.prototype, "toolbarTemplate", void 0);
__decorate([
    ViewChild('popupTemplate', { static: true }),
    __metadata("design:type", TemplateRef)
], EditorColorPickerComponent.prototype, "popupTemplate", void 0);
__decorate([
    ViewChild('colorpicker', { read: ElementRef, static: false }),
    __metadata("design:type", ElementRef)
], EditorColorPickerComponent.prototype, "element", void 0);
__decorate([
    ViewChild('colorpicker', { read: ColorPickerComponent, static: false }),
    __metadata("design:type", ColorPickerComponent)
], EditorColorPickerComponent.prototype, "colorPicker", void 0);
__decorate([
    ViewChild('colorPickerButton', { read: ElementRef, static: false }),
    __metadata("design:type", ElementRef)
], EditorColorPickerComponent.prototype, "colorPickerButton", void 0);
EditorColorPickerComponent = EditorColorPickerComponent_1 = __decorate([ __param(0, Host()),
    __metadata("design:paramtypes", [EditorComponent,
        EditorLocalizationService,
        DialogService,
        NgZone])
], EditorColorPickerComponent);

var EditorInsertTableButtonComponent_1;
const popupWrapperWidth = '190px';
const popupWrapperHeight = '164px'; // Set to '192px' when TableWizard button is added;
/**
 * A toolbar component which allows the user to create and insert a table in the Editor's content.
 *
 * @example
 * ```ts-no-run
 * <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
 * ```
 */
let EditorInsertTableButtonComponent = EditorInsertTableButtonComponent_1 = class EditorInsertTableButtonComponent extends ToolBarToolComponent {
    constructor(editor, localization, popupService, dialogService) {
        super();
        this.editor = editor;
        this.localization = localization;
        this.popupService = popupService;
        this.dialogService = dialogService;
        this.open = false;
        this.buttonBlurred = new EventEmitter();
        this.cellClicked = new EventEmitter();
        this.subs = this.editor.stateChange.subscribe(({ insertTable }) => {
            this.disabled = insertTable.disabled;
        });
        this.subs.add(this.buttonBlurred.pipe(concatMap(() => interval(200).pipe(take(1), takeUntil(this.cellClicked)))).subscribe(() => {
            this.toggle(false);
        }));
    }
    ngOnDestroy() {
        this.destroyPopup();
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
    get outerWidth() {
        if (this.element) {
            return outerWidth(this.element.nativeElement);
        }
    }
    get title() {
        return this.localization.get('insertTable');
    }
    /**
     * @hidden
     */
    toggle(open) {
        this.open = open === undefined ? !this.open : open;
        this.destroyPopup();
        if (this.open) {
            this.createPopup();
        }
    }
    /**
     * @hidden
     */
    openDialog() {
        const dialogSettings = {
            appendTo: this.editor.dialogContainer,
            content: InsertTableDialogComponent
        };
        this.editor.toolbar.toggle(false);
        const dialogContent = this.dialogService.open(dialogSettings).content.instance;
        dialogContent.setData({
            editor: this.editor
        });
    }
    /**
     * @hidden
     */
    onBlur() {
        this.tabIndex = -1;
        this.buttonBlurred.emit();
    }
    /**
     * @hidden
     */
    onCellClick(args) {
        this.cellClicked.emit();
        this.toggle(false);
        this.editor.exec('insertTable', args);
    }
    /**
     * @hidden
     */
    canFocus() {
        return !this.disabled;
    }
    /**
     * @hidden
     */
    focus() {
        this.tabIndex = 0;
        this.getButton().focus();
    }
    /**
     * @hidden
     */
    handleKey(ev) {
        if (ev.keyCode === Keys.Space || ev.keyCode === Keys.Enter) {
            return true;
        }
        this.tabIndex = -1;
        return false;
    }
    /**
     * @hidden
     */
    onTableWizardClick() {
        // this.toggle(false);
        // this.editor.openDialog("tableWizard");
    }
    createPopup() {
        const horizontalAlign = this.editor.direction === 'rtl' ? 'right' : 'left';
        const anchorPosition = { horizontal: horizontalAlign, vertical: 'bottom' };
        const popupPosition = { horizontal: horizontalAlign, vertical: 'top' };
        this.popupRef = this.popupService.open({
            anchor: this.element,
            anchorAlign: anchorPosition,
            animate: true,
            content: this.popupGridTemplate,
            popupAlign: popupPosition,
            popupClass: 'k-ct-popup k-group k-reset k-state-border-up',
            positionMode: 'absolute'
        });
        const popupWrapper = this.popupRef.popupElement;
        popupWrapper.style.width = popupWrapperWidth;
        popupWrapper.style.height = popupWrapperHeight;
        popupWrapper.setAttribute('dir', this.editor.direction);
    }
    destroyPopup() {
        if (this.popupRef) {
            this.popupRef.close();
            this.popupRef = null;
        }
    }
    getButton() {
        return (this.overflows ? this.overflowElement : this.element).nativeElement;
    }
};
EditorInsertTableButtonComponent.ɵfac = function EditorInsertTableButtonComponent_Factory(t) { return new (t || EditorInsertTableButtonComponent)(ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc9.PopupService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DialogService)); };
EditorInsertTableButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditorInsertTableButtonComponent, selectors: [["kendo-editor-insert-table-button"]], viewQuery: function EditorInsertTableButtonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c117, 7);
        ɵngcc0.ɵɵviewQuery(_c118, 5);
        ɵngcc0.ɵɵviewQuery(_c112, 5);
        ɵngcc0.ɵɵviewQuery(_c127, 5);
        ɵngcc0.ɵɵviewQuery(_c128, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toolbarTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.element = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overflowElement = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popupGridTemplate = _t.first);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: ToolBarToolComponent, useExisting: forwardRef(() => EditorInsertTableButtonComponent_1) }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 0, consts: [["toolbarTemplate", ""], ["popupTemplate", ""], ["popupGridTemplate", ""], ["type", "button", "kendoButton", "", 3, "icon", "disabled", "click", "blur"], ["element", ""], ["kendoButton", "", 3, "icon", "disabled", "click"], ["overflowElement", ""], [3, "cellClick", "tableWizardClick"]], template: function EditorInsertTableButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EditorInsertTableButtonComponent_ng_template_0_Template, 2, 4, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, EditorInsertTableButtonComponent_ng_template_2_Template, 3, 5, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, EditorInsertTableButtonComponent_ng_template_4_Template, 1, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, directives: function () { return [ɵngcc2.ButtonDirective, PopupTableGridComponent]; }, encapsulation: 2 });
__decorate([
    ViewChild('toolbarTemplate', { static: true }),
    __metadata("design:type", TemplateRef)
], EditorInsertTableButtonComponent.prototype, "toolbarTemplate", void 0);
__decorate([
    ViewChild('popupTemplate', { static: false }),
    __metadata("design:type", TemplateRef)
], EditorInsertTableButtonComponent.prototype, "popupTemplate", void 0);
__decorate([
    ViewChild('element', { static: false }),
    __metadata("design:type", ElementRef)
], EditorInsertTableButtonComponent.prototype, "element", void 0);
__decorate([
    ViewChild('overflowElement', { static: false }),
    __metadata("design:type", ElementRef)
], EditorInsertTableButtonComponent.prototype, "overflowElement", void 0);
__decorate([
    ViewChild('popupGridTemplate', { static: true }),
    __metadata("design:type", TemplateRef)
], EditorInsertTableButtonComponent.prototype, "popupGridTemplate", void 0);
EditorInsertTableButtonComponent = EditorInsertTableButtonComponent_1 = __decorate([ __param(0, Host()),
    __metadata("design:paramtypes", [EditorComponent,
        EditorLocalizationService,
        PopupService,
        DialogService])
], EditorInsertTableButtonComponent);

/**
 * @hidden
 */
let PopupTableGridComponent = class PopupTableGridComponent {
    /**
     * @hidden
     */
    constructor() {
        this.cellClick = new EventEmitter();
        this.tableWizardClick = new EventEmitter();
        this.state = { rows: -1, cols: -1 };
        this.rows = 6;
        this.cols = 8;
    }
    get message() {
        const { rows, cols } = this.state;
        return `Create a ${rows > -1 ? rows + 1 : ''} ${cols > -1 ? 'x' : ''} ${cols > -1 ? cols + 1 : ''} table`;
    }
    get cells() {
        return Array.from(Array(this.rows * this.cols).keys());
    }
    selected(index) {
        const { rows, cols } = this.state;
        const cellRow = Math.floor(index / this.cols);
        const cellCol = index % this.cols;
        return cellRow <= rows && cellCol <= cols;
    }
    setState(index) {
        const rows = Math.floor(index / this.cols);
        const cols = index % this.cols;
        this.state = { rows: rows, cols: cols };
    }
    resetState() {
        this.state = { rows: -1, cols: -1 };
    }
    insertTable() {
        this.cellClick.emit(this.state);
    }
    openTableWizard() {
        this.tableWizardClick.emit();
    }
};
PopupTableGridComponent.ɵfac = function PopupTableGridComponent_Factory(t) { return new (t || PopupTableGridComponent)(); };
PopupTableGridComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PopupTableGridComponent, selectors: [["kendo-popup-table-grid"]], outputs: { cellClick: "cellClick", tableWizardClick: "tableWizardClick" }, decls: 4, vars: 2, consts: [[2, "border-color", "inherit", 3, "mouseleave", "click"], ["class", "k-ct-cell", 3, "k-state-selected", "k-state-disabled", "mouseenter", 4, "ngFor", "ngForOf"], ["unselectable", "on", 1, "k-status"], [1, "k-ct-cell", 3, "mouseenter"]], template: function PopupTableGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("mouseleave", function PopupTableGridComponent_Template_div_mouseleave_0_listener() { return ctx.resetState(); })("click", function PopupTableGridComponent_Template_div_click_0_listener() { return ctx.insertTable(); });
        ɵngcc0.ɵɵtemplate(1, PopupTableGridComponent_span_1_Template, 1, 4, "span", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.cells);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.message);
    } }, directives: [ɵngcc4.NgForOf], encapsulation: 2 });
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PopupTableGridComponent.prototype, "cellClick", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PopupTableGridComponent.prototype, "tableWizardClick", void 0);

/**
 * @hidden
 */
const commandIcons = {
    alignCenter: 'align-center',
    alignJustify: 'align-justify',
    alignLeft: 'align-left',
    alignRight: 'align-right',
    backColor: 'background',
    bold: 'bold',
    cleanFormatting: 'clear-css',
    createLink: 'link-horizontal',
    foreColor: 'foreground-color',
    indent: 'indent-increase',
    insertFile: 'file-add',
    insertImage: 'image',
    insertOrderedList: 'list-ordered',
    insertUnorderedList: 'list-unordered',
    italic: 'italic',
    outdent: 'indent-decrease',
    print: 'print',
    redo: 'redo',
    selectAll: 'select-all',
    strikethrough: 'strikethrough',
    subscript: 'sub-script',
    superscript: 'sup-script',
    underline: 'underline',
    undo: 'undo',
    unlink: 'unlink-horizontal',
    viewSource: 'html',
    //table
    insertTable: 'table-insert',
    addColumnBefore: 'table-column-insert-left',
    addColumnAfter: 'table-column-insert-right',
    addRowBefore: 'table-row-insert-above',
    addRowAfter: 'table-row-insert-below',
    deleteRow: 'table-row-delete',
    deleteColumn: 'table-column-delete',
    mergeCells: 'cells-merge',
    splitCell: 'cell-split-horizontally',
    deleteTable: 'table-delete'
    // tableWizard: 'table-wizard'
};

/**
 * @hidden
 */
class EditorCommandBase {
    constructor(command, button, editor, localization, toolsService) {
        this.command = command;
        this.button = button;
        this.editor = editor;
        this.localization = localization;
        this.toolsService = toolsService;
        setTimeout(() => {
            const text = this.localization.get(this.command);
            if (text) {
                this.button.showText = 'overflow';
                this.button.showIcon = 'both';
                this.button.text = text;
            }
            if (!this.button.toolbarOptions.icon) {
                this.button.icon = commandIcons[this.command];
            }
            this.button.title = text;
            this.toolsService.needsCheck.next();
        });
    }
    ngOnInit() {
        this.subs = this.editor.stateChange.subscribe(this.onStateChange.bind(this));
        this.subs.add(this.button.click.subscribe((this.clickHandler.bind(this))));
        this.subs.add(this.button.pointerdown.subscribe((this.pointerdownHandler.bind(this))));
    }
    ngOnDestroy() {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
    // tslint:disable-next-line
    clickHandler() { }
    // tslint:disable-next-line
    pointerdownHandler(_event) { }
    // tslint:disable-next-line
    onStateChange(_toolBarState) { }
}
EditorCommandBase.ɵfac = function EditorCommandBase_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
EditorCommandBase.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorCommandBase });

/**
 * @hidden
 */
class EditorCommandButton extends EditorCommandBase {
    constructor(command, button, editor, localization, toolsService) {
        super(command, button, editor, localization, toolsService);
        this.command = command;
        this.button = button;
        this.editor = editor;
        this.localization = localization;
        this.toolsService = toolsService;
    }
    clickHandler() {
        this.editor.exec(this.command, this.editor.applyToWord);
        this.editor.focus();
    }
    pointerdownHandler(e) {
        e.preventDefault();
    }
    onStateChange(toolBarState) {
        this.button.selected = toolBarState[this.command].selected;
        this.button.disabled = toolBarState[this.command].disabled;
    }
}

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor AlignLeft tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAlignLeftButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorAlignLeftButtonDirective = class EditorAlignLeftButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('alignLeft', button, editor, localization, toolsService);
    }
};
EditorAlignLeftButtonDirective.ɵfac = function EditorAlignLeftButtonDirective_Factory(t) { return new (t || EditorAlignLeftButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorAlignLeftButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorAlignLeftButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorAlignLeftButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorAlignLeftButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorAlignLeftButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor AlignCenter tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAlignCenterButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorAlignCenterButtonDirective = class EditorAlignCenterButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('alignCenter', button, editor, localization, toolsService);
    }
};
EditorAlignCenterButtonDirective.ɵfac = function EditorAlignCenterButtonDirective_Factory(t) { return new (t || EditorAlignCenterButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorAlignCenterButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorAlignCenterButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorAlignCenterButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorAlignCenterButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorAlignCenterButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor AlignRight tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAlignRightButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorAlignRightButtonDirective = class EditorAlignRightButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('alignRight', button, editor, localization, toolsService);
    }
};
EditorAlignRightButtonDirective.ɵfac = function EditorAlignRightButtonDirective_Factory(t) { return new (t || EditorAlignRightButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorAlignRightButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorAlignRightButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorAlignRightButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorAlignRightButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorAlignRightButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor AlignJustify tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAlignJustifyButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorAlignJustifyButtonDirective = class EditorAlignJustifyButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('alignJustify', button, editor, localization, toolsService);
    }
};
EditorAlignJustifyButtonDirective.ɵfac = function EditorAlignJustifyButtonDirective_Factory(t) { return new (t || EditorAlignJustifyButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorAlignJustifyButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorAlignJustifyButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorAlignJustifyButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorAlignJustifyButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorAlignJustifyButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Redo tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorRedoButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorRedoButtonDirective = class EditorRedoButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('redo', button, editor, localization, toolsService);
    }
};
EditorRedoButtonDirective.ɵfac = function EditorRedoButtonDirective_Factory(t) { return new (t || EditorRedoButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorRedoButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorRedoButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorRedoButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorRedoButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorRedoButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Undo tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorUndoButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorUndoButtonDirective = class EditorUndoButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('undo', button, editor, localization, toolsService);
    }
};
EditorUndoButtonDirective.ɵfac = function EditorUndoButtonDirective_Factory(t) { return new (t || EditorUndoButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorUndoButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorUndoButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorUndoButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorUndoButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorUndoButtonDirective);

/**
 * @hidden
 */
class EditorCommandDialog extends EditorCommandBase {
    constructor(dialog, button, editor, localization, toolsService) {
        super(dialog, button, editor, localization, toolsService);
        this.dialog = dialog;
        this.button = button;
        this.editor = editor;
        this.localization = localization;
        this.toolsService = toolsService;
    }
    clickHandler() {
        this.editor.openDialog(this.dialog);
    }
    onStateChange(toolBarState) {
        this.button.selected = toolBarState[this.command].selected;
        this.button.disabled = toolBarState[this.command].disabled;
    }
}

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor InsertImage tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorInsertImageButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorInsertImageButtonDirective = class EditorInsertImageButtonDirective extends EditorCommandDialog {
    constructor(button, editor, localization, toolsService) {
        super('insertImage', button, editor, localization, toolsService);
    }
};
EditorInsertImageButtonDirective.ɵfac = function EditorInsertImageButtonDirective_Factory(t) { return new (t || EditorInsertImageButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorInsertImageButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorInsertImageButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorInsertImageButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorInsertImageButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorInsertImageButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Indent tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorIndentButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorIndentButtonDirective = class EditorIndentButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('indent', button, editor, localization, toolsService);
    }
};
EditorIndentButtonDirective.ɵfac = function EditorIndentButtonDirective_Factory(t) { return new (t || EditorIndentButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorIndentButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorIndentButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorIndentButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorIndentButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorIndentButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Outdent tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorOutdentButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorOutdentButtonDirective = class EditorOutdentButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('outdent', button, editor, localization, toolsService);
    }
};
EditorOutdentButtonDirective.ɵfac = function EditorOutdentButtonDirective_Factory(t) { return new (t || EditorOutdentButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorOutdentButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorOutdentButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorOutdentButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorOutdentButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorOutdentButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor CreateLink tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorCreateLinkButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorCreateLinkButtonDirective = class EditorCreateLinkButtonDirective extends EditorCommandDialog {
    constructor(button, editor, localization, toolsService) {
        super('createLink', button, editor, localization, toolsService);
    }
};
EditorCreateLinkButtonDirective.ɵfac = function EditorCreateLinkButtonDirective_Factory(t) { return new (t || EditorCreateLinkButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorCreateLinkButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorCreateLinkButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorCreateLinkButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorCreateLinkButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorCreateLinkButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Unlink tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorUnlinkButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorUnlinkButtonDirective = class EditorUnlinkButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('unlink', button, editor, localization, toolsService);
    }
};
EditorUnlinkButtonDirective.ɵfac = function EditorUnlinkButtonDirective_Factory(t) { return new (t || EditorUnlinkButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorUnlinkButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorUnlinkButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorUnlinkButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorUnlinkButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorUnlinkButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor InsertOrderedList tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorInsertOrderedListButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorInsertOrderedListButtonDirective = class EditorInsertOrderedListButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('insertOrderedList', button, editor, localization, toolsService);
    }
};
EditorInsertOrderedListButtonDirective.ɵfac = function EditorInsertOrderedListButtonDirective_Factory(t) { return new (t || EditorInsertOrderedListButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorInsertOrderedListButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorInsertOrderedListButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorInsertOrderedListButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorInsertOrderedListButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorInsertOrderedListButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor InsertUnorderedList tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorInsertUnorderedListButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorInsertUnorderedListButtonDirective = class EditorInsertUnorderedListButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('insertUnorderedList', button, editor, localization, toolsService);
    }
};
EditorInsertUnorderedListButtonDirective.ɵfac = function EditorInsertUnorderedListButtonDirective_Factory(t) { return new (t || EditorInsertUnorderedListButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorInsertUnorderedListButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorInsertUnorderedListButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorInsertUnorderedListButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorInsertUnorderedListButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorInsertUnorderedListButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor ViewSource tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorViewSourceButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorViewSourceButtonDirective = class EditorViewSourceButtonDirective extends EditorCommandDialog {
    constructor(button, editor, localization, toolsService) {
        super('viewSource', button, editor, localization, toolsService);
    }
};
EditorViewSourceButtonDirective.ɵfac = function EditorViewSourceButtonDirective_Factory(t) { return new (t || EditorViewSourceButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorViewSourceButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorViewSourceButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorViewSourceButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorViewSourceButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorViewSourceButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Bold tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorBoldButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorBoldButtonDirective = class EditorBoldButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('bold', button, editor, localization, toolsService);
    }
};
EditorBoldButtonDirective.ɵfac = function EditorBoldButtonDirective_Factory(t) { return new (t || EditorBoldButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorBoldButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorBoldButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorBoldButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorBoldButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorBoldButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Italic tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorItalicButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorItalicButtonDirective = class EditorItalicButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('italic', button, editor, localization, toolsService);
    }
};
EditorItalicButtonDirective.ɵfac = function EditorItalicButtonDirective_Factory(t) { return new (t || EditorItalicButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorItalicButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorItalicButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorItalicButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorItalicButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorItalicButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Underline tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorUnderlineButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorUnderlineButtonDirective = class EditorUnderlineButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('underline', button, editor, localization, toolsService);
    }
};
EditorUnderlineButtonDirective.ɵfac = function EditorUnderlineButtonDirective_Factory(t) { return new (t || EditorUnderlineButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorUnderlineButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorUnderlineButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorUnderlineButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorUnderlineButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorUnderlineButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Strikethrough tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorStrikethroughButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorStrikethroughButtonDirective = class EditorStrikethroughButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('strikethrough', button, editor, localization, toolsService);
    }
};
EditorStrikethroughButtonDirective.ɵfac = function EditorStrikethroughButtonDirective_Factory(t) { return new (t || EditorStrikethroughButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorStrikethroughButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorStrikethroughButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorStrikethroughButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorStrikethroughButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorStrikethroughButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Subscript tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorSubscriptButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorSubscriptButtonDirective = class EditorSubscriptButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('subscript', button, editor, localization, toolsService);
    }
};
EditorSubscriptButtonDirective.ɵfac = function EditorSubscriptButtonDirective_Factory(t) { return new (t || EditorSubscriptButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorSubscriptButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorSubscriptButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorSubscriptButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorSubscriptButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorSubscriptButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Superscript tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `selected` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorSuperscriptButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorSuperscriptButtonDirective = class EditorSuperscriptButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('superscript', button, editor, localization, toolsService);
    }
};
EditorSuperscriptButtonDirective.ɵfac = function EditorSuperscriptButtonDirective_Factory(t) { return new (t || EditorSuperscriptButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorSuperscriptButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorSuperscriptButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorSuperscriptButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorSuperscriptButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorSuperscriptButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor 'Insert File' tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
 * ```
 */
let EditorInsertFileButtonDirective = class EditorInsertFileButtonDirective extends EditorCommandDialog {
    constructor(button, editor, localization, toolsService) {
        super('insertFile', button, editor, localization, toolsService);
    }
};
EditorInsertFileButtonDirective.ɵfac = function EditorInsertFileButtonDirective_Factory(t) { return new (t || EditorInsertFileButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorInsertFileButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorInsertFileButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorInsertFileButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorInsertFileButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorInsertFileButtonDirective);

/**
 * A directive which configures an `EditorColorPickerComponent`
 * for manipulating the foreground color of the text
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 */
let EditorForeColorDirective = class EditorForeColorDirective {
    constructor(colorPicker) {
        this.colorPicker = colorPicker;
        this.colorPicker.icon = commandIcons.foreColor;
        this.colorPicker.editorCommand = 'foreColor';
    }
};
EditorForeColorDirective.ɵfac = function EditorForeColorDirective_Factory(t) { return new (t || EditorForeColorDirective)(ɵngcc0.ɵɵdirectiveInject(EditorColorPickerComponent)); };
EditorForeColorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorForeColorDirective, selectors: [["", "kendoEditorForeColor", ""]] });
EditorForeColorDirective = __decorate([ __metadata("design:paramtypes", [EditorColorPickerComponent])
], EditorForeColorDirective);

/**
 * A directive which configures an `EditorColorPickerComponent`
 * for manipulating the background color of the text
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 */
let EditorBackColorDirective = class EditorBackColorDirective {
    constructor(colorPicker) {
        this.colorPicker = colorPicker;
        this.colorPicker.icon = commandIcons.backColor;
        this.colorPicker.editorCommand = 'backColor';
    }
};
EditorBackColorDirective.ɵfac = function EditorBackColorDirective_Factory(t) { return new (t || EditorBackColorDirective)(ɵngcc0.ɵɵdirectiveInject(EditorColorPickerComponent)); };
EditorBackColorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorBackColorDirective, selectors: [["", "kendoEditorBackColor", ""]] });
EditorBackColorDirective = __decorate([ __metadata("design:paramtypes", [EditorColorPickerComponent])
], EditorBackColorDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Clean Formatting tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorCleanFormattingButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorCleanFormattingButtonDirective = class EditorCleanFormattingButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('cleanFormatting', button, editor, localization, toolsService);
    }
};
EditorCleanFormattingButtonDirective.ɵfac = function EditorCleanFormattingButtonDirective_Factory(t) { return new (t || EditorCleanFormattingButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorCleanFormattingButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorCleanFormattingButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorCleanFormattingButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorCleanFormattingButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorCleanFormattingButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor AddColumnBefore tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
 * ```
 */
let EditorAddColumnBeforeButtonDirective = class EditorAddColumnBeforeButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('addColumnBefore', button, editor, localization, toolsService);
    }
};
EditorAddColumnBeforeButtonDirective.ɵfac = function EditorAddColumnBeforeButtonDirective_Factory(t) { return new (t || EditorAddColumnBeforeButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorAddColumnBeforeButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorAddColumnBeforeButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorAddColumnBeforeButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorAddColumnBeforeButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorAddColumnBeforeButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor AddColumnAfter tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
 * ```
 */
let EditorAddColumnAfterButtonDirective = class EditorAddColumnAfterButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('addColumnAfter', button, editor, localization, toolsService);
    }
};
EditorAddColumnAfterButtonDirective.ɵfac = function EditorAddColumnAfterButtonDirective_Factory(t) { return new (t || EditorAddColumnAfterButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorAddColumnAfterButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorAddColumnAfterButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorAddColumnAfterButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorAddColumnAfterButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorAddColumnAfterButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor AddRowBefore tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
 * ```
 */
let EditorAddRowBeforeButtonDirective = class EditorAddRowBeforeButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('addRowBefore', button, editor, localization, toolsService);
    }
};
EditorAddRowBeforeButtonDirective.ɵfac = function EditorAddRowBeforeButtonDirective_Factory(t) { return new (t || EditorAddRowBeforeButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorAddRowBeforeButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorAddRowBeforeButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorAddRowBeforeButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorAddRowBeforeButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorAddRowBeforeButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor AddRowAfter tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
 * ```
 */
let EditorAddRowAfterButtonDirective = class EditorAddRowAfterButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('addRowAfter', button, editor, localization, toolsService);
    }
};
EditorAddRowAfterButtonDirective.ɵfac = function EditorAddRowAfterButtonDirective_Factory(t) { return new (t || EditorAddRowAfterButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorAddRowAfterButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorAddRowAfterButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorAddRowAfterButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorAddRowAfterButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorAddRowAfterButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor DeleteColumn tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
 * ```
 */
let EditorDeleteColumnButtonDirective = class EditorDeleteColumnButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('deleteColumn', button, editor, localization, toolsService);
    }
};
EditorDeleteColumnButtonDirective.ɵfac = function EditorDeleteColumnButtonDirective_Factory(t) { return new (t || EditorDeleteColumnButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorDeleteColumnButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorDeleteColumnButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorDeleteColumnButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorDeleteColumnButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorDeleteColumnButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor DeleteRow tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
 * ```
 */
let EditorDeleteRowButtonDirective = class EditorDeleteRowButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('deleteRow', button, editor, localization, toolsService);
    }
};
EditorDeleteRowButtonDirective.ɵfac = function EditorDeleteRowButtonDirective_Factory(t) { return new (t || EditorDeleteRowButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorDeleteRowButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorDeleteRowButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorDeleteRowButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorDeleteRowButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorDeleteRowButtonDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor DeleteTable tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
 * ```
 */
let EditorDeleteTableButtonDirective = class EditorDeleteTableButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('deleteTable', button, editor, localization, toolsService);
    }
};
EditorDeleteTableButtonDirective.ɵfac = function EditorDeleteTableButtonDirective_Factory(t) { return new (t || EditorDeleteTableButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorDeleteTableButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorDeleteTableButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorDeleteTableButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorDeleteTableButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorDeleteTableButtonDirective);

/**
 * @hidden
 *
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor MergeCells tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
 * ```
 */
let EditorMergeCellsButtonDirective = class EditorMergeCellsButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('mergeCells', button, editor, localization, toolsService);
    }
};
EditorMergeCellsButtonDirective.ɵfac = function EditorMergeCellsButtonDirective_Factory(t) { return new (t || EditorMergeCellsButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorMergeCellsButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorMergeCellsButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorMergeCellsButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorMergeCellsButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorMergeCellsButtonDirective);

/**
 * @hidden
 *
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor SplitCell tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 * In addition, the directive updates the `disabled` state of the button according to the cursor position in the editing area.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
 * ```
 */
let EditorSplitCellButtonDirective = class EditorSplitCellButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('splitCell', button, editor, localization, toolsService);
    }
};
EditorSplitCellButtonDirective.ɵfac = function EditorSplitCellButtonDirective_Factory(t) { return new (t || EditorSplitCellButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorSplitCellButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorSplitCellButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorSplitCellButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorSplitCellButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorSplitCellButtonDirective);

/**
 * @hidden
 */
class Messages extends ComponentMessages {
}
Messages.ɵfac = /*@__PURE__*/ function () { let ɵMessages_BaseFactory; return function Messages_Factory(t) { return (ɵMessages_BaseFactory || (ɵMessages_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(Messages)))(t || Messages); }; }();
Messages.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: Messages, inputs: { alignCenter: "alignCenter", alignJustify: "alignJustify", alignLeft: "alignLeft", alignRight: "alignRight", backColor: "backColor", bold: "bold", cleanFormatting: "cleanFormatting", createLink: "createLink", fontFamily: "fontFamily", fontSize: "fontSize", foreColor: "foreColor", format: "format", indent: "indent", insertFile: "insertFile", insertImage: "insertImage", insertOrderedList: "insertOrderedList", insertUnorderedList: "insertUnorderedList", italic: "italic", outdent: "outdent", print: "print", redo: "redo", selectAll: "selectAll", strikethrough: "strikethrough", subscript: "subscript", superscript: "superscript", underline: "underline", undo: "undo", unlink: "unlink", viewSource: "viewSource", insertTable: "insertTable", addColumnBefore: "addColumnBefore", addColumnAfter: "addColumnAfter", addRowBefore: "addRowBefore", addRowAfter: "addRowAfter", deleteColumn: "deleteColumn", deleteRow: "deleteRow", deleteTable: "deleteTable", dialogApply: "dialogApply", dialogCancel: "dialogCancel", dialogInsert: "dialogInsert", dialogUpdate: "dialogUpdate", fileText: "fileText", fileTitle: "fileTitle", fileWebAddress: "fileWebAddress", imageAltText: "imageAltText", imageHeight: "imageHeight", imageWebAddress: "imageWebAddress", imageWidth: "imageWidth", linkOpenInNewWindow: "linkOpenInNewWindow", linkText: "linkText", linkTitle: "linkTitle", linkWebAddress: "linkWebAddress" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "alignCenter", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "alignJustify", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "alignLeft", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "alignRight", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "backColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "bold", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "cleanFormatting", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "createLink", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "fontFamily", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "fontSize", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "foreColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "format", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "indent", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "insertFile", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "insertImage", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "insertOrderedList", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "insertUnorderedList", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "italic", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "outdent", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "print", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "redo", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "selectAll", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "strikethrough", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "subscript", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "superscript", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "underline", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "undo", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "unlink", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "viewSource", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "insertTable", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "addColumnBefore", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "addColumnAfter", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "addRowBefore", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "addRowAfter", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "deleteColumn", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "deleteRow", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "deleteTable", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "dialogApply", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "dialogCancel", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "dialogInsert", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "dialogUpdate", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "fileText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "fileTitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "fileWebAddress", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "imageAltText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "imageHeight", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "imageWebAddress", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "imageWidth", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "linkOpenInNewWindow", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "linkText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "linkTitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], Messages.prototype, "linkWebAddress", void 0);

var LocalizedMessagesDirective_1;
/**
 * @hidden
 */
let LocalizedMessagesDirective = LocalizedMessagesDirective_1 = class LocalizedMessagesDirective extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
};
LocalizedMessagesDirective.ɵfac = function LocalizedMessagesDirective_Factory(t) { return new (t || LocalizedMessagesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LocalizationService)); };
LocalizedMessagesDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: LocalizedMessagesDirective, selectors: [["", "kendoEditorLocalizedMessages", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                // tslint:disable-next-line:no-forward-ref
                useExisting: forwardRef(() => LocalizedMessagesDirective_1)
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
LocalizedMessagesDirective = LocalizedMessagesDirective_1 = __decorate([ __metadata("design:paramtypes", [LocalizationService])
], LocalizedMessagesDirective);

var CustomMessagesComponent_1;
/**
 * Custom component messages override default component messages
 * ([see example]({% slug globalization_editor %}#toc-localization)).
 */
let CustomMessagesComponent = CustomMessagesComponent_1 = class CustomMessagesComponent extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
    get override() {
        return true;
    }
};
CustomMessagesComponent.ɵfac = function CustomMessagesComponent_Factory(t) { return new (t || CustomMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LocalizationService)); };
CustomMessagesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CustomMessagesComponent, selectors: [["kendo-editor-messages"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                // tslint:disable-next-line:no-forward-ref
                useExisting: forwardRef(() => CustomMessagesComponent_1)
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function CustomMessagesComponent_Template(rf, ctx) { }, encapsulation: 2 });
CustomMessagesComponent = CustomMessagesComponent_1 = __decorate([ __metadata("design:paramtypes", [LocalizationService])
], CustomMessagesComponent);

/**
 * @hidden
 */
let DropDownToolDirective = class DropDownToolDirective {
    constructor(hostEl, zone) {
        this.hostEl = hostEl;
        this.zone = zone;
        this.preventDefault = (event) => {
            event.preventDefault();
        };
    }
    ngAfterViewInit() {
        this.zone.runOutsideAngular(() => {
            this.hostEl.nativeElement.addEventListener('pointerdown', this.preventDefault);
        });
    }
    ngOnDestroy() {
        this.hostEl.nativeElement.removeEventListener('pointerdown', this.preventDefault);
    }
};
DropDownToolDirective.ɵfac = function DropDownToolDirective_Factory(t) { return new (t || DropDownToolDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
DropDownToolDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DropDownToolDirective, selectors: [["", "kendoEditorDropDownTool", ""]] });
DropDownToolDirective = __decorate([ __metadata("design:paramtypes", [ElementRef,
        NgZone])
], DropDownToolDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor Print tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 *
 * > The Editor Print tool is supported in the default [`iframe`](https://www.telerik.com/kendo-angular-ui-develop/components/editor/api/EditorComponent/#toc-iframe) mode only.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorPrintButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorPrintDirective = class EditorPrintDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('print', button, editor, localization, toolsService);
        this.editor = editor;
    }
    ngAfterViewInit() {
        if (isDevMode) {
            if (!this.editor.iframe) {
                throw new Error(EditorErrorMessages.printTool);
            }
        }
    }
    clickHandler() {
        if (this.editor.iframe) {
            const view = this.editor.view;
            const dom = view && view.dom;
            const doc = dom && dom.ownerDocument;
            const editorWindow = doc && doc.defaultView;
            if (editorWindow) {
                editorWindow.print();
            }
        }
    }
};
EditorPrintDirective.ɵfac = function EditorPrintDirective_Factory(t) { return new (t || EditorPrintDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorPrintDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorPrintDirective, selectors: [["kendo-toolbar-button", "kendoEditorPrintButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorPrintDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorPrintDirective);

/**
 * A directive which configures an existing `ToolBarButtonComponent` as an Editor SelectAll tool
 * ([see example]({% slug toolbartools_editor %}#toc-built-in-tools)).
 * The directive will predefine the `icon` and `click` event handlers of the button.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
 * ```
 *
 * The following example demonstrates how to change the default icon that is applied by the directive.
 *
 * @example
 * ```ts-no-run
 * <kendo-toolbar-button kendoEditorSelectAllButton icon="blogger"></kendo-toolbar-button>
 * ```
 */
let EditorSelectAllButtonDirective = class EditorSelectAllButtonDirective extends EditorCommandButton {
    constructor(button, editor, localization, toolsService) {
        super('selectAll', button, editor, localization, toolsService);
    }
    clickHandler() {
        this.editor.shouldEmitFocus = true;
        super.clickHandler();
    }
};
EditorSelectAllButtonDirective.ɵfac = function EditorSelectAllButtonDirective_Factory(t) { return new (t || EditorSelectAllButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ToolBarButtonComponent), ɵngcc0.ɵɵdirectiveInject(EditorComponent, 1), ɵngcc0.ɵɵdirectiveInject(EditorLocalizationService), ɵngcc0.ɵɵdirectiveInject(EditorToolsService)); };
EditorSelectAllButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorSelectAllButtonDirective, selectors: [["kendo-toolbar-button", "kendoEditorSelectAllButton", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
EditorSelectAllButtonDirective = __decorate([ __param(1, Host()),
    __metadata("design:paramtypes", [ToolBarButtonComponent,
        EditorComponent,
        EditorLocalizationService,
        EditorToolsService])
], EditorSelectAllButtonDirective);

const COMPONENT_DIRECTIVES = [
    //alignment
    EditorAlignLeftButtonDirective,
    EditorAlignCenterButtonDirective,
    EditorAlignRightButtonDirective,
    EditorAlignJustifyButtonDirective,
    //file
    EditorInsertFileButtonDirective,
    //history
    EditorRedoButtonDirective,
    EditorUndoButtonDirective,
    //image
    EditorInsertImageButtonDirective,
    //indent
    EditorIndentButtonDirective,
    EditorOutdentButtonDirective,
    //link
    EditorCreateLinkButtonDirective,
    EditorUnlinkButtonDirective,
    //list
    EditorInsertOrderedListButtonDirective,
    EditorInsertUnorderedListButtonDirective,
    //source
    EditorViewSourceButtonDirective,
    //typographical emphasis
    EditorBoldButtonDirective,
    EditorItalicButtonDirective,
    EditorUnderlineButtonDirective,
    EditorStrikethroughButtonDirective,
    EditorSubscriptButtonDirective,
    EditorSuperscriptButtonDirective,
    //color
    EditorForeColorDirective,
    EditorBackColorDirective,
    //clear format
    EditorCleanFormattingButtonDirective,
    //table
    EditorAddColumnBeforeButtonDirective,
    EditorAddColumnAfterButtonDirective,
    EditorAddRowBeforeButtonDirective,
    EditorAddRowAfterButtonDirective,
    EditorDeleteColumnButtonDirective,
    EditorDeleteRowButtonDirective,
    EditorDeleteTableButtonDirective,
    EditorMergeCellsButtonDirective,
    EditorSplitCellButtonDirective,
    // EditorTableWizardButtonDirective,
    //localization
    CustomMessagesComponent,
    LocalizedMessagesDirective,
    // dropdown tools
    DropDownToolDirective,
    // print
    EditorPrintDirective,
    // select all
    EditorSelectAllButtonDirective
];
const TOOLBAR_TOOLS = [
    EditorFontSizeComponent,
    EditorFontFamilyComponent,
    EditorFormatComponent,
    EditorColorPickerComponent,
    EditorInsertTableButtonComponent
];
const TOOLBAR_DIALOGS = [
    FileLinkDialogComponent,
    ImageDialogComponent,
    SourceDialogComponent,
    FormatDialogComponent,
    ColorPickerDialogComponent,
    FontFamilyDialogComponent,
    FontSizeDialogComponent,
    InsertTableDialogComponent
    // TableWizardDialogComponent
    // Table Wizard Building Blocks
    // TableSettingsComponent,
    // CellSettingsComponent,
    // AccessibilitySettingsComponent
];
const INTERNAL_COMPONENTS = [
    PopupTableGridComponent,
    FormatDropDownListComponent,
    FontFamilyDropDownListComponent,
    FontSizeDropDownListComponent
];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }}) definition for the Editor component.
 *
 * The package exports:
 * - `EditorComponent`&mdash;The `EditorComponent` class.
 * - `EditorButtonDirective`&mdash;The `EditorButton` directive class.
 * - `EditorDropDownDirective`&mdash;The `EditorDropDown` directive class.
 * - `EditorDialogDirective`&mdash;The `EditorDialog` directive class.
 * - `ToolBarDropDownListComponent`&mdash;The `ToolBarDropDownListComponent` directive class.
 * - `ButtonModule`&mdash;The `KendoButton` module.
 * - `ToolBarModule`&mdash;The `KendoToolBar` module.
 *
 *  * @example
 *
 * ```ts-no-run
 * // Import the Editor module
 * import { EditorModule } from '@progress/kendo-angular-editor';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare the app component
 *     imports:      [BrowserModule, EditorModule], // import the Editor module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
let EditorModule = class EditorModule {
};
EditorModule.ɵfac = function EditorModule_Factory(t) { return new (t || EditorModule)(); };
EditorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: EditorModule });
EditorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            //Kendo UI Angular Modules
            ButtonModule,
            ColorPickerModule,
            DialogModule,
            DropDownsModule,
            NumericTextBoxModule,
            ToolBarModule,
            TextBoxModule
        ], ToolBarModule,
        ButtonModule,
        FormsModule,
        ReactiveFormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SourceDialogComponent, [{
        type: Component,
        args: [{
                styles: [
                    `
            >>> .k-editor-textarea {
                height: 100%;
            }
        `
                ],
                template: `
        <kendo-dialog-titlebar (close)="onCancelAction()">
            {{ textFor('viewSource') }}
        </kendo-dialog-titlebar>
        <textarea [value]="data" #textarea class="k-textarea k-editor-textarea"></textarea>
        <kendo-dialog-actions>
            <button kendoButton (click)="onCancelAction()">{{ textFor('dialogCancel') }}</button>
            <button kendoButton (click)="onConfirmAction()" [primary]="true">{{ textFor('dialogUpdate') }}</button>
        </kendo-dialog-actions>
    `
            }]
    }], function () { return [{ type: ɵngcc1.DialogRef }, { type: EditorLocalizationService }]; }, { editor: [{
            type: Input
        }], textarea: [{
            type: ViewChild,
            args: ['textarea', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImageDialogComponent, [{
        type: Component,
        args: [{
                template: `
        <kendo-dialog-titlebar (close)="onCancelAction()">
            {{ textFor('insertImage') }}
        </kendo-dialog-titlebar>
        <div class="k-editor-dialog">
            <div class="k-editor-dialog k-popup-edit-form k-window-content k-content">
                <div class="k-edit-form-container k-window-content">
                    <div class="k-edit-label">
                        <label [for]="srcInputId">{{ textFor('imageWebAddress') }}</label>
                    </div>
                    <div class="k-edit-field">
                        <input [id]="srcInputId" #srcInput [formControl]="src" type="text" class="k-textbox" />
                    </div>
                    <div class="k-edit-label">
                        <label [for]="altTextInputId">{{ textFor('imageAltText') }}</label>
                    </div>
                    <div class="k-edit-field">
                        <input [id]="altTextInputId" [formControl]="alt" type="text" class="k-textbox" />
                    </div>
                    <div class="k-edit-label">
                        <label [for]="widthInputId">{{ textFor('imageWidth') }}</label>
                    </div>
                    <div class="k-edit-field">
                        <input [id]="widthInputId" [formControl]="width" type="text" class="k-textbox" />
                    </div>
                    <div class="k-edit-label">
                        <label [for]="heightInputId">{{ textFor('imageHeight') }}</label>
                    </div>
                    <div class="k-edit-field">
                        <input [id]="heightInputId" [formControl]="height" type="text" class="k-textbox" />
                    </div>
                </div>
            </div>
        </div>
        <kendo-dialog-actions>
            <button kendoButton (click)="onCancelAction()">{{ textFor('dialogCancel') }}</button>
            <button kendoButton [disabled]="imageData.invalid"
                    (click)="onConfirmAction()" [primary]="true">{{ textFor('dialogInsert') }}</button>
        </kendo-dialog-actions>
    `
            }]
    }], function () { return [{ type: ɵngcc1.DialogRef }, { type: EditorLocalizationService }]; }, { editor: [{
            type: Input
        }], srcInput: [{
            type: ViewChild,
            args: ['srcInput', { read: ElementRef, static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileLinkDialogComponent, [{
        type: Component,
        args: [{
                template: `
        <kendo-dialog-titlebar (close)="onCancelAction()">
            {{ titleText }}
        </kendo-dialog-titlebar>
        <div class="k-editor-dialog">
            <div class="k-editor-dialog k-popup-edit-form k-window-content k-content">
                <div class="k-edit-form-container k-window-content">
                    <form novalidate [formGroup]="linkForm">
                        <div class="k-edit-label">
                            <label (click)="hrefInput.focus()">{{ textForWithPrefix('WebAddress') }}</label>
                        </div>
                        <div class="k-edit-field">
                            <input #hrefInput formControlName="href" type="text" class="k-textbox" />
                        </div>

                        <div class="k-edit-label">
                            <label (click)="textInput.focus()">{{ textForWithPrefix('Text') }}</label>
                        </div>
                        <div class="k-edit-field">
                            <input #textInput formControlName="text" type="text" class="k-textbox" />
                        </div>

                        <div class="k-edit-label">
                            <label (click)="titleInput.focus()">{{ textForWithPrefix('Title') }}</label>
                        </div>
                        <div class="k-edit-field">
                            <input #titleInput formControlName="title" type="text" class="k-textbox" />
                        </div>
                        <ng-container *ngIf="command === 'createLink'">
                            <div class="k-edit-label"></div>
                            <div class="k-edit-field">
                                <input type="checkbox" id="k-target-blank" class="k-checkbox" formControlName="target" />
                                <label class="k-checkbox-label" for="k-target-blank">{{ textForWithPrefix('OpenInNewWindow') }}</label>
                            </div>
                        </ng-container>
                    </form>
                </div>
            </div>
        </div>
        <kendo-dialog-actions>
            <button kendoButton (click)="onCancelAction()">{{ textFor('dialogCancel') }}</button>
            <button kendoButton [disabled]="linkForm.invalid" (click)="onConfirmAction()" [primary]="true">
                {{ textFor('dialogInsert') }}
            </button>
        </kendo-dialog-actions>
    `
            }]
    }], function () { return [{ type: ɵngcc1.DialogRef }, { type: EditorLocalizationService }]; }, { editor: [{
            type: Input
        }], command: [{
            type: Input
        }], hrefInput: [{
            type: ViewChild,
            args: ['hrefInput', { read: ElementRef, static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorToolsService, [{
        type: Injectable
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-editor',
                providers: [
                    EditorLocalizationService,
                    EditorToolsService,
                    {
                        provide: LocalizationService,
                        useExisting: EditorLocalizationService
                    },
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.editor'
                    },
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => EditorComponent_1),
                        multi: true
                    },
                    {
                        provide: KendoInput,
                        useExisting: forwardRef(() => EditorComponent_1)
                    }
                ],
                /* tslint:disable:max-line-length */
                template: `
        <ng-container
            kendoEditorLocalizedMessages
            i18n-alignCenter="kendo.editor.alignCenter|The title of the tool that aligns text in the center."
            alignCenter="Center text"
            i18n-alignJustify="kendo.editor.alignJustify|The title of the tool that justifies text both left and right."
            alignJustify="Justify"
            i18n-alignLeft="kendo.editor.alignLeft|The title of the tool that aligns text on the left."
            alignLeft="Align text left"
            i18n-alignRight="kendo.editor.alignRight|The title of the tool that aligns text on the right."
            alignRight="Align text right"
            i18n-backColor="kendo.editor.backColor|The title of the tool that changes the text background color."
            backColor="Background color"
            i18n-bold="kendo.editor.bold|The title of the tool that makes text bold."
            bold="Bold"
            i18n-cleanFormatting="kendo.editor.cleanFormatting|The title of the Clean Formatting tool."
            cleanFormatting="Clean formatting"
            i18n-createLink="kendo.editor.createLink|The title of the tool that creates hyperlinks."
            createLink="Insert link"
            i18n-dialogApply="kendo.editor.dialogApply|The label of the **Apply** button in all editor dialogs."
            dialogApply="Apply"
            i18n-dialogCancel="kendo.editor.dialogCancel|The label of the **Cancel** button in all editor dialogs."
            dialogCancel="Cancel"
            i18n-dialogInsert="kendo.editor.dialogInsert|The label of the **Insert** button in all editor dialogs."
            dialogInsert="Insert"
            i18n-dialogUpdate="kendo.editor.dialogUpdate|The label of the **Update** button in all editor dialogs."
            dialogUpdate="Update"
            i18n-fileText="kendo.editor.fileText|The caption for the file text in the insertFile dialog."
            fileText="Text"
            i18n-fileTitle="kendo.editor.fileTitle|The caption for the file Title in the insertFile dialog."
            fileTitle="Title"
            i18n-fileWebAddress="kendo.editor.fileWebAddress|The caption for the file URL in the insertFile dialog."
            fileWebAddress="Web address"
            i18n-fontFamily="kendo.editor.fontFamily|The title of the tool that changes the text font."
            fontFamily="Select font family"
            i18n-fontSize="kendo.editor.fontSize|The title of the tool that changes the text size."
            fontSize="Select font size"
            i18n-foreColor="kendo.editor.foreColor|The title of the tool that changes the text color."
            foreColor="Color"
            i18n-format="kendo.editor.format|The title of the tool that lets users choose block formats."
            format="Format"
            i18n-imageAltText="kendo.editor.imageAltText|The caption for the image alternate text in the insertImage dialog."
            imageAltText="Alternate text"
            i18n-imageHeight="kendo.editor.imageHeight|The caption for the image height in the insertImage dialog."
            imageHeight="Height (px)"
            i18n-imageWebAddress="kendo.editor.imageWebAddress|The caption for the image URL in the insertImage dialog."
            imageWebAddress="Web address"
            i18n-imageWidth="kendo.editor.imageWidth|The caption for the image width in the insertImage dialog."
            imageWidth="Width (px)"
            i18n-indent="kendo.editor.indent|The title of the tool that indents the content."
            indent="Indent"
            i18n-insertFile="kendo.editor.insertFile|The title of the tool that inserts links to files."
            insertFile="Insert file"
            i18n-insertImage="kendo.editor.insertImage|The title of the tool that inserts images."
            insertImage="Insert image"
            i18n-insertOrderedList="kendo.editor.insertOrderedList|The title of the tool that inserts an ordered list."
            insertOrderedList="Insert ordered list"
            i18n-insertUnorderedList="kendo.editor.insertUnorderedList|The title of the tool that inserts an unordered list."
            insertUnorderedList="Insert unordered list"
            i18n-italic="kendo.editor.italic|The title of the tool that makes text italicized."
            italic="Italic"
            i18n-linkOpenInNewWindow="kendo.editor.linkOpenInNewWindow|The caption for the checkbox for opening the link in a new window in the createLink dialog."
            linkOpenInNewWindow="Open link in new window"
            i18n-linkText="kendo.editor.linkText|The caption for the link text in the createLink dialog."
            linkText="Text"
            i18n-linkTitle="kendo.editor.linkTitle|The caption for the link title in the createLink dialog."
            linkTitle="Title"
            i18n-linkWebAddress="kendo.editor.linkWebAddress|The caption for the URL in the createLink dialog."
            linkWebAddress="Web address"
            i18n-outdent="kendo.editor.outdent|The title of the tool that outdents the content."
            outdent="Outdent"
            i18n-print="kendo.editor.print|The title of the print tool."
            print="Print"
            i18n-redo="kendo.editor.redo|The title of the tool that undos the last action."
            redo="Redo"
            i18n-selectAll="kendo.editor.selectAll|The title of the tool that selects all content."
            selectAll="Select All"
            i18n-strikethrough="kendo.editor.strikethrough|The title of the tool that strikes through text."
            strikethrough="Strikethrough"
            i18n-subscript="kendo.editor.subscript|The title of the tool that makes text subscript."
            subscript="Subscript"
            i18n-superscript="kendo.editor.superscript|The title of the tool that makes text superscript."
            superscript="Superscript"
            i18n-underline="kendo.editor.underline|The title of the tool that underlines text."
            underline="Underline"
            i18n-unlink="kendo.editor.unlink|The title of the tool that removes hyperlinks."
            unlink="Remove Link"
            i18n-undo="kendo.editor.undo|The title of the tool that undos the last action."
            undo="Undo"
            i18n-viewSource="kendo.editor.viewSource|The title of the tool that shows the editor value as HTML."
            viewSource="View source"
            i18n-insertTable="kendo.editor.insertTable|The title of the tool that inserts table."
            insertTable="Insert Table"
            i18n-addColumnBefore="kendo.editor.addColumnBefore|The title of the tool that adds new column before currently selected column."
            addColumnBefore="Add column before"
            i18n-addColumnAfter="kendo.editor.addColumnAfter|The title of the tool that adds new column after currently selected column."
            addColumnAfter="Add column after"
            i18n-addRowBefore="kendo.editor.addRowBefore|The title of the tool that adds new row before currently selected row."
            addRowBefore="Add row before"
            i18n-addRowAfter="kendo.editor.addRowAfter|The title of the tool that adds new row after currently selected row."
            addRowAfter="Add row after"
            i18n-deleteColumn="kendo.editor.deleteColumn|The title of the tool that deletes a table column."
            deleteColumn="Delete column"
            i18n-deleteRow="kendo.editor.deleteRow|The title of the tool that deletes a table row."
            deleteRow="Delete row"
            i18n-deleteTable="kendo.editor.deleteTable|The title of the tool that deletes a table."
            deleteTable="Delete table"
        >
        </ng-container>

        <ng-content select="kendo-toolbar"></ng-content>
        <kendo-toolbar [overflow]="true" [tabindex]="readonly ? -1 : 0" *ngIf="!userToolBarElement" #defaultToolbar>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
        </kendo-toolbar>

        <div *ngIf="!iframe" #content [attr.dir]="direction" class="k-editor-content"></div>

        <div class="k-editor-content" *ngIf="iframe">
            <iframe #content frameborder="0" class="k-iframe" (load)="iframeOnLoad()"></iframe>
        </div>

        <ng-container #dialogsContainer></ng-container>
    `,
                styles: [
                    `
            >>> .k-editor-content > .ProseMirror {
                height: 100%;
                width: 100%;
                box-sizing: border-box;
                outline: none;
                overflow: auto;
            }

            .k-iframe {
                width: 100%;
                height: 100%;
                display: block;
            }
        `
                ]
            }]
    }], function () { return [{ type: ɵngcc1.DialogService }, { type: ɵngcc5.LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ElementRef }, { type: EditorToolsService }]; }, { iframe: [{
            type: Input
        }], applyToWord: [{
            type: Input
        }], updateInterval: [{
            type: Input
        }], preserveWhitespace: [{
            type: Input
        }], resizable: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], onFocus: [{
            type: Output,
            args: ['focus']
        }], onBlur: [{
            type: Output,
            args: ['blur']
        }], hostClass: [{
            type: HostBinding,
            args: ['class.k-editor']
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], schema: [{
            type: Input
        }], plugins: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], resizableClass: [{
            type: HostBinding,
            args: ['class.k-editor-resizable']
        }], isDisabled: [{
            type: HostBinding,
            args: ['class.k-state-disabled']
        }], isReadonly: [{
            type: HostBinding,
            args: ['class.k-readonly']
        }], isIE: [{
            type: HostBinding,
            args: ['class.k-ie']
        }], dir: [{
            type: HostBinding,
            args: ['attr.dir']
        }], ariaDisabled: [{
            type: HostBinding,
            args: ['attr.ariaDisabled']
        }], minWidth: [{
            type: HostBinding,
            args: ['style.minWidth']
        }], maxWidth: [{
            type: HostBinding,
            args: ['style.maxWidth']
        }], minHeight: [{
            type: HostBinding,
            args: ['style.minHeight']
        }], maxHeight: [{
            type: HostBinding,
            args: ['style.maxHeight']
        }], pasteCleanupSettings: [{
            type: Input
        }], userToolBarComponent: [{
            type: ContentChild,
            args: [ToolBarComponent, { static: false }]
        }], userToolBarElement: [{
            type: ContentChild,
            args: [ToolBarComponent, { read: ElementRef, static: false }]
        }], dialogContainer: [{
            type: ViewChild,
            args: ['dialogsContainer', { read: ViewContainerRef, static: true }]
        }], container: [{
            type: ViewChild,
            args: ['content', { read: ViewContainerRef, static: false }]
        }], defaultToolbar: [{
            type: ViewChild,
            args: ['defaultToolbar', { read: ElementRef, static: false }]
        }], defaultToolbarComponent: [{
            type: ViewChild,
            args: ['defaultToolbar', { read: ToolBarComponent, static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormatDropDownListComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:no-forward-ref
                selector: 'kendo-editor-format-dropdownlist',
                template: `
        <kendo-dropdownlist
            #element
            kendoEditorDropDownTool
            [defaultItem]="defaultItem"
            [textField]="'text'"
            [valueField]="'tag'"
            [data]="data"
            [(value)]="value"
            [valuePrimitive]="true"
            [itemDisabled]="itemDisabled"
            [attr.title]="title"
            [disabled]="disabled"
            [tabindex]="tabindex"
            (valueChange)="onValueChange($event)"
        >
            <ng-template kendoDropDownListItemTemplate let-dataItem>
                <ng-container [ngSwitch]="dataItem.tag">
                    <span *ngSwitchCase="'h1'" style="display: block; font-size: 2em; margin-left: 0; font-weight: bold;">
                        {{ dataItem.text }}
                    </span>

                    <span *ngSwitchCase="'h2'" style="display: block; font-size: 1.5em; margin-left: 0; font-weight: bold;">
                        {{ dataItem.text }}
                    </span>

                    <span *ngSwitchCase="'h3'" style="display: block; font-size: 1.17em; margin-left: 0; font-weight: bold;">
                        {{ dataItem.text }}
                    </span>

                    <span *ngSwitchCase="'h4'" style="display: block; font-size: 1em; margin-left: 0; font-weight: bold;">
                        {{ dataItem.text }}
                    </span>

                    <span *ngSwitchCase="'h5'" style="display: block; font-size: .83em; margin-left: 0; font-weight: bold;">
                        {{ dataItem.text }}
                    </span>

                    <span *ngSwitchCase="'h6'" style="display: block; font-size: .67em; margin-left: 0; font-weight: bold;">
                        {{ dataItem.text }}
                    </span>

                    <span *ngSwitchCase="'p'" style="display: block; margin-left: 0;">
                        {{ dataItem.text }}
                    </span>

                    <span *ngSwitchCase="'blockquote'" style="display: block; margin-left: 0;">
                        {{ dataItem.text }}
                    </span>

                    <span *ngSwitchDefault>{{ dataItem.text }}</span>
                </ng-container>
            </ng-template>
        </kendo-dropdownlist>
    `
            }]
    }], function () { return []; }, { valueChange: [{
            type: Output
        }], data: [{
            type: Input
        }], value: [{
            type: Input
        }], defaultItem: [{
            type: Input
        }], itemDisabled: [{
            type: Input
        }], title: [{
            type: Input
        }], disabled: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], element: [{
            type: ViewChild,
            args: ['element', { static: true }]
        }], dropDownList: [{
            type: ViewChild,
            args: ['element', { read: DropDownListComponent, static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormatDialogComponent, [{
        type: Component,
        args: [{
                template: `
        <kendo-dialog-titlebar (close)="onCancelAction()">
            {{ textFor('format') }}
        </kendo-dialog-titlebar>
        <div class="k-editor-dialog">
            <div class="k-editor-dialog k-popup-edit-form k-window-content k-content">
                <div class="k-edit-form-container k-window-content" style="text-align: center;">
                    <kendo-editor-format-dropdownlist
                        #formatDropDownList
                        [defaultItem]="defaultItem"
                        [data]="data"
                        [(value)]="value"
                        [itemDisabled]="itemDisabled"
                    >
                    </kendo-editor-format-dropdownlist>
                </div>
            </div>
        </div>
        <kendo-dialog-actions>
            <button kendoButton (click)="onCancelAction()">{{ textFor('dialogCancel') }}</button>
            <button kendoButton
                    (click)="onConfirmAction()" [primary]="true">{{ textFor('dialogApply') }}</button>
        </kendo-dialog-actions>
    `
            }]
    }], function () { return [{ type: ɵngcc1.DialogRef }, { type: EditorLocalizationService }]; }, { editor: [{
            type: Input
        }], formatDropDownList: [{
            type: ViewChild,
            args: ['formatDropDownList', { read: FormatDropDownListComponent, static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ColorPickerDialogComponent, [{
        type: Component,
        args: [{
                template: `
        <kendo-dialog-titlebar (close)="onCancelAction()">
            {{ textFor(editorCommand) }}
        </kendo-dialog-titlebar>
        <div class="k-editor-dialog">
            <div class="k-editor-dialog k-popup-edit-form k-window-content k-content">
                <div class="k-edit-form-container k-window-content" style="text-align: center;">
                    <kendo-colorpicker
                        #colorpicker
                        [view]="view"
                        [format]="'hex'"
                        [attr.title]="title"
                        [icon]="icon"
                        [(value)]="value"
                        [paletteSettings]="paletteSettings"
                        (activeColorClick)="handleActiveColorClick($event)"
                    >
                    </kendo-colorpicker>
                </div>
            </div>
        </div>
        <kendo-dialog-actions>
            <button kendoButton (click)="onCancelAction()">{{ textFor('dialogCancel') }}</button>
            <button kendoButton
                    (click)="onConfirmAction()" [primary]="true">{{ textFor('dialogApply') }}</button>
        </kendo-dialog-actions>
    `
            }]
    }], function () { return [{ type: ɵngcc1.DialogRef }, { type: EditorLocalizationService }]; }, { editor: [{
            type: Input
        }], colorPicker: [{
            type: ViewChild,
            args: ['colorpicker', { read: ColorPickerComponent, static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FontFamilyDropDownListComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:no-forward-ref
                selector: 'kendo-editor-fontfamily-dropdownlist',
                template: `
        <kendo-dropdownlist
            #element
            kendoEditorDropDownTool
            [defaultItem]="defaultItem"
            [textField]="'text'"
            [valueField]="'fontName'"
            [data]="data"
            [(value)]="value"
            [valuePrimitive]="true"
            [itemDisabled]="itemDisabled"
            [attr.title]="title"
            [disabled]="disabled"
            [tabindex]="tabindex"
            (valueChange)="onValueChange($event)"
        >
            <ng-template kendoDropDownListItemTemplate let-dataItem>
                <span [ngStyle]="{ 'font-family': dataItem.fontName }">
                    {{ dataItem.text }}
                </span>
            </ng-template>
        </kendo-dropdownlist>
    `
            }]
    }], function () { return []; }, { valueChange: [{
            type: Output
        }], data: [{
            type: Input
        }], value: [{
            type: Input
        }], defaultItem: [{
            type: Input
        }], itemDisabled: [{
            type: Input
        }], title: [{
            type: Input
        }], disabled: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], element: [{
            type: ViewChild,
            args: ['element', { static: true }]
        }], dropDownList: [{
            type: ViewChild,
            args: ['element', { read: DropDownListComponent, static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FontFamilyDialogComponent, [{
        type: Component,
        args: [{
                template: `
        <kendo-dialog-titlebar (close)="onCancelAction()">
            {{ textFor('fontFamily') }}
        </kendo-dialog-titlebar>
        <div class="k-editor-dialog">
            <div class="k-editor-dialog k-popup-edit-form k-window-content k-content">
                <div class="k-edit-form-container k-window-content" style="text-align: center;">
                    <kendo-editor-fontfamily-dropdownlist
                        #fontFamilyDropDownList
                        [defaultItem]="defaultItem"
                        [data]="data"
                        [(value)]="value"
                        [itemDisabled]="itemDisabled"
                    >
                    </kendo-editor-fontfamily-dropdownlist>
                </div>
            </div>
        </div>
        <kendo-dialog-actions>
            <button kendoButton (click)="onCancelAction()">{{ textFor('dialogCancel') }}</button>
            <button kendoButton
                    (click)="onConfirmAction()" [primary]="true">{{ textFor('dialogApply') }}</button>
        </kendo-dialog-actions>
    `
            }]
    }], function () { return [{ type: ɵngcc1.DialogRef }, { type: EditorLocalizationService }]; }, { editor: [{
            type: Input
        }], fontFamilyDropDownList: [{
            type: ViewChild,
            args: ['fontFamilyDropDownList', { read: FontFamilyDropDownListComponent, static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InsertTableDialogComponent, [{
        type: Component,
        args: [{
                template: `
        <kendo-dialog-titlebar (close)="onCancelAction()">
            {{ textFor('insertTable') }}
        </kendo-dialog-titlebar>
        <div class="k-editor-dialog">
            <div class="k-editor-dialog k-popup-edit-form k-window-content k-content">
                <div class="k-ct-popup k-window-content" style="text-align: center;">
                    <kendo-popup-table-grid (cellClick)="onCellClick($event)"></kendo-popup-table-grid>
                </div>
            </div>
        </div>
        <kendo-dialog-actions>
            <button kendoButton (click)="onCancelAction()">{{ textFor('dialogCancel') }}</button>
        </kendo-dialog-actions>
    `
            }]
    }], function () { return [{ type: ɵngcc1.DialogRef }, { type: EditorLocalizationService }]; }, { editor: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorFormatComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:no-forward-ref
                providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => EditorFormatComponent_1) }],
                selector: 'kendo-toolbar-dropdownlist[kendoEditorFormat]',
                template: `
        <ng-template #toolbarTemplate>
            <kendo-editor-format-dropdownlist
                #formatDropDownList
                [defaultItem]="defaultItem"
                [data]="data"
                [(value)]="value"
                [itemDisabled]="itemDisabled"
                [title]="title"
                [disabled]="disabled"
                [tabindex]="tabindex"
                (valueChange)="onValueChange($event)"
            >
            </kendo-editor-format-dropdownlist>
        </ng-template>
        <ng-template #popupTemplate>
            <button
                #formatButton
                [tabindex]="tabindex"
                type="button"
                kendoButton
                class="k-overflow-button"
                [icon]="'apply-format'"
                [attr.title]="title"
                [disabled]="disabled"
                [tabindex]="tabindex"
                (click)="openDialog()"
            >
                {{ title }}
            </button>
        </ng-template>
    `
            }]
    }], function () { return [{ type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: ɵngcc1.DialogService }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, { valueChange: [{
            type: Output
        }], data: [{
            type: Input
        }], toolbarTemplate: [{
            type: ViewChild,
            args: ['toolbarTemplate', { static: true }]
        }], popupTemplate: [{
            type: ViewChild,
            args: ['popupTemplate', { static: true }]
        }], formatDropDownList: [{
            type: ViewChild,
            args: ['formatDropDownList', { static: false }]
        }], formatButton: [{
            type: ViewChild,
            args: ['formatButton', { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FontSizeDropDownListComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:no-forward-ref
                selector: 'kendo-editor-fontsize-dropdownlist',
                template: `
        <kendo-dropdownlist
            #element
            kendoEditorDropDownTool
            [defaultItem]="defaultItem"
            [textField]="'text'"
            [valueField]="'size'"
            [data]="data"
            [(value)]="value"
            [valuePrimitive]="true"
            [itemDisabled]="itemDisabled"
            [attr.title]="title"
            [disabled]="disabled"
            [tabindex]="tabindex"
            (valueChange)="onValueChange($event)"
        >
        </kendo-dropdownlist>
    `
            }]
    }], function () { return []; }, { valueChange: [{
            type: Output
        }], data: [{
            type: Input
        }], value: [{
            type: Input
        }], defaultItem: [{
            type: Input
        }], itemDisabled: [{
            type: Input
        }], title: [{
            type: Input
        }], disabled: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], element: [{
            type: ViewChild,
            args: ['element', { static: true }]
        }], dropDownList: [{
            type: ViewChild,
            args: ['element', { read: DropDownListComponent, static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FontSizeDialogComponent, [{
        type: Component,
        args: [{
                template: `
        <kendo-dialog-titlebar (close)="onCancelAction()">
            {{ textFor('fontSize') }}
        </kendo-dialog-titlebar>
        <div class="k-editor-dialog">
            <div class="k-editor-dialog k-popup-edit-form k-window-content k-content">
                <div class="k-edit-form-container k-window-content" style="text-align: center;">
                    <kendo-editor-fontsize-dropdownlist
                        #fontSizeDropDownList
                        [defaultItem]="defaultItem"
                        [data]="data"
                        [(value)]="value"
                        [itemDisabled]="itemDisabled"
                    >
                    </kendo-editor-fontsize-dropdownlist>
                </div>
            </div>
        </div>
        <kendo-dialog-actions>
            <button kendoButton (click)="onCancelAction()">{{ textFor('dialogCancel') }}</button>
            <button kendoButton
                    (click)="onConfirmAction()" [primary]="true">{{ textFor('dialogApply') }}</button>
        </kendo-dialog-actions>
    `
            }]
    }], function () { return [{ type: ɵngcc1.DialogRef }, { type: EditorLocalizationService }]; }, { editor: [{
            type: Input
        }], fontSizeDropDownList: [{
            type: ViewChild,
            args: ['fontSizeDropDownList', { read: FontSizeDropDownListComponent, static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorFontSizeComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:no-forward-ref
                providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => EditorFontSizeComponent_1) }],
                selector: 'kendo-toolbar-dropdownlist[kendoEditorFontSize]',
                template: `
        <ng-template #toolbarTemplate>
            <kendo-editor-fontsize-dropdownlist
                #element
                [defaultItem]="defaultItem"
                [data]="data"
                [(value)]="value"
                [itemDisabled]="itemDisabled"
                [title]="title"
                [disabled]="disabled"
                [tabindex]="tabindex"
                (valueChange)="onValueChange($event)"
            >
            </kendo-editor-fontsize-dropdownlist>
        </ng-template>
        <ng-template #popupTemplate>
            <button
                tabindex="-1"
                type="button"
                kendoButton
                #fontSizeButton
                class="k-overflow-button"
                [icon]="'font-size'"
                [attr.title]="title"
                [disabled]="disabled"
                [tabindex]="tabindex"
                (click)="openDialog()"
            >
                {{ title }}
            </button>
        </ng-template>
    `
            }]
    }], function () { return [{ type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: ɵngcc1.DialogService }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, { valueChange: [{
            type: Output
        }], data: [{
            type: Input
        }], toolbarTemplate: [{
            type: ViewChild,
            args: ['toolbarTemplate', { static: true }]
        }], popupTemplate: [{
            type: ViewChild,
            args: ['popupTemplate', { static: true }]
        }], element: [{
            type: ViewChild,
            args: ['element', { static: false }]
        }], fontSizeDropDownList: [{
            type: ViewChild,
            args: ['element', { read: FontSizeDropDownListComponent, static: false }]
        }], fontSizeButton: [{
            type: ViewChild,
            args: ['fontSizeButton', { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorFontFamilyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:no-forward-ref
                providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => EditorFontFamilyComponent_1) }],
                selector: 'kendo-toolbar-dropdownlist[kendoEditorFontFamily]',
                template: `
        <ng-template #toolbarTemplate>
            <kendo-editor-fontfamily-dropdownlist
                #element
                [defaultItem]="defaultItem"
                [data]="data"
                [(value)]="value"
                [itemDisabled]="itemDisabled"
                [title]="title"
                [disabled]="disabled"
                [tabindex]="tabindex"
                (valueChange)="onValueChange($event)"
            >
            </kendo-editor-fontfamily-dropdownlist>
        </ng-template>
        <ng-template #popupTemplate>
            <button
                tabindex="-1"
                type="button"
                kendoButton
                #fontFamilyButton
                class="k-overflow-button"
                [icon]="'font-family'"
                [attr.title]="title"
                [disabled]="disabled"
                [tabindex]="tabindex"
                (click)="openDialog()"
            >
                {{ title }}
            </button>
        </ng-template>
    `
            }]
    }], function () { return [{ type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: ɵngcc1.DialogService }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, { valueChange: [{
            type: Output
        }], data: [{
            type: Input
        }], toolbarTemplate: [{
            type: ViewChild,
            args: ['toolbarTemplate', { static: true }]
        }], popupTemplate: [{
            type: ViewChild,
            args: ['popupTemplate', { static: true }]
        }], element: [{
            type: ViewChild,
            args: ['element', { static: false }]
        }], fontFamilyDropDownList: [{
            type: ViewChild,
            args: ['element', { read: FontFamilyDropDownListComponent, static: false }]
        }], fontFamilyButton: [{
            type: ViewChild,
            args: ['fontFamilyButton', { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorColorPickerComponent, [{
        type: Component,
        args: [{
                providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => EditorColorPickerComponent_1) }],
                selector: 'kendo-toolbar-colorpicker',
                template: `
        <ng-template #toolbarTemplate>
            <kendo-colorpicker
                #colorpicker
                [view]="view"
                [format]="'hex'"
                [attr.title]="title"
                [icon]="icon"
                [value]="value"
                [paletteSettings]="paletteSettings"
                [disabled]="disabled"
                [tabindex]="tabindex"
                (valueChange)="handleValueChange($event)"
                (activeColorClick)="handleActiveColorClick($event)"
                (open)="onOpen(colorpicker)"
                (close)="onClose(colorpicker)"
            >
            </kendo-colorpicker>
        </ng-template>
        <ng-template #popupTemplate>
            <button
                tabindex="-1"
                type="button"
                kendoButton
                #colorPickerButton
                class="k-overflow-button"
                [icon]="icon"
                [attr.title]="title"
                [disabled]="disabled"
                [tabindex]="tabindex"
                (click)="openDialog()"
            >
                {{ title }}
            </button>
        </ng-template>
    `
            }]
    }], function () { return [{ type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: ɵngcc1.DialogService }, { type: ɵngcc0.NgZone }]; }, { disabled: [{
            type: Input
        }], view: [{
            type: Input
        }], value: [{
            type: Input
        }], icon: [{
            type: Input
        }], paletteSettings: [{
            type: Input
        }], editorCommand: [{
            type: Input
        }], toolbarTemplate: [{
            type: ViewChild,
            args: ['toolbarTemplate', { static: true }]
        }], popupTemplate: [{
            type: ViewChild,
            args: ['popupTemplate', { static: true }]
        }], element: [{
            type: ViewChild,
            args: ['colorpicker', { read: ElementRef, static: false }]
        }], colorPicker: [{
            type: ViewChild,
            args: ['colorpicker', { read: ColorPickerComponent, static: false }]
        }], colorPickerButton: [{
            type: ViewChild,
            args: ['colorPickerButton', { read: ElementRef, static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorInsertTableButtonComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:no-forward-ref
                providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => EditorInsertTableButtonComponent_1) }],
                selector: 'kendo-editor-insert-table-button',
                template: `
        <ng-template #toolbarTemplate>
            <button
                type="button"
                kendoButton
                #element
                [attr.title]="title"
                [attr.tabindex]="tabIndex"
                [icon]="'table-insert'"
                [disabled]="disabled"
                (click)="toggle()"
                (blur)="onBlur()"
            ></button>
        </ng-template>
        <ng-template #popupTemplate>
            <button
                kendoButton
                #overflowElement
                [attr.title]="title"
                [attr.tabindex]="tabIndex"
                [icon]="'table-insert'"
                [disabled]="disabled"
                (click)="openDialog()">
                {{ title }}
            </button>
        </ng-template>
        <ng-template #popupGridTemplate>
            <kendo-popup-table-grid (cellClick)="onCellClick($event)" (tableWizardClick)="onTableWizardClick()"></kendo-popup-table-grid>
        </ng-template>
    `
            }]
    }], function () { return [{ type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: ɵngcc9.PopupService }, { type: ɵngcc1.DialogService }]; }, { toolbarTemplate: [{
            type: ViewChild,
            args: ['toolbarTemplate', { static: true }]
        }], popupTemplate: [{
            type: ViewChild,
            args: ['popupTemplate', { static: false }]
        }], element: [{
            type: ViewChild,
            args: ['element', { static: false }]
        }], overflowElement: [{
            type: ViewChild,
            args: ['overflowElement', { static: false }]
        }], popupGridTemplate: [{
            type: ViewChild,
            args: ['popupGridTemplate', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopupTableGridComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-popup-table-grid',
                template: `
        <div style="border-color: inherit;" (mouseleave)="resetState()" (click)="insertTable()">
            <span *ngFor="let i of cells"
                class="k-ct-cell"
                [class.k-state-selected]="selected(i)"
                [class.k-state-disabled]="!selected(i)"
                (mouseenter)="setState(i)">
            </span>
        </div>
        <div class="k-status" unselectable="on">{{ message }}</div>
        <!-- uncomment when TableWizard is completed
        <div class="k-editor-toolbar" unselectable="on">
            <button type="button" kendoButton class="k-tool" [icon]="'table-wizard'" (click)="openTableWizard()" title="Table Wizard">Table Wizard</button>
        </div>
        -->
    `
            }]
    }], function () { return []; }, { cellClick: [{
            type: Output
        }], tableWizardClick: [{
            type: Output
        }] }); })();

(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorAlignLeftButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorAlignLeftButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorAlignCenterButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorAlignCenterButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorAlignRightButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorAlignRightButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorAlignJustifyButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorAlignJustifyButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorRedoButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorRedoButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorUndoButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorUndoButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorInsertImageButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorInsertImageButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorIndentButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorIndentButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorOutdentButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorOutdentButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorCreateLinkButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorCreateLinkButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorUnlinkButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorUnlinkButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorInsertOrderedListButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorInsertOrderedListButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorInsertUnorderedListButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorInsertUnorderedListButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorViewSourceButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorViewSourceButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorBoldButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorBoldButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorItalicButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorItalicButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorUnderlineButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorUnderlineButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorStrikethroughButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorStrikethroughButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorSubscriptButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorSubscriptButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorSuperscriptButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorSuperscriptButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorInsertFileButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorInsertFileButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorForeColorDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoEditorForeColor]'
            }]
    }], function () { return [{ type: EditorColorPickerComponent }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorBackColorDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoEditorBackColor]'
            }]
    }], function () { return [{ type: EditorColorPickerComponent }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorCleanFormattingButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorCleanFormattingButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorAddColumnBeforeButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorAddColumnBeforeButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorAddColumnAfterButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorAddColumnAfterButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorAddRowBeforeButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorAddRowBeforeButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorAddRowAfterButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorAddRowAfterButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorDeleteColumnButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorDeleteColumnButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorDeleteRowButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorDeleteRowButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorDeleteTableButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorDeleteTableButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorMergeCellsButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorMergeCellsButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorSplitCellButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorSplitCellButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();

(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalizedMessagesDirective, [{
        type: Directive,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: forwardRef(() => LocalizedMessagesDirective_1)
                    }
                ],
                selector: '[kendoEditorLocalizedMessages]'
            }]
    }], function () { return [{ type: ɵngcc5.LocalizationService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomMessagesComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        // tslint:disable-next-line:no-forward-ref
                        useExisting: forwardRef(() => CustomMessagesComponent_1)
                    }
                ],
                selector: 'kendo-editor-messages',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc5.LocalizationService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropDownToolDirective, [{
        type: Directive,
        args: [{ selector: '[kendoEditorDropDownTool]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorPrintDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorPrintButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorSelectAllButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'kendo-toolbar-button[kendoEditorSelectAllButton]'
            }]
    }], function () { return [{ type: ɵngcc6.ToolBarButtonComponent }, { type: EditorComponent, decorators: [{
                type: Host
            }] }, { type: EditorLocalizationService }, { type: EditorToolsService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    EditorComponent,
                    COMPONENT_DIRECTIVES,
                    TOOLBAR_TOOLS,
                    TOOLBAR_DIALOGS,
                    INTERNAL_COMPONENTS
                ],
                entryComponents: [
                    TOOLBAR_DIALOGS
                ],
                exports: [
                    EditorComponent,
                    COMPONENT_DIRECTIVES,
                    TOOLBAR_TOOLS,
                    ToolBarModule,
                    ButtonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    //needed for unit tests
                    INTERNAL_COMPONENTS
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    //Kendo UI Angular Modules
                    ButtonModule,
                    ColorPickerModule,
                    DialogModule,
                    DropDownsModule,
                    NumericTextBoxModule,
                    ToolBarModule,
                    TextBoxModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EditorModule, { declarations: function () { return [EditorComponent, EditorAlignLeftButtonDirective, EditorAlignCenterButtonDirective, EditorAlignRightButtonDirective, EditorAlignJustifyButtonDirective, EditorInsertFileButtonDirective, EditorRedoButtonDirective, EditorUndoButtonDirective, EditorInsertImageButtonDirective, EditorIndentButtonDirective, EditorOutdentButtonDirective, EditorCreateLinkButtonDirective, EditorUnlinkButtonDirective, EditorInsertOrderedListButtonDirective, EditorInsertUnorderedListButtonDirective, EditorViewSourceButtonDirective, EditorBoldButtonDirective, EditorItalicButtonDirective, EditorUnderlineButtonDirective, EditorStrikethroughButtonDirective, EditorSubscriptButtonDirective, EditorSuperscriptButtonDirective, EditorForeColorDirective, EditorBackColorDirective, EditorCleanFormattingButtonDirective, EditorAddColumnBeforeButtonDirective, EditorAddColumnAfterButtonDirective, EditorAddRowBeforeButtonDirective, EditorAddRowAfterButtonDirective, EditorDeleteColumnButtonDirective, EditorDeleteRowButtonDirective, EditorDeleteTableButtonDirective, EditorMergeCellsButtonDirective, EditorSplitCellButtonDirective, CustomMessagesComponent, LocalizedMessagesDirective, DropDownToolDirective, EditorPrintDirective, EditorSelectAllButtonDirective, EditorFontSizeComponent, EditorFontFamilyComponent, EditorFormatComponent, EditorColorPickerComponent, EditorInsertTableButtonComponent, FileLinkDialogComponent, ImageDialogComponent, SourceDialogComponent, FormatDialogComponent, ColorPickerDialogComponent, FontFamilyDialogComponent, FontSizeDialogComponent, InsertTableDialogComponent, PopupTableGridComponent, FormatDropDownListComponent, FontFamilyDropDownListComponent, FontSizeDropDownListComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        //Kendo UI Angular Modules
        ButtonModule,
        ColorPickerModule,
        DialogModule,
        DropDownsModule,
        NumericTextBoxModule,
        ToolBarModule,
        TextBoxModule]; }, exports: function () { return [EditorComponent, EditorAlignLeftButtonDirective, EditorAlignCenterButtonDirective, EditorAlignRightButtonDirective, EditorAlignJustifyButtonDirective, EditorInsertFileButtonDirective, EditorRedoButtonDirective, EditorUndoButtonDirective, EditorInsertImageButtonDirective, EditorIndentButtonDirective, EditorOutdentButtonDirective, EditorCreateLinkButtonDirective, EditorUnlinkButtonDirective, EditorInsertOrderedListButtonDirective, EditorInsertUnorderedListButtonDirective, EditorViewSourceButtonDirective, EditorBoldButtonDirective, EditorItalicButtonDirective, EditorUnderlineButtonDirective, EditorStrikethroughButtonDirective, EditorSubscriptButtonDirective, EditorSuperscriptButtonDirective, EditorForeColorDirective, EditorBackColorDirective, EditorCleanFormattingButtonDirective, EditorAddColumnBeforeButtonDirective, EditorAddColumnAfterButtonDirective, EditorAddRowBeforeButtonDirective, EditorAddRowAfterButtonDirective, EditorDeleteColumnButtonDirective, EditorDeleteRowButtonDirective, EditorDeleteTableButtonDirective, EditorMergeCellsButtonDirective, EditorSplitCellButtonDirective, CustomMessagesComponent, LocalizedMessagesDirective, DropDownToolDirective, EditorPrintDirective, EditorSelectAllButtonDirective, EditorFontSizeComponent, EditorFontFamilyComponent, EditorFormatComponent, EditorColorPickerComponent, EditorInsertTableButtonComponent, ToolBarModule,
        ButtonModule,
        FormsModule,
        ReactiveFormsModule, PopupTableGridComponent, FormatDropDownListComponent, FontFamilyDropDownListComponent, FontSizeDropDownListComponent]; } }); })();


/**
 * Generated bundle index. Do not edit.
 */

export { ColorPickerDialogComponent, FileLinkDialogComponent, FontFamilyDialogComponent, FontSizeDialogComponent, FormatDialogComponent, ImageDialogComponent, InsertTableDialogComponent, SourceDialogComponent, CustomMessagesComponent, EditorLocalizationService, LocalizedMessagesDirective, Messages, EditorAlignCenterButtonDirective, EditorAlignJustifyButtonDirective, EditorAlignLeftButtonDirective, EditorAlignRightButtonDirective, EditorBackColorDirective, EditorColorPickerComponent, EditorForeColorDirective, EditorCleanFormattingButtonDirective, FontFamilyDropDownListComponent, EditorFontFamilyComponent, FontSizeDropDownListComponent, EditorFontSizeComponent, FormatDropDownListComponent, EditorFormatComponent, EditorRedoButtonDirective, EditorUndoButtonDirective, EditorInsertImageButtonDirective, EditorIndentButtonDirective, EditorOutdentButtonDirective, EditorCreateLinkButtonDirective, EditorInsertFileButtonDirective, EditorUnlinkButtonDirective, EditorInsertOrderedListButtonDirective, EditorInsertUnorderedListButtonDirective, EditorPrintDirective, EditorSelectAllButtonDirective, DropDownToolDirective, EditorCommandBase, EditorCommandButton, EditorCommandDialog, EditorViewSourceButtonDirective, EditorAddColumnAfterButtonDirective, EditorAddColumnBeforeButtonDirective, EditorAddRowAfterButtonDirective, EditorAddRowBeforeButtonDirective, EditorDeleteColumnButtonDirective, EditorDeleteRowButtonDirective, EditorDeleteTableButtonDirective, EditorInsertTableButtonComponent, EditorMergeCellsButtonDirective, EditorSplitCellButtonDirective, PopupTableGridComponent, EditorToolsService, EditorBoldButtonDirective, EditorItalicButtonDirective, EditorStrikethroughButtonDirective, EditorSubscriptButtonDirective, EditorSuperscriptButtonDirective, EditorUnderlineButtonDirective, EditorComponent, EditorModule, schema };

